$(document).ready(function() {
    $('#mbtiretr').show();
     setupTire();
     $(document).on('change', 'select:not(#mbtire), input', function(){
        //console.log(data);
       setupTire();
     });
     $(document).on('change', 'select, input', function(){
         var wheel_type = document.querySelector('#wheel_type').value;
         var rear_name =  ['Rear', 'REAR'];
         if(rear_name.includes(wheel_type)){
             // document.querySelector('.sprocket').style.display = 'block';
             
             // Rear
         }else{
             // document.querySelector('.sprocket').style.display = 'none';
             //Front
         }
     });
     function setupTire() {
         var selected_to = document.getElementById("mbtire").value;
         //// console.log(`Selected TO: ${selected_to}`)
         var rim_size = $('#rim_size').val();
         var bike_model = $('#bike_model option:selected').text();		
         var tire_options = [];
 
         // Extract only the numeric part of rim size (e.g. "18x2.15" => "2.15")
         rim_size = rim_size.split(' ')[1] || rim_size;
 
         // List of specific bike models that have exceptions for 110 tires
         var specific_bike_models = [
             'WR250R', 'CRF250L', 'CRF250L RALLY', 'CRF250L RALLY ABS', 'CRF250L Rally ABS',
             'CRF250L ABS', 'CRF300L', 'CRF300L ABS', 'CRF300L Rally', 'CRF300L RALLY ABS', 'CRF300L Rally ABS', 
         ];

         // List of specific bike models that have exceptions for big 17x5.00 160 tires
         var specific_largetire_bike_models = [
            '690 Enduro', '690 R', '790 Adventure', '790 Adventure R', '890 Adventure', '890 Adventure R', '1090 Adventure R', '1190 Adventure', '1290 Adventure', '1290 Super Adventure R', '1290 Super Adventure S',
            ];
 
         // Check conditions for rim sizes and bike models
         if (rim_size === '17x3.50') {
             if (specific_bike_models.includes(bike_model)) {
                 // Specific bikes with Dunlop Sportmax GPR-300 110/70ZR17 and MICHELIN 2CT 110/70ZR17
                 tire_options = [
                     'Bridgestone Battlax Hypersport S22 110/70-17',
                     'Continental ContiAttack SM2 110/70-17',
                     'Dunlop Sportmax Q5A 110/70-17', // Q5S
                     'Dunlop Sportmax GPR-300 110/70ZR17',
                     'Michelin Pilot Power 2CT 110/70ZR17'
                 ];
             } else {
                 // All other bikes with 17x3.50 rim size
                 tire_options = [
                     'Bridgestone Battlax Hypersport S22 120/70-17',
                     'Continental ContiAttack SM2 120/70-17',
                     'Dunlop Sportmax Q5A 120/70-17', // Q5S
                     'Dunlop Sportmax GPR-300 120/70ZR17',
                     'Michelin Pilot Power 2CT 120/70R17',
                     'Michelin Power 5 120/70R17'
                 ];
             }
         } else if (rim_size === '17x4.25' ) {
             // Tires for 17x4.25
             if (specific_bike_models.includes(bike_model)) {
                // Specific bikes with Dunlop Sportmax GPR-300 110/70ZR17 and MICHELIN 2CT 110/70ZR17
                tire_options = [
                    'Bridgestone Battlax Hypersport S22 150/60-17',
                    'Continental ContiAttack SM2 150/60-17',
                    'Dunlop Sportmax Q5A 150/60-17', // Q5S
                    'Dunlop Sportmax GPR-300 150/60ZR17',
                    'Michelin Pilot Power 2CT 150/60R17',
                ];
              }  else {
             tire_options = [
                 'Bridgestone Battlax Hypersport S22 150/60-17',
                 'Continental ContiAttack SM2 150/60-17',
                 'Dunlop Sportmax Q5A 150/60-17', // Q5S
                 'Dunlop Sportmax GPR-300 150/60ZR17',
                 'Michelin Pilot Power 2CT 150/60R17',
                 'Michelin Pilot Power 2CT 160/60R17'
             ];
            }
         }
         else if (rim_size === '17x5.00') {
            if (specific_largetire_bike_models.includes(bike_model)) {
                // Specific bikes that will fit a larger 160 sized tire
                tire_options = [
                    'Bridgestone Battlax Hypersport S22 150/60-17',
                    'Bridgestone Battlax Hypersport S22 160/60-17',
                    'Continental ContiAttack SM2 150/60-17',
                    'Continental ContiAttack SM2 160/60-17',
                    'Dunlop Sportmax GPR-300 150/60ZR17',
                    'Dunlop Sportmax Q5A 150/60-17', // Q5S
                    //'Dunlop Sportmax Q5 160/60-17', // Q5S
                    'Michelin Pilot Power 2CT 150/60R17',
                    'Michelin Pilot Power 2CT 160/60R17',
                    'Michelin Power 5 160/60ZR17'
                ];
            } else {
            // All other bikes with 17x5.00 rim size
             tire_options = [
                 'Bridgestone Battlax Hypersport S22 150/60-17',
                 'Continental ContiAttack SM2 150/60-17',
                 'Dunlop Sportmax GPR-300 150/60ZR17',
                 'Dunlop Sportmax Q5A 150/60-17', // Q5S
                 'Michelin Pilot Power 2CT 150/60R17',
                 'Michelin Pilot Power 2CT 160/60R17',
                 'Michelin Power 5 160/60ZR17'
             ];
         }
         }
 
         // Update the select element with available tire options
         var selectElement = document.getElementById("mbtire");
         selectElement.innerHTML = '<option class="category" value="mbno">No</option>';
 
         tire_options.forEach(function (tireOption) {
             //// console.log(`TO: ${tireOption}`)
             var option = document.createElement("option");
             option.value = tireOption;
             option.text = tireOption;
             if (tireOption == selected_to) {
                 option.selected = true;
             }
             selectElement.add(option);
         });
 
         //// console.log('Tire options:', tire_options);
     }

     /* REAR rims for KTM ADV (790/890, 1090, 1190, and 1290) */
    $(document).on('change', 'select#wheel_type, select#bike_make, select#bike_model', function () {
        const wheelType = $('#wheel_type').val() || "";
        const bikeMake = $('#bike_make').val() || "";
        const bikeModel = $('#bike_model').val() || "";
        
        const option = $('#rim_size option[value="REAR 17x4.25"]');

        const restrictedModels = [
            '790 Adventure *REAR*',
            '790 Adventure R *REAR*',
            '890 Adventure *REAR*',
            '890 Adventure R *REAR*',
            '1090 Adventure R *REAR*',
            '1190 Adventure *REAR*',
            '1290 Adventure *REAR*',
            '1290 Super Adventure R *REAR*',
            '1290 Super Adventure S *REAR*'
        ];

        const shouldHide = (
            wheelType.toUpperCase() === 'REAR' &&
            bikeMake === 'KTM' &&
            restrictedModels.includes(bikeModel)
        );

        if (shouldHide) {
            option.prop('disabled', true).hide();

            // If user had selected it → auto change to first valid option
            if (option.is(':selected')) {
                $('#rim_size').val($('#rim_size option:not(:disabled)').first().val());
            }

            console.log("⛔ REAR 17x4.25 hidden for this model");
        } else {
            // Restore original state
            option.prop('disabled', false).show();
            console.log("✅ REAR 17x4.25 restored");
        }
    });

 
     function setupCush(){
         if(document.querySelector("#wheel_type").value == "REAR"){
             var selected_rim_size = document.querySelector('#rim_size').value.replaceAll('X','x').replaceAll(' ','')
             if(selected_rim_size.includes('17x4.25') || selected_rim_size.includes('17x5.00')){
                 var make = document.querySelector('#bike_make').value;
                 var current_value = document.getElementById("cush_drive").value;
                 var select = $('#cush_drive');
     
                 var options = `<option class="category" value="unavailable">Standard</option>`;
                 var has_cush = false;
                 switch (make) {
                     case 'Stark':						
                         if(current_value == "unavailable"){
                             options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                         }else{
                             options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                         }
                         has_cush = true;
                         break;
                     case 'Alta Redshift':
                         if(current_value == "unavailable"){
                             options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                         }else{
                             options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                         }
                         has_cush = true;
                         break;
     
                     case 'BMW':
                         if(document.querySelector('#bike_model').value.includes('450X')){
                             if(current_value == "unavailable"){
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             }else{
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'Beta':
                         if(document.querySelector('#bike_model').value.includes('RR') || document.querySelector('#bike_model').value.includes('RS')){
                             if(current_value == "unavailable"){
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             }else{
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'GasGas':
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
 
                         if(selectedOptionText == "ES500"){
                                 if (current_value == "unavailable") {
                                     options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                 } else {
                                     options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                 }
                                 has_cush = true;
                         }
                         else if(selectedOptionText == 'EC200' || selectedOptionText =='EC250' || selectedOptionText =='EC300' ){
                             var selected_year = document.querySelector('#bike_year').value;
                             if(selectedOptionText == 'EC200'){
                                 // Check year 2020-2025
                                 if(selected_year >= 2020 && selected_year <= 2025){
                                     if(current_value == "unavailable"){
                                         options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                     }else{
                                         options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                     }
                                     has_cush = true;
     
                                 }
                             }else if(selectedOptionText == 'EC250'){
                                 // Check Year 2020-2025
                                 if(selected_year >= 2020 && selected_year <= 2025){
                                     if(current_value == "unavailable"){
                                         options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                     }else{
                                         options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                     }
                                     has_cush = true;
     
                                 }
                             }else{
                                 // Check Year 2020-2025
                                 if(selected_year >= 2020 && selected_year <= 2025){
                                     if(current_value == "unavailable"){
                                         options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                     }else{
                                         options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                     }
                                     has_cush = true;
     
                                 }
     
                             }
                         }
                         break;
                     case 'Honda':
                         var bikeModelsWithCushDrive = [
                             'CR125',
                             'CR250',
                             'CRF250L',
                             'CRF250L ABS',
                             'CRF250L RALLY',
                             'CRF250R',
                             'CRF250X',
                             'CRF250RX',
                             'CRF300L',
                             'CRF300L ABS',
                             'CRF300L Rally',
                             'CRF450R',
                             'CRF450R WORKS EDITION',
                             'CRF450L',
                             'CRF450RL',
                             'CRF450X',
                             'CRF450RX',
                             'CR500',
                             'XR600',
                             'XR650R',
                             'XR650L',
                             'AFRICAN TWIN'
                         ];
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
                         
                         if(selectedOptionText == "AFRICAN TWIN"){
                             options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             has_cush = true;
                             
                         }
                         else if (bikeModelsWithCushDrive.includes(selectedOptionText)) {
                             if (current_value == "unavailable") {
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             } else {
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'Husaberg':
                         if(document.querySelector('#bike_model').value == 'FE *REAR*' | document.querySelector('#bike_model').value == 'All FE /FC Models *REAR*'){
                             if(current_value == "unavailable"){
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             }else{
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'Husqvarna':
                         var bikeModelsWithCushDrive = [			
                             'TE150',
                             'FC250',
                             'FE250',
                             'TE250',
                             'TE250i',
                             'TE300',
                             'TE300i',
                             'TX300',
                             'TX300i',
                             'FC350',
                             'FE350',
                             'FX350',
                             'FC450',
                             'FC450 ROCKSTAR EDITION',
                             'FE450',
                             'FX450',
                             'FE501',
                         ];
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
                         
                         if(selectedOptionText == "701 ENDURO ABS"){
                             options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             has_cush = true;
                             
                         }
                         else if(selectedOptionText == "TC125" || selectedOptionText == "TX125" || selectedOptionText == "TC250"){
                             var selected_year = document.querySelector('#bike_year').value;
                             // 2014-2025
                             if(selected_year >= 2014 && selected_year <= 2025){
                                 if(current_value == "unavailable"){
                                     options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                 }else{
                                     options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                 }
                                 has_cush = true;
                             }
                         }
                         else if (bikeModelsWithCushDrive.includes(selectedOptionText)) {
                             if (current_value == "unavailable") {
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             } else {
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'Kawasaki':
                         if(document.querySelector('#bike_model').value == 'KLR650 *REAR* '){
                             options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             has_cush = true;
                         }else if(document.querySelector('#bike_model').value == 'KLX400 *REAR*'){
                             if (current_value == "unavailable") {
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             } else {
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     case 'Kove':
                         if(document.querySelector('#bike_model').value == '450 Rally *REAR*' || document.querySelector('#bike_model').value == '450 Rally ABS *REAR*'){
                             options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             has_cush = true;
                         }
                         break;
                     case 'KTM':
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
                         var numbers = selectedOptionText.match(/\d+/g);
                         if(selectedOptionText == "690 Enduro" 
                             || selectedOptionText == "690 R"
                             || selectedOptionText == "690 Enduro ABS" 
                             || selectedOptionText == "790 Adventure" 
                             || selectedOptionText == "790 Adventure R"
                             || selectedOptionText == "890 Adventure"
                             || selectedOptionText == "890 Adventure R"
                             || selectedOptionText == "950 Adventure"
                             || selectedOptionText == "990 Adventure"
                             || selectedOptionText == "1090 Adventure R"
                             || selectedOptionText == "1190 Adventure"
                             || selectedOptionText == "1290 Adventure"
                             || selectedOptionText == "1290 Super Adventure R"
                             || selectedOptionText == "1290 Super Adventure S" ){
                                 options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                 has_cush = true;
                         }
                         else if (numbers) {
                             var num = numbers.join('');
                             if (num <= 530){
                                 if (current_value == "unavailable") {
                                     options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                                 } else {
                                     options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                                 }
                                 has_cush = true;
                         }
                         }
                         
                         break;	
                     case 'Suzuki':
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
                         var bikeModelsWithCushDrive = [
                             'DRZ400 SM',
                             'DRZ400 SE',
                             'DRZ400 E'
                         ]
     
                         if(selectedOptionText == 'DR650' ){
                             options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             has_cush = true;
                         }else if(bikeModelsWithCushDrive.includes(selectedOptionText)){
                             if (current_value == "unavailable") {
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             } else {
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;	
                     case 'Yamaha':
                         var selectElement = document.querySelector('#bike_model');
                         var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
                         var bikeModelsWithCushDrive = [
                             'WR250F',
                             'WR400',
                             'WR426',
                             'WR450F',
                             'YZ125',
                             'YZ250',
                             'YZ250F',
                             'YZ250FX',
                             'YX250X',
                             'YZ426',
                             'YZ450F',
                             'YZ450FX',
                             'WR426'
                         ]
                         if(bikeModelsWithCushDrive.includes(selectedOptionText)){
                             if (current_value == "unavailable") {
                                 options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
                             } else {
                                 options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
                             }
                             has_cush = true;
                         }
                         break;
                     default:
                         break;
                 }
                 if(has_cush){
                     select.empty().append(options);
                     document.getElementById("cush_drive").disabled = false;
                     $('#cush_drive1').show(); 
                 }else{
                     select.empty().append('<option class="category" value="unavailable">Standard</option>');
                     document.getElementById("cush_drive").disabled = true;
                     $('#cush_drive1').hide(); 
     
                 }				
             }else{				
                 select = $('#cush_drive');
                 select.empty().append('<option class="category" value="unavailable">Standard</option>');
                 document.getElementById("cush_drive").disabled = true;
                 $('#cush_drive1').hide(); 
             }
             
         }else{
             select = $('#cush_drive');
             select.empty().append('<option class="category" value="unavailable">Standard</option>');
             document.getElementById("cush_drive").disabled = true;
             $('#cush_drive1').hide(); 
         }
     }
     $(document).on('change', 'select:not(#cush_drive), input', function(){
       setupCush();
     });
 
 
     function setupSprocket() {
         const wheel_type = document.querySelector("#wheel_type").value;
         var selectModelDOM = document.querySelector('#bike_model');
         var selectedModel = selectModelDOM.options[selectModelDOM.selectedIndex].text;
         var selectedYear = parseInt(document.querySelector('#bike_year').value);
         var preselected_value = document.querySelector('#sprocket_size').value;
         var availableSprocket = [];
         if (wheel_type == "REAR") {
             var select = $('#sprocket_size');
             var make = document.querySelector('#bike_make').value;
             switch (make) {
                 case 'Stark':
                     availableSprocket = [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53];
                     break;
                 case 'Alta Redshift':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                     break;
                 case 'BMW':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                     break;
                 case 'Beta':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                     break;
                 case 'GasGas':
                     var sprocketSizeByModelYear = {
                         "ES500": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "EC125": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC200 RANGER": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XC200": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC250 2T": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC250 4T": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC250 SIX DAYS": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XC250": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC300 RANGER": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC300 SIX DAYS": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XC300": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC450": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "EC200": {
                             "2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "EC250": {
                             "2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2015": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "EC300": {
                             "2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2015": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         }
                     };
                     var availableSprocket = [];
                     if (sprocketSizeByModelYear[selectedModel]) {
                         if(sprocketSizeByModelYear[selectedModel][selectedYear]){
                             availableSprocket = sprocketSizeByModelYear[selectedModel][selectedYear];
                         }else{
                             availableSprocket = sprocketSizeByModelYear[selectedModel].default || [];
                         }
                     }			
 
                     break;
                 case 'Honda':
                     var sprocketSizeByModelYear = {
                         "CR125": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250L": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250L ABS": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250L RALLY": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250R": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250X": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF250RX": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF300L": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF300L ABS": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF300L Rally": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450R": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450R WORKS EDITION": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450L": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450RL": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450X": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CRF450RX": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR500": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XR600": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XR650R": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "XR650L": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "AFRICAN TWIN CRF1000L": {
                             default: [42]
                         }
                     };
 
                     availableSprocket = [];
                     if (sprocketSizeByModelYear[selectedModel]) {
                         if(sprocketSizeByModelYear[selectedModel][selectedYear]){
                             availableSprocket = sprocketSizeByModelYear[selectedModel][selectedYear];
                         }else{
                             availableSprocket = sprocketSizeByModelYear[selectedModel].default || [];
                         }
                     }
 
                     break;
                 case 'Husaberg':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                     break;
                 case 'Husqvarna':
                     // Define sprocket sizes for different models and years
                     var sprocketSizeByModelYear = {
                         "CR 125": {
                             default: [40, 41, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "SM 125": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TC125": {
                             "2000": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2001": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2002": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2003": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2004": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2005": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2006": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2007": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2008": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2009": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2010": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2011": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2012": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2013": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2014": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TX125": {
                             "2000": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2001": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2002": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2003": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2004": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2005": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2006": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2007": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2008": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2009": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2010": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2011": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2012": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2013": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2014": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TXC 125": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 125": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE150": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FC 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TC 250": {
                             "2002": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2003": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2004": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2005": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2006": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2007": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2008": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2009": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2010": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2011": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2012": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2013": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                             "2014": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
                             "2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FE 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TE 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TE250i": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "SM 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TXC 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR 250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE300": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TE300i": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TX300": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "TX300i": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FC350": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FE350": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FX350": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "SM 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TC 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TXC 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR 499": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "FC450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FC450 Rockstar Edition": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FE450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "FX450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "SM 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TC 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TXC 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 450": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "FE501": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "SM 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TC 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TXC 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR 510": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "SM 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TC 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TE 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "TXC 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "CR 610": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "701 Enduro ABS": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         }
                     };
 
 
                     if (sprocketSizeByModelYear[selectedModel]) {
                         var modelData = sprocketSizeByModelYear[selectedModel];
                         if (modelData[selectedYear]) {
                             availableSprocket = modelData[selectedYear];
                         } else {
                             availableSprocket = modelData.default || [];
                         }
                     }
 
 
                     break;
                 case 'Kawasaki':
                     var sprocketSizeByModelYear = {
                         "KX125": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KX250": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KX250F": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KX250X": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KLX 300R": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KLX400": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "KX450F": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KX450X": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KLX450R": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KX500": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "KLR650": {
                             default: [43]
                         }
                     };
                     if (sprocketSizeByModelYear[selectedModel]) {
                         var modelData = sprocketSizeByModelYear[selectedModel];
                         if (modelData[selectedYear]) {
                             availableSprocket = modelData[selectedYear];
                         } else {
                             availableSprocket = modelData.default || [];
                         }
                     }
                     break;
                 case 'Kove':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
 
                     break;
                 case 'KTM':
                     var numbers = selectedModel.match(/\d+/g);
                     if (selectedModel == "690 Enduro" ||
                         selectedModel == "690 Enduro ABS" ||
                         selectedModel == "790 Adventure" ||
                         selectedModel == "790 Adventure R" ||
                         selectedModel == "890 Adventure" ||
                         selectedModel == "890 Adventure R"
                     ) {
                         availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
 
 
                     } else if 
                     (selectedModel == "950 Adventure" ||
                         selectedModel == "990 Adventure" ||
                         selectedModel == "1190 Adventure" ||
                         selectedModel == "1090 Adventure R" ||
                         selectedModel == "1290 Adventure" ||
                         selectedModel == "1290 Super Adventure R" ||
                         selectedModel == "1290 Super Adventure S") {
                         availableSprocket = [42];
 
                     } else if (numbers) {
                         var num = numbers.join('');
                         if (num <= 530) {
                             availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                         }
                     }
                     break;
                 case 'Sherco':
                     availableSprocket = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
                     break;
                 case 'Suzuki':
                     var sprocketSizeByModelYear = {
                         "DRZ400 S": {
                             default: [40, 44, 47, 48, 49, 50, 51, 52, 53]
                         },						
                         "DRZ400 SM": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "DRZ400 SE": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "DRZ400 E": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
                         },
                         "DR650": {
                             default: [40, 42]
                         },
                         "RM125": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "RM250": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
                         },
                         "RMZ250": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51]
                         },
                         "RMX450": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51]
                         },
                         "RMZ450": {
                             default: [40, 42, 44, 47, 48, 49, 50, 51]
                         }
                     };
 
                     if (sprocketSizeByModelYear[selectedModel]) {
                         var modelData = sprocketSizeByModelYear[selectedModel];
                         if (modelData[selectedYear]) {
                             availableSprocket = modelData[selectedYear];
                         } else {
                             availableSprocket = modelData.default || [];
                         }
                     }
 
                     break;
                 case 'Yamaha':
                     var sprocketSizeByModelYear = {
                         "WR250F": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "WR250R": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR250X": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR400": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
                         },
                         "WR426": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "WR450F": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "YZ125": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
 
                         },
                         "YZ250": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
 
                         },
                         "YZ250F": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
 
                         },
                         "YZ250FX": {
                             default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
 
                         },
                         "YX250X": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "YZ426": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "YZ450F": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "YZ450FX": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         },
                         "WR426": {
                             default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
 
                         }
                     };
 
                     if (sprocketSizeByModelYear[selectedModel]) {
                         var modelData = sprocketSizeByModelYear[selectedModel];
                         if (modelData[selectedYear]) {
                             availableSprocket = modelData[selectedYear];
                         } else {
                             availableSprocket = modelData.default || [];
                         }
                     }
 
                     break;
                 default:
                     break;
             }
 
             
             if (availableSprocket.length > 0) {
                 var select = $('#sprocket_size');
                 // // console.log("Available Spokes:", availableSprocket);
                 var spokedom = ``;
                 availableSprocket.forEach(function (spoke) {
                     var v = `${spoke} Teeth`;
                     if (preselected_value == v) {
                         spokedom += `<option class="category" value="${v}" selected>${v}</option>`;
                     } else {
                         spokedom += `<option class="category" value="${v}">${v}</option>`;
                     }
                 });
                 // Suzuki RM 125 & RM 250
                 // Honda CR250L, CR300L, CR250L Rally, CR300L Rally
                 // Suzuki DRZ400
                 // Kawasaki KLX250, KLX300
                 var restrict_nospoke  = [
                     'RM125 * REAR *',
                     'RM250 * REAR *',
                     'CRF250L *REAR*',
                     'CRF300L *REAR*',
                     'CRF250L Rally *REAR*',
                     'CRF300L Rally *REAR*',
                     'DRZ400 SM *REAR*',
                     'DRZ400 S * REAR *',
                     'DRZ400 SE * REAR *',
                     'DRZ400 E * REAR *',
                     'KX250F  *REAR*',
                     'KX250XC *REAR*',
                     'KLX 300R *REAR*'
                 ]
                 //--> Old array
                 // var restrict_nospoke  = [
                     
                 // 	'CRF250L *REAR*',
                 // 	'CRF300L *REAR*',
                 // 	'CRF250L RALLY *REAR*',
                 // 	'CRF300L Rally *REAR*',
                 // 	'DRZ400 S/SE/E *REAR*',
                 // 	'DRZ400 SE *REAR*',
                 // 	'DRZ400 SM *REAR*',
                 // 	'DRZ400 E *REAR*',
                 // 	'KX250 *FRONT*',
                 // 	'KX250F *FRONT*',
                 // 	'KLX 300R *FRONT*'
                 // ]
                 var selected_model = $('#bike_model').val();
                 if(!restrict_nospoke.includes(selected_model)){
                     spokedom+=`<option class="category" value="no">No Sprocket</option>`;
                 }
                 select.empty().append(spokedom);
                 $('#sprocket').show();
             } else {
                 var select = $('#sprocket_size');
                 select.empty().append('<option value="no">No Sprocket</option>');
                 $('#sprocket').hide();
             }
         } else {
             var select = $('#sprocket_size');
             select.empty().append('<option value="no">No Sprocket</option>');
 
             $('#sprocket').hide();
         }
         document.querySelector('#sprocket_size').dispatchEvent(new Event('change'));
 
     }
     $(document).on('change', 'select:not(#sprocket_size), input', function () {
         setTimeout(function(){
             setupSprocket();
         }, 100);
     });
 
   
      var images = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-";
      var rotorImage = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--";
      var colorImages = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/";
      var new_base_price = 500;
      var base_price = 500;
      var role = $(".custom-variant-wrapper").attr('data-role');
      var dealerprice = 379;
       if (role == "true") {
           $('#price').text('$' + dealerprice);
       }
 
     function showColors(category) {
       $('.color-swatch').removeClass('show');
       $('.color-swatch[data-category="' + category + '"]').addClass('show');      
     }
 
     showColors('anodized');
   
     $('.rim-type-wrap').click(function() {
       // //// console.log('here');
       $('.rim-type-wrap').removeClass('active');
       $(this).addClass('active');
       var category = $(this).attr('data-category');
       showColors(category);
       $('.color-swatch[data-category="' + category + '"].show').eq(0).click();
     });
       //husqvarna = hq
     var hqf1 = 'CR 125 *FRONT*';
     var hqf2 = 'SM 125 *FRONT*';
     var hqf3 = 'TC125 *FRONT*';
     var hqf4 = 'TE 125 *FRONT*';
     var hqf5 = 'TX125 *FRONT*';
     var hqf6 = 'TXC 125 *FRONT*';
     var hqf7 = 'WR 125 *FRONT*';
     var hqf8 = 'TE150 *FRONT*';
     var hqf9 = 'FC 250 *FRONT*';
     var hqf10 = 'TC 250 *FRONT*';
     var hqf11 = 'FE 250 *FRONT*';
     var hqf12 = 'TE 250 *FRONT*';
     var hqf13 = 'TE250I *FRONT*';
     var hqf14 = 'SM 250 *FRONT*';
     var hqf15 = 'TXC 250 *FRONT*';
     var hqf16 = 'WR 250 *FRONT*';
     var hqf17 = 'CR 250 *FRONT*';
     var hqf18 = 'TE300 *FRONT*';
     var hqf19 = 'TE300I *FRONT*';
     var hqf20 = 'TX300 *FRONT*';
     var hqf21 = 'TX300i *FRONT*';
     var hqf22 = 'FC350 *FRONT*';
     var hqf23 = 'FE350 *FRONT*';
     var hqf24 = 'FX350 *FRONT*';
     var hqf25 = 'SM 449 *FRONT*';
     var hqf26 = 'TC 449 *FRONT*';
     var hqf27 = 'TE 449 *FRONT*';
     var hqf28 = 'TXC 449 *FRONT*';
     var hqf29 = 'WR 449 *FRONT*';
     var hqf30 = 'CR 449 *FRONT*';
     var hqf31 = 'CR 450 *FRONT*';
     var hqf32 = 'FC450 *FRONT*';
     var hqf33 = 'FC450 Rockstar Edition *FRONT*';
     var hqf34 = 'FE450 *FRONT*';
     var hqf35 = 'FX450 *FRONT*';
     var hqf36 = 'SM 450 *FRONT*';
     var hqf37 = 'TC 450 *FRONT*';
     var hqf38 = 'TE 450 *FRONT*';
     var hqf39 = 'TXC 450 *FRONT*';
     var hqf40 = 'WR 450 *FRONT*';
     var hqf41 = 'FE501 *FRONT*';
     var hqf42 = 'SM 510 *FRONT*';
     var hqf43 = 'TC 510 *FRONT*';
     var hqf44 = 'TE 510 *FRONT*';
     var hqf45 = 'TXC 510 *FRONT*';
     var hqf46 = 'WR 510 *FRONT*';
     var hqf47 = 'CR 510 *FRONT*';
     var hqf48 = 'SM 610 *FRONT*';
     var hqf49 = 'TC 610 *FRONT*';
     var hqf50 = 'TE 610 *FRONT*';
     var hqf51 = 'TXC 610 *FRONT*';
     var hqf52 = 'WR 610 *FRONT*';
     var hqf53 = 'CR 610 *FRONT*';
     var hqf54 = '701 Enduro ABS *FRONT*';
     var hqr1 = 'CR 125 *REAR*';
     var hqr2 = 'SM 125 *REAR*';
     var hqr3 = 'TC125 *REAR*';
     var hqr4 = 'TE 125 *REAR*';
     var hqr5 = 'TX125 *REAR*';
     var hqr6 = 'TXC 125 *REAR*';
     var hqr7 = 'WR 125 *REAR*';
     var hqr8 = 'TE150 *REAR*';
     var hqr9 = 'FC 250 *REAR*';
     var hqr10 = 'TC 250 *REAR*';
     var hqr11 = 'FE 250 *REAR*';
     var hqr12 = 'TE 250 *REAR*';
     var hqr13 = 'TE250I *REAR*';
     var hqr14 = 'SM 250 *REAR*';
     var hqr15 = 'TXC 250 *REAR*';
     var hqr16 = 'WR 250 *REAR*';
     var hqr17 = 'CR 250 *REAR*';
     var hqr18 = 'TE300 *REAR*';
     var hqr19 = 'TE300I *REAR*';
     var hqr20 = 'TX300 *REAR*';
     var hqr21 = 'TX300i *REAR*';
     var hqr22 = 'FC350 *REAR*';
     var hqr23 = 'FE350 *REAR*';
     var hqr24 = 'FX350 *REAR*';
     var hqr25 = 'SM 449 *REAR*';
     var hqr26 = 'TC 449 *REAR*';
     var hqr27 = 'TE 449 *REAR*';
     var hqr28 = 'TXC 449 *REAR*';
     var hqr29 = 'WR 449 *REAR*';
     var hqr30 = 'CR 449 *REAR*';
     var hqr31 = 'CR 450 *REAR*';
     var hqr32 = 'FC450 *REAR*';
     var hqr33 = 'FC450 Rockstar Edition *REAR*';
     var hqr34 = 'FE450 *REAR*';
     var hqr35 = 'FX450 *REAR*';
     var hqr36 = 'SM 450 *REAR*';
     var hqr37 = 'TC 450 *REAR*';
     var hqr38 = 'TE 450 *REAR*';
     var hqr39 = 'TXC 450 *REAR*';
     var hqr40 = 'WR 450 *REAR*';
     var hqr41 = 'FE501 *REAR*';
     var hqr42 = 'SM 510 *REAR*';
     var hqr43 = 'TC 510 *REAR*';
     var hqr44 = 'TE 510 *REAR*';
     var hqr45 = 'TXC 510 *REAR*';
     var hqr46 = 'WR 510 *REAR*';
     var hqr47 = 'CR 510 *REAR*';
     var hqr48 = 'SM 610 *REAR*';
     var hqr49 = 'TC 610 *REAR*';
     var hqr50 = 'TE 610 *REAR*';
     var hqr51 = 'TXC 610 *REAR*';
     var hqr52 = 'WR 610 *REAR*';
     var hqr53 = 'CR 610 *REAR*';
     var hqr54 = '701 Enduro ABS *REAR*';
     //honda = hn
     var hnf1 = 'CR125, CR250 *FRONT*';
     var hnf2 = 'CR125, CR250 *FRONT*';
     var hnf3 = 'CRF250L *FRONT*';
     var hnf4 = 'CRF250L ABS *FRONT*';
     var hnf5 = 'CRF250L Rally *FRONT*';
     var hnf6 = 'CRF250R *FRONT*';
     var hnf7 = 'CRF250X *FRONT*';
     var hnf8 = 'CRF250RX *FRONT*';
     var hnf9 = 'XR400 *FRONT*';
     var hnf10 = 'CRF450R *FRONT*';
     var hnf11 = 'CRF450R Works Edition *FRONT*';
     var hnf12 = 'CRF450L *FRONT*';
     var hnf13 = 'CRF450X *FRONT*';
     var hnf14 = 'CRF450RX *FRONT*';
     var hnf15 = 'CR500 *FRONT*';
     var hnf16 = 'XR600 *FRONT*';
     var hnf17 = 'XR650L *FRONT*';
     var hnf18 = 'XR650R *FRONT*';
     var hnf19 = 'CRF1000L *FRONT*';
     var hnf20 = 'CRF450RL *FRONT*';
     var hnr1 = 'CR125, CR250 *REAR*';
     var hnr2 = 'CR125, CR250 *REAR*';
     var hnr3 = 'CRF250L *REAR*';
     var hnr4 = 'CRF250L ABS *REAR*';
     var hnr5 = 'CRF250L Rally *REAR*';
     var hnr6 = 'CRF250R *REAR*';
     var hnr7 = 'CRF250X *REAR*';
     var hnr8 = 'CRF250RX *REAR*';
     var hnr9 = 'XR400 *REAR*';
     var hnr10 = 'CRF450R *REAR*';
     var hnr11 = 'CRF450R Works Edition *REAR*';
     var hnr12 = 'CRF450L *REAR*';
     var hnr20 = 'CRF450RL *REAR*';
     var hnr13 = 'CRF450X *REAR*';
     var hnr14 = 'CRF450RX *REAR*';
     var hnr15 = 'CR500 *REAR*';
     var hnr16 = 'XR600 *REAR*';
     var hnr17 = 'XR650L *REAR*';
     var hnr18 = 'XR650R *REAR*';
     var hnr19 = 'CRF1000L *REAR*';
     //honda = hn
     var hnf1 = 'CR125, CR250 *FRONT*';
     var hnf2 = 'CR125, CR250 *FRONT*'
     var hnf3 = 'CRF250L *FRONT*';
     var hnf4 = 'CRF250L ABS *FRONT*';
     var hnf5 = 'CRF250L Rally *FRONT*';
     var hnf6 = 'CRF250R *FRONT*';
     var hnf7 = 'CRF250X *FRONT*';
     var hnf8 = 'CRF250RX *FRONT*';	
     var hnf9 = 'XR400 *FRONT*';
     var hnf10 = 'CRF450R *FRONT*';
     var hnf11 = 'CRF450R Works Edition *FRONT*';
     var hnf12 = 'CRF450L *FRONT*';
     var hnf13 = 'CRF450X *FRONT*';
     var hnf14 = 'CRF450RX *FRONT*';
     var hnf15 = 'CR500 *FRONT*';
     var hnf16 = 'XR600 *FRONT*';
     var hnf17 = 'XR650L *FRONT*';
     var hnf18 = 'XR650R *FRONT*';
     var hnf19 = 'CRF1000L *FRONT*';
     var hnf20 = 'CRF450RL *FRONT*';
     var hnr1 = 'CR125, CR250 *REAR*';
     var hnr2 = 'CR125, CR250 *REAR*';
     var hnr3 = 'CRF250L *REAR*';
     var hnr4 = 'CRF250L ABS *REAR*';
     var hnr5 = 'CRF250L Rally *REAR*';
     var hnr6 = 'CRF250R *REAR*';
     var hnr7 = 'CRF250X *REAR*';
     var hnr8 = 'CRF250RX *REAR*';
     var hnr9 = 'XR400 *REAR*';
     var hnr10 = 'CRF450R *REAR*';
     var hnr11 = 'CRF450R Works Edition *REAR*';
     var hnr12 = 'CRF450L *REAR*';
     var hnr20 = 'CRF450RL *REAR*';
     var hnr13 = 'CRF450X *REAR*';
     var hnr14 = 'CRF450RX *REAR*';
     var hnr15 = 'CR500 *REAR*';
     var hnr16 = 'XR600 *REAR*';
     var hnr17 = 'XR650L *REAR*';
     var hnr18 = 'XR650R *REAR*';
     var hnr19 = 'CRF1000L *REAR*';
     //ktm = ktm
     var ktmf1 = 'EXC125 *FRONT*';
     var ktmf2 = 'EXC200 *FRONT*';
     var ktmf3 = 'EXC-F250 *FRONT*';
     var ktmf4 = 'XCF-W250 *FRONT*';
     var ktmf5 = 'EXC300 *FRONT*';
     var ktmf6 = 'EXC350 *FRONT*';
     var ktmf7 = 'XC-W300 TPI *FRONT*';
     var ktmf8 = 'EXC-F350 *FRONT*';
     var ktmf9 = 'EXC380 *FRONT*';
     var ktmf10 = 'EXC400 *FRONT*';
     var ktmf11 = 'EXC450 *FRONT*';
     var ktmf12 = 'EXC-F450 *FRONT*';
     var ktmf13 = 'EXC-F500 *FRONT*';
     var ktmf14 = 'EXC520 *FRONT*';
     var ktmf15 = 'EXC525 *FRONT*';
     var ktmf16 = 'EXC530 *FRONT*';
     var ktmf17 = 'EXC-R530 *FRONT*';
     var ktmf18 = 'XC150 *FRONT*';
     var ktmf19 = 'XC-W150 *FRONT*';
     var ktmf20 = 'XC200 *FRONT*';
     var ktmf21 = 'XC-W200 *FRONT*';
     var ktmf22 = 'XC250 *FRONT*';
     var ktmf23 = 'XC250 TPI *FRONT*';
     var ktmf24 = 'XC-W250 *FRONT*';
     var ktmf25 = 'XC-W250 TPI *FRONT*';
     var ktmf26 = 'XC-F250 *FRONT*';
     var ktmf27 = 'XC300 *FRONT*';
     var ktmf28 = 'XC300 TPI *FRONT*';
     var ktmf29 = 'XC-W300 *FRONT*';
     var ktmf30 = 'XC-W300 TPI Six Days *FRONT*';
     var ktmf31 = 'XC-F350 *FRONT*';
     var ktmf32 = 'XCF-W350 *FRONT*';
     var ktmf33 = 'XC400 *FRONT*';
     var ktmf34 = 'XC-W400 *FRONT*';
     var ktmf35 = 'XC-F450 *FRONT*';
     var ktmf36 = 'XC450 *FRONT*';
     var ktmf37 = 'XC-W450 *FRONT*';
     var ktmf38 = 'XC-W500 *FRONT*';
     var ktmf39 = 'XC-F505 *FRONT*';
     var ktmf40 = 'XC525 *FRONT*';
     var ktmf41 = 'XC-W525 *FRONT*';
     var ktmf42 = 'XC530 *FRONT*';
     var ktmf43 = 'XC-W530 *FRONT*';
     var ktmf44 = 'SX125 *FRONT*';
     var ktmf45 = 'SX144 *FRONT*';
     var ktmf46 = 'SX150 *FRONT*';
     var ktmf47 = 'SX200 *FRONT*';
     var ktmf48 = 'SX250 *FRONT*';
     var ktmf49 = 'SXF250 *FRONT*';
     var ktmf50 = 'SXF350 *FRONT*';
     var ktmf51 = 'SX380 *FRONT*';
     var ktmf52 = 'SX400 *FRONT*';
     var ktmf53 = 'SXC400 *FRONT*';
     var ktmf54 = 'SX450 *FRONT*';
     var ktmf55= 'SX-RFS450 *FRONT*';
     var ktmf56 = 'SX-F450 *FRONT*';
     var ktmf57 = 'SX-F450 Factory Edition *FRONT*';
     var ktmf58 = 'SX-F505 *FRONT*';
     var ktmf59 = 'SX520 *FRONT*';
     var ktmf60 = 'SX525 *FRONT*';
     var ktmf61 = 'SXC625 *FRONT*';
     var ktmf62 = '690 Enduro *FRONT*';
     var ktmf63 = '690 Enduro ABS *FRONT*';
     var ktmf64 = '790 Adventure *FRONT*';
     var ktmf65 = '790 Adventure R *FRONT*';
     var ktmf66 = '950 Adventure *FRONT*';
     var ktmf67 = '990 Adventure *FRONT*';
     var ktmf68 = '1090 Adventure R *FRONT*';
     var ktmf69 = '1190 Adventure *FRONT*';
     var ktmf70 = '1290 Adventure *FRONT*';
     var ktmf71 = '1290 Adventure R *FRONT*';
     var ktmf72 = '1290 Super Adventure S *FRONT*';
     var ktmf73 = '690 Enduro ABS *FRONT*';
     
     var ktmr1 = 'EXC125 *REAR*';
     var ktmr2 = 'EXC200 *REAR*';
     var ktmr3 = 'EXC-F250 *REAR*';
     var ktmr4 = 'XCF-W250 *REAR*';
     var ktmr5 = 'EXC300 *REAR*';
     var ktmr6 = 'EXC350 *REAR*';
     var ktmr7 = 'XC-W300 TPI *REAR*';
     var ktmr8 = 'EXC-F350 *REAR*';
     var ktmr9 = 'EXC380 *REAR*';
     var ktmr10 = 'EXC400 *REAR*';
     var ktmr11 = 'EXC450 *REAR*';
     var ktmr12 = 'EXC-F450 *REAR*';
     var ktmr13 = 'EXC-F500 *REAR*';
     var ktmr14 = 'EXC520 *REAR*';
     var ktmr15 = 'EXC525 *REAR*';
     var ktmr16 = 'EXC530 *REAR*';
     var ktmr17 = 'EXC530 *REAR*';
     var ktmr18 = 'EXC-R530 *REAR*';
     var ktmr19 = 'XC150 *REAR*';
     var ktmr20 = 'XC-W150 *REAR*';
     var ktmr21 = 'XC200 *REAR*';
     var ktmr22 = 'XC-W200 *REAR*';
     var ktmr23 = 'XC250 *REAR*';
     var ktmr24 = 'XC250 TPI *REAR*';
     var ktmr25 = 'XC-W250 *REAR*';
     var ktmr26 = 'XC-W250 TPI *REAR*';
     var ktmr27 = 'XC-F250 *REAR*';
     var ktmr28 = 'XC300 *REAR*';
     var ktmr29 = 'XC300 TPI *REAR*';
     var ktmr30 = 'XC-W300 *REAR*';
     var ktmr31 = 'XC-W300 TPI Six Days *REAR*';
     var ktmr32 = 'XC-F350 *REAR*';
     var ktmr33 = 'XCF-W350 *REAR*';
     var ktmr34 = 'XC400 *REAR*';
     var ktmr35 = 'XC-W400 *REAR*';
     var ktmr36 = 'XC-F450 *REAR*';
     var ktmr37 = 'XC450 *REAR*';
     var ktmr38 = 'XC-W450 *REAR*';
     var ktmr39 = 'XC-W500 *REAR*';
     var ktmr40 = 'XC-F505 *REAR*';
     var ktmr41 = 'XC525 *REAR*';
     var ktmr42 = 'XC-W525 *REAR*';
     var ktmr43 = 'XC530 *REAR*';
     var ktmr44 = 'XC-W530 *REAR*';
     var ktmr45 = 'SX125 *REAR*';
     var ktmr46 = 'SX144 *REAR*';
     var ktmr47 = 'SX150 *REAR*';
     var ktmr48 = 'SX200 *REAR*';
     var ktmr49 = 'SX250 *REAR*';
     var ktmr50 = 'SXF250 *REAR*';
     var ktmr51 = 'SXF350 *REAR*';
     var ktmr52 = 'SX380 *REAR*';
     var ktmr53 = 'SX400 *REAR*';
     var ktmr54 = 'SXC400 *REAR*';
     var ktmr55 = 'SX450 *REAR*';
     var ktmr56 = 'SX-RFS450 *REAR*';
     var ktmr57 = 'SX-F450 *REAR*';
     var ktmr58 = 'SX-F450 Factory Edition *REAR*';
     var ktmr59 = 'SX-F505 *REAR*';
     var ktmr60 = 'SX520 *REAR*';
     var ktmr61 = 'SX525 *REAR*';
     var ktmr62 = 'SXC625 *REAR*';
     var ktmr63 = '690 ENDURO * REAR *';
     var ktmr64 = '690 ENDURO ABS * REAR *';
     var ktmr65 = '790 Adventure *REAR*';
     var ktmr66 = '790 Adventure R *REAR*';
     var ktmr67 = '950 Adventure *REAR*';
     var ktmr68 = '990 Adventure *REAR*';
     var ktmr69 = '1090 Adventure *REAR*';
     var ktmr70 = '1190 Adventure *REAR*';
     var ktmr71 = '1290 Adventure *REAR*';
     var ktmr72 = '1290 Adventure R *REAR*';
     var ktmr73 = '1290 Super Adventure S *REAR*';
     var ktmr74 = '690 ENDURO ABS * REAR *';
 
  
   
 
   //Change Magnet Images and Price Increase
       var magnet_change = function() {
       var magnet = $('select#sm_magnets').val();
           if(magnet!="NO"){
           $("#resultAreaID_1_7").show();
           var image_name = images+"magnet-"+$('select#sm_magnets').val()+'-'+$('select#wheel_type').val()+".png";
           var imageArr6 = [image_name];
           var divArr6 = ["resultAreaID_1_7"];
           // imageObj6 = new BL_ImageLoader(divArr6,imageArr6);
           $('#resultAreaID_1_7 img').attr('src', image_name);
           }
           else if (magnet=="NO") {
           $("#resultAreaID_1_7").hide();
           }
           else {}
       }
 
   //Sprocket Hide Function
         function sprockethide() {
             if($('select#sprocket_size').val() == "no") {
                 $('#resultAreaID_1_7').hide();
             }
             else {
                 $('#resultAreaID_1_7').show();
             }
         }
 
       function nipplespokecolor(){
             if ($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "CRF1000L *FRONT*" || $('select#bike_model').val() == "CRF1000L *REAR*") {
             var spoke_color_wrapper = $('.spoke_color_wrapper');
             spoke_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>`);
             var image_name = images+"spokes-"+$('#spoke_color').val()+"-"+$('select#wheel_type').val()+".png";
             $('#resultAreaID_1_2 img').attr('src', image_name);
             }
             if($('select#rim_size').val() == "REAR 19x3.00") {
             // var select = $('#spoke_color');
             // select.empty().append('<option value="Silver">Silver</option>');
             var rim_color_wrapper = $('.rim_color_wrapper');
             rim_color_wrapper.empty().append(`<div class="color-swatch active show" data-category="anodized" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">`);
             var image_name = images+"spokes-"+$('#spoke_color').val()+"-"+$('select#wheel_type').val()+".png";        
             $('#resultAreaID_1_2 img').attr('src', image_name);	
             }
         }
 
   //Nipple Color depends upon Spoke Color
         function nipplecolorreset() {
             if (($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "CRF1000L *FRONT*" || $('select#bike_model').val() == "CRF1000L *REAR*") || $('select#rim_size').val() == "REAR 19x3.00") {
             if ($('#spoke_color').val() == "Silver") {
                 var nipple_color_wrapper = $('.nipple_color_wrapper');
                 nipple_color_wrapper.empty().append('<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">');
                 var image_name = images+"nipple-"+$('#nipple_color').val()+"-"+$('select#wheel_type').val()+".png";
                 $('#resultAreaID_1_3 img').attr('src', image_name);	
             }
             else {
                 var select = $('#nipple_color');
                 // select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Orange">Orange</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');
             }
             }
         }
 
 
         var spoketitanium = function() {
         //Titanium Spoke Color Code
         //Bike Make 
         
             var bike = $('select#bike_year').val();
             var bikemodel = $('select#bike_model').val();
             if ($('select#bike_make').val() == "Husqvarna") {
             if (bikemodel == hqf1 || bikemodel == hqf2 || bikemodel == hqf3 || bikemodel == hqf4 || bikemodel == hqf5 || bikemodel == hqf6 || bikemodel == hqf7 || bikemodel == hqf8 || bikemodel == hqf9 || bikemodel == hqf10 || bikemodel == hqf11 || bikemodel == hqf12 || bikemodel == hqf13 || bikemodel == hqf14 || bikemodel == hqf15 || bikemodel == hqf16 || bikemodel == hqf17 || bikemodel == hqf18 || bikemodel == hqf19 || bikemodel == hqf20 || bikemodel == hqf21 || bikemodel == hqf22 || bikemodel == hqf23 || bikemodel == hqf24 || bikemodel == hqf25 || bikemodel == hqf26 || bikemodel == hqf27 || bikemodel == hqf28 || bikemodel == hqf29 || bikemodel == hqf30 || bikemodel == hqf31 || bikemodel == hqf32 || bikemodel == hqf33 || bikemodel == hqf34 || bikemodel == hqf35 || bikemodel == hqf36 || bikemodel == hqf37 || bikemodel == hqf38 || bikemodel == hqf39 || bikemodel == hqf40 || bikemodel == hqf41 || bikemodel == hqr1 || bikemodel == hqr2 || bikemodel == hqr3 || bikemodel == hqr4 || bikemodel == hqr5 || bikemodel == hqr6 || bikemodel == hqr7 || bikemodel == hqr8 || bikemodel == hqr9 || bikemodel == hqr10 || bikemodel == hqr11 || bikemodel == hqr12 || bikemodel == hqr13 || bikemodel == hqr14 || bikemodel == hqr15 || bikemodel == hqr16 || bikemodel == hqr17 || bikemodel == hqr18 || bikemodel == hqr19 || bikemodel == hqr20 || bikemodel == hqr21 || bikemodel == hqr22 || bikemodel == hqr23 || bikemodel == hqr24 || bikemodel == hqr25 || bikemodel == hqr26 || bikemodel == hqr27 || bikemodel == hqr28 || bikemodel == hqr29 || bikemodel == hqr30 || bikemodel == hqr31 || bikemodel == hqr32 || bikemodel == hqr33 || bikemodel == hqr34 || bikemodel == hqr35 || bikemodel == hqr36 || bikemodel == hqr37 || bikemodel == hqr38 || bikemodel == hqr39 || bikemodel == hqr40 || bikemodel == hqr41) {
                 if(	bike >= 2014 & bike <= 2020) {
                         if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "18X2.50 (OEM SIZE)") {
                             var select = $('.spoke_color_wrapper');
                             select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Titanium" style="background: url(${colorImages}titanium.svg?v=1717478021);"></div>
 `);
                         }
                         else if ($('select#rim_size').val() != "REAR 19x3.00") {
                             var select = $('.spoke_color_wrapper');
                             select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
 `);
                         }
                 }
 
         }
         
         }
         else if ($('select#bike_make').val() == "Honda" || $('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Kawasaki" || $('select#bike_make').val() == "Yamaha") {
             if (bikemodel == hnf1 || bikemodel == hnf2 || bikemodel == hnf6 || bikemodel == hnf7 || bikemodel == hnf8 || bikemodel == hnf9 || bikemodel == hnf10 || bikemodel == hnf11 || bikemodel == hnf12 || bikemodel == hnf20 || bikemodel == hnf13 || bikemodel == hnf14 || bikemodel == hnr1 ||  bikemodel == hnr2 ||  bikemodel == hnr6 ||  bikemodel == hnr7 ||  bikemodel == hnr8 ||  bikemodel == hnr9 ||  bikemodel == hnr10 ||  bikemodel == hnr11 ||  bikemodel == hnr12 ||  bikemodel == hnr13 ||  bikemodel == hnr14 || bikemodel == ktmf1 || bikemodel == ktmf2 || bikemodel == ktmf3 || bikemodel == ktmf4 || bikemodel == ktmf5 || bikemodel == ktmf6 || bikemodel == ktmf7 || bikemodel == ktmf8 || bikemodel == ktmf9 || bikemodel == ktmf10 || bikemodel == ktmf11 || bikemodel == ktmf12 || bikemodel == ktmf13 || bikemodel == ktmf14 || bikemodel == ktmf15 || bikemodel == ktmf16 || bikemodel == ktmf17 || bikemodel == ktmf18 || bikemodel == ktmf19 || bikemodel == ktmf20 || bikemodel == ktmf21 || bikemodel == ktmf22 || bikemodel == ktmf23 || bikemodel == ktmf24 || bikemodel == ktmf25 || bikemodel == ktmf26 || bikemodel == ktmf27 || bikemodel == ktmf28 || bikemodel == ktmf29 || bikemodel == ktmf30 || bikemodel == ktmf31 || bikemodel == ktmf32 || bikemodel == ktmf33 || bikemodel == ktmf34 || bikemodel == ktmf35 || bikemodel == ktmf36 || bikemodel == ktmf37 || bikemodel == ktmf38 || bikemodel == ktmf39 || bikemodel == ktmf40 || bikemodel == ktmf41 || bikemodel == ktmf42 || bikemodel == ktmf43 || bikemodel == ktmf44 || bikemodel == ktmf45 || bikemodel == ktmf46 || bikemodel == ktmf47 || bikemodel == ktmf48 || bikemodel == ktmf49 || bikemodel == ktmf50 || bikemodel == ktmf51 || bikemodel == ktmf52 || bikemodel == ktmf53 || bikemodel == ktmf54 || bikemodel == ktmf55 || bikemodel == ktmf56 || bikemodel == ktmf57 || bikemodel == ktmf58 || bikemodel == ktmf59 || bikemodel == ktmf60 || bikemodel == ktmr1 || bikemodel == ktmr2 || bikemodel == ktmr3 || bikemodel == ktmr4 || bikemodel == ktmr5 || bikemodel == ktmr6 || bikemodel == ktmr7 || bikemodel == ktmr8 || bikemodel == ktmr9 || bikemodel == ktmr10 || bikemodel == ktmr11 || bikemodel == ktmr12 || bikemodel == ktmr13 || bikemodel == ktmr14 || bikemodel == ktmr15 || bikemodel == ktmr16 || bikemodel == ktmr17 || bikemodel == ktmr18 || bikemodel == ktmr19 || bikemodel == ktmr20 || bikemodel == ktmr21 || bikemodel == ktmr22 || bikemodel == ktmr23 || bikemodel == ktmr24 || bikemodel == ktmr25 || bikemodel == ktmr26 || bikemodel == ktmr27 || bikemodel == ktmr28 || bikemodel == ktmr29 || bikemodel == ktmr30 || bikemodel == ktmr31 || bikemodel == ktmr32 || bikemodel == ktmr33 || bikemodel == ktmr34 || bikemodel == ktmr35 || bikemodel == ktmr36 || bikemodel == ktmr37 || bikemodel == ktmr38 || bikemodel == ktmr39 || bikemodel == ktmr40 || bikemodel == ktmr41 || bikemodel == ktmr42 || bikemodel == ktmr43 || bikemodel == ktmr44 || bikemodel == ktmr45 || bikemodel == ktmr46 || bikemodel == ktmr47 || bikemodel == ktmr48 || bikemodel == ktmr49 || bikemodel == ktmr50 || bikemodel == ktmr51 || bikemodel == ktmr52 || bikemodel == ktmr53 || bikemodel == ktmr54 || bikemodel == ktmr55 || bikemodel == ktmr56 || bikemodel == ktmr57 || bikemodel == ktmr58 || bikemodel == ktmr59 || bikemodel == ktmr60 || bikemodel == ktmr61 || bikemodel == "KX125 *FRONT*" || bikemodel == "KX250 *FRONT*" || bikemodel == "KX250F  *FRONT*" || bikemodel == "KX250XC *FRONT*" || bikemodel == "KX450F/KLX450R *FRONT*" || bikemodel == "KX450XC *FRONT*" || bikemodel == "KLX 300R *FRONT*" || bikemodel == "KLX450R *FRONT*" || bikemodel == "KX125 *REAR*" || bikemodel == "KX250 *REAR*" || bikemodel == "KX250F  *REAR*"  || bikemodel == "KX250XC *REAR*" || bikemodel == "KX450F *REAR*" || bikemodel == "KX450XC *REAR*" || bikemodel == "KLX 300R *REAR*" || bikemodel == "KLX450R *REAR*" || bikemodel == "WR250F *FRONT*" || bikemodel == "WR400 *FRONT*" || bikemodel == "WR450F *FRONT*" || bikemodel == "YZ125 *FRONT*" || bikemodel == "YZ125R *FRONT*" || bikemodel == "YZ250 *FRONT*" || bikemodel == "YZ250R *FRONT*" || bikemodel == "YZ250F *FRONT*" || bikemodel == "YZ250FX *FRONT*" || bikemodel == "YZ250X *FRONT*" || bikemodel == "YZ400F *FRONT*" || bikemodel == "YZ426F/YZ450F *FRONT*" || bikemodel == "YZ250F/YZ450F *FRONT*" || bikemodel == "YZ450FX *FRONT*" || bikemodel == "WR426 *FRONT*" || bikemodel == "WR250F *REAR*" || bikemodel == "WR400/WR426 *REAR*" || bikemodel == "WR426 *REAR*" || bikemodel == "WR450F *REAR*" || bikemodel == "YZ125, YZ250 *REAR*" || bikemodel == "YZ125, YZ250 *REAR*" || bikemodel == "YZ250F *REAR*" || bikemodel == "YZ250FX *REAR*" || bikemodel == "YZ250X *REAR*" || bikemodel == "YZ400F *REAR*" || bikemodel == "YZ426F *REAR*" || bikemodel == "YZ450F *REAR*" || bikemodel == "YZ450FX *REAR*" || bikemodel == "WR426 *REAR*") {
                     if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "REAR 18x4.25\"") {
                             var select = $('.spoke_color_wrapper');
                             select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Titanium" style="background: url(${colorImages}titanium.svg?v=1717478021);"></div>`);
                         }
                 }
                 
         }
         //Titanium Spoke Color Code End
     }
     $('select#bike_model').change( function () {
    
    if ($('select#bike_make').val() == 'Kawasaki') {
        if ($('select#bike_model').val() == 'KX125 *FRONT*') {
            var select = $('#brake_rotor');
            select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
        } else {
            if ($('select#bike_make').val() === "GasGas") {
                gasgasbrakeremove();
            } else {
                var select = $('#brake_rotor');
                select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
            }
        }
    }
    if ($('select#bike_make').val() == 'Yamaha') {
        if ($('select#bike_model').val() == 'YZ125 *FRONT*') {
            var select = $('#brake_rotor');
            select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
        } else {
            if ($('select#bike_make').val() === "GasGas") {
                gasgasbrakeremove();
            } else {
                var select = $('#brake_rotor');
                select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
            }
        }
    } 
 });
     function gasgasbrakeremove() {
         if($('select#bike_make').val() === "GasGas") {
             if($('select#bike_year').val() <= 2019) {
                 var select = $('#brake_rotor');
                 select.empty().append('<option class="category" value="260mm">OEM 260mm</option>');
             }
             else {
                 var select = $('#brake_rotor');
                 select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
             }
         }
     }
 
    //Hide 320mm Floating Brake Rotor Style option with Bike Year
         function hide320mm() {
             var make = $('select#bike_make').val();
             if(make == "Husqvarna") {
                 var bike = $('select#bike_year').val();
                 if( bike >= 2000 & bike <= 2013) {
                         select = $('#brake_rotor');
                         select.empty().append(' <option value="320MM_FIXED">320mm Fixed</option>');
                 }
                 else if(bike >= 2014) {
                         select = $('#brake_rotor');
                         select.empty().append(' <option value="320MM_FIXED">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
                 }
             }
         }
 
     //Tubeless Wheel Conditions.
     function tubelesswheel(){
         //val select = $('#rim_size');
         if($('select#rim_size').val() == 'FRONT 17x3.50' || $('select#rim_size').val() == 'FRONT 16.5x3.50' ||$('select#rim_size').val() == 'REAR 17x4.25' ||$('select#rim_size').val() == 'REAR 17x5.00' ) {
             if($('select#mtl').val() == "No") {
                 $('#resultAreaID_1_11').hide();
             }
             else {
                 $('#resultAreaID_1_11').show();
                 var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-"+"tubeless-"+$('select#mtl').val()+"-"+$('select#wheel_type').val()+".png";
                 var imageArr10 = [image_name];
                 var divArr10 = [	"resultAreaID_1_11"];
                 $('#resultAreaID_1_11 img').attr('src', image_name);
                 
             }
             // //// console.log('On 17');
             $('#make_tubeless').show();
         }
         else {
             $('#make_tubeless').hide();
             $('#resultAreaID_1_11').hide();				
         }
     }
 
   function nosprocket() {
       // var make = $('select#bike_make').val();
       // var year = $('select#bike_year').val();
       // var model = $('select#bike_model').val();
       // var select = $('#sprocket_size');
       // var wheel = $('select#wheel_type').val();
 
       // if (wheel == "REAR") {
       // 	if (model == "CRF250L *REAR*" || model == "CRF250L RALLY *REAR*" || model == "CRF300L *REAR*" || model == "CRF300L Rally *REAR*" || model == "XR650L *REAR*" || model == "XR650R *REAR*" || model == "RMZ250 *REAR*" || model == "DRZ400 S/SE/E *REAR*" || model == "DRZ400 SM *REAR*" || model == "DRZ400 E *REAR*" || model == "KLX400 *REAR*" || make == "TM") {
 
       // 		$("#sprocket_size option[value='no']").remove();
       // 	} else if ((make == "Husqvarna" & year <= 2013) || (make == "GasGas" & year >= 2021)) {
 
       // 		$("#sprocket_size option[value='no']").remove();
       // 	} else {
       // 		var optionExists = ($('#sprocket_size option[value="no"]').length > 0);
 
       // 		if (!optionExists) {
       // 			select.append(' <option value="no">No Sprocket</option>');
       // 		}
 
       // 	}
       // }
   }
 
   function updateSurronImage(){
     var model = $('select#bike_model').val();
     var brake_rotor = $('select#brake_rotor').val();
     
     var image_name ="https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--240mm-fixed-FRONT.png?v=1712646236";
     if($('select#bike_model').val() == 'Ultra Bee *FRONT*' || $('select#bike_model').val() == 'Ultra Bee * REAR *'){          
       switch(brake_rotor) {
         case '240MM_FIXED':
           image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--240mm-fixed-FRONT.png?v=1712646236";
           $('#resultAreaID_1_6 img').attr("src", image_name);
           break;
         case '240MM_FLOATING':
           image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--240mm-floating-FRONT.png?v=1712646236";
           $('#resultAreaID_1_6 img').attr("src", image_name);
           break;
         case '260MM_FLOATING':
           image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--260mm-floating-FRONT.png?v=1712646236";
           $('#resultAreaID_1_6 img').attr("src", image_name);
           break;
         case '300MM_FLOATING':
           image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm--300mm-floating-FRONT.png?v=1712646236";
           $('#resultAreaID_1_6 img').attr("src", image_name);
           break;
       }     
     }
   }

    // bike-make
     $('select#bike_make').change(function() {
 
     var select_model = $('select#bike_model');
 
     $("option:selected", select_model).removeAttr("selected");
     $('select#hidden_bike_model option').appendTo('select#bike_model');
     switch (this.value) {
         default:
         case 'FRONT':
             $('select#bike_model option.rear').appendTo('select#hidden_bike_model');
             break;
         case 'REAR':
             $('select#bike_model option.front').appendTo('select#hidden_bike_model');
             break;
     }
     select_model.val(select_model.find('option').first().val()).change();
 
     $('select#hidden_bike_model').empty();
     switch ($('select#bike_make').val()) {
 
         case 'Husqvarna': //Husqvarna
             models = {
 
                 'TC125 *FRONT*': 'TC125',
                 'TE125 *FRONT*': 'TE125',
                 'TX125 *FRONT*': 'TX125',
                 'TE150 *FRONT*': 'TE150',
                 'CR250 *FRONT*': 'CR250',
                 'FC/TC/FE/TE 250 *FRONT*': 'FC250',
                 'FE250 *FRONT*': 'FE250',
                 'TC250 *FRONT*': 'TC250',
                 'TE250 *FRONT*': 'TE250',
                 'TE250I *FRONT*': 'TE250i',
                 'TXC250 *FRONT*': 'TXC250',
                 'WR250 *FRONT*': 'WR250',
                 'TE300 *FRONT*': 'TE300',
                 'TE300I *FRONT*': 'TE300i',
                 'TX300 *FRONT*': 'TX300',
                 'TX300i *FRONT*': 'TX300i',
                 'WR300 *FRONT*': 'WR300',
                 'TC310 *FRONT*': 'TC310',
                 'TE310 *FRONT*': 'TE310',
                 'TXC310 *FRONT*': 'TXC310',
                 'FC350 *FRONT*': 'FC350',
                 'FE350 *FRONT*': 'FE350',
                 'FX350 *FRONT*': 'FX350',
                 'WR360 *FRONT*': 'WR360',
                 'TE410 *FRONT*': 'TE410',
                 'TC449 *FRONT*': 'TC449',
                 'TE449 *FRONT*': 'TE449',
                 'TXC449 *FRONT*': 'TXC449',
                 'FC450 *FRONT*': 'FC450',
                 'FC450 ROCKSTAR EDITION *FRONT*': 'FC450 ROCKSTAR EDITION',
                 'FE450 *FRONT*': 'FE450',
                 'FX450 *FRONT*': 'FX450',
                 'TC450 *FRONT*': 'TC450',
                 'TE450 *FRONT*': 'TE450',
                 'TXC450 *FRONT*': 'TXC450',
                 'FE501 *FRONT*': 'FE501',
                 'TC510 *FRONT*': 'TC510',
                 'TE510 *FRONT*': 'TE510',
                 'TXC510 *FRONT*': 'TXC510',
                 //'TE511 *FRONT*' : 'TE511',
                 'TXC511 *FRONT*': 'TXC511',
                 'TC570 *FRONT*': 'TC570',
                 'TE570 *FRONT*': 'TE570',
                 'TC610 *FRONT*': 'TC610',
                 'TE610 *FRONT*': 'TE610',
                 'TE630 *FRONT*': 'TE630',
                 '701 Enduro *FRONT*': '701 ENDURO ABS',
 
                 'TC125 *REAR*': 'TC125',
                 'TE125 *REAR*': 'TE125',
                 'TX125 *REAR*': 'TX125',
                 'TE150 *REAR*': 'TE150',
                 'CR250 *REAR*': 'CR250',
                 'FC/TC/FE/TE 250 *REAR*': 'FC250',
                 'FE250 *REAR*': 'FE250',
                 'TC250 *REAR*': 'TC250',
                 'TE250 *REAR*': 'TE250',
                 'TE250I *REAR*': 'TE250i',
                 'SM/TC/TE/TXC 250/450/510/610 *REAR*': 'TXC250',
                 'CR/WR 125-250 *REAR*': 'WR250',
                 'TE300 *REAR*': 'TE300',
                 'TE300I *REAR*': 'TE300i',
                 'TX300 *REAR*': 'TX300',
                 'TX300i *REAR*': 'TX300i',
                 'WR300 *REAR*': 'WR300',
                 'TC310 *REAR*': 'TC310',
                 'TE310 *REAR*': 'TE310',
                 'TXC310 *REAR*': 'TXC310',
                 'FC350 *REAR*': 'FC350',
                 'FE350 *REAR*': 'FE350',
                 'FX350 *REAR*': 'FX350',
                 'WR360 *REAR*': 'WR360',
                 'TE410 *REAR*': 'TE410',
                 'TC/TE 449/511 *REAR*': 'TC449',
                 'TE449 *REAR*': 'TE449',
                 'TXC449 *REAR*': 'TXC449',
                 'FC450 *REAR*': 'FC450',
                 'FC450 ROCKSTAR EDITION *REAR*': 'FC450 ROCKSTAR EDITION',
                 'FE450 *REAR*': 'FE450',
                 'FX450 *REAR*': 'FX450',
                 'TC450 *REAR*': 'TC450',
                 'TE450 *REAR*': 'TE450',
                 'TXC450 *REAR*': 'TXC450',
                 'FE501 *REAR*': 'FE501',
                 'TC510 *REAR*': 'TC510',
                 'TE510 *REAR*': 'TE510',
                 'TXC510 *REAR*': 'TXC510',
                 //'TE511 *REAR*' : 'TE511',
                 'TXC511 *REAR*': 'TXC511',
                 'TC570 *REAR*': 'TC570',
                 'TE570 *REAR*': 'TE570',
                 'TC610 *REAR*': 'TC610',
                 'TE610 *REAR*': 'TE610',
                 'TE630 *REAR*': 'TE630',
                 '701 Enduro *REAR*': '701 ENDURO ABS',
 
 
 
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
 
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Honda': //Honda
             models = {
                 'CR125-CR250 *FRONT*': 'CR125',
                 'CR125-CR250 *FRONT*': 'CR250',
                 'CRF250L *FRONT*': 'CRF250L',
                 'CRF250L ABS *FRONT*': 'CRF250L ABS',
                 'CRF250L RALLY *FRONT*': 'CRF250L RALLY',
                 "CRF250L RALLY ABS *FRONT*": "CRF250L RALLY ABS",
                 'CRF250R *FRONT*': 'CRF250R',
                 'CRF250X *FRONT*': 'CRF250X',
                 'CRF250RX *FRONT*': 'CRF250RX',
                 'CRF300L *FRONT*': 'CRF300L',
                 'CRF300L ABS *FRONT*': 'CRF300L ABS',
                 'CRF300L Rally *FRONT*': 'CRF300L Rally',
                 'CRF300L Rally ABS *FRONT*': 'CRF300L Rally ABS',
                 'XR400 *FRONT*': 'XR400 (No Odometer)',
                 'CRF450R *FRONT*': 'CRF450R',
                 'CRF450R WORKS EDITION *FRONT*': 'CRF450R WORKS EDITION',
                 'CRF450L *FRONT*': 'CRF450L /RL 2019-2026',
                 'CRF450RL *FRONT*': 'CRF450RL',
                 'CRF450X *FRONT*': 'CRF450X',
                 'CRF450RX *FRONT*': 'CRF450RX',
                 'CR500 *FRONT*': 'CR500',
                 'XR650L (No Speedo) *FRONT*': 'XR650L',
                 'XR650R *FRONT*': 'XR650R (No Odometer)',
 
 
 
 
                 'CR125-CR250 *REAR*': 'CR125',
                 'CR125-CR250 *REAR*': 'CR250',
                 'CRF250L *REAR*': 'CRF250L',
                 'CRF250L ABS *REAR*': 'CRF250L ABS',
                 'CRF250L RALLY *REAR*': 'CRF250L RALLY',
                 "CRF250L RALLY ABS *REAR*": "CRF250L RALLY ABS",
                 'CRF250R *REAR*': 'CRF250R',
                 'CRF250X *REAR*': 'CRF250X',
                 'CRF250RX *REAR*': 'CRF250RX',
                 'CRF300L *REAR*': 'CRF300L',
                 'CRF300L ABS *REAR*': 'CRF300L ABS',
                 'CRF300L Rally *REAR*': 'CRF300L Rally',
                 'CRF300L Rally ABS *REAR*': 'CRF300L Rally ABS',
                 'XR4000 *REAR*': 'XR400',
                 'CRF450R *REAR*': 'CRF450R',
                 'CRF450R WORKS EDITION *REAR*': 'CRF450R WORKS EDITION',
                 'CRF450L *REAR*': 'CRF450L /RL 2019-2026',
                 'CRF450RL *REAR*': 'CRF450RL',
                 'CRF450X *REAR*': 'CRF450X',
                 'CRF450RX *REAR*': 'CRF450RX',
                 'CR500 *REAR*': 'CR500',
                 'XR650L *REAR*': 'XR650L',
                 'XR650R *REAR*': 'XR650R',
 
 
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
              brake_rotor = {
                  'fixed': '320mm Fixed',
                  '320MM_FLOATING': '320mm Floating'
              };
              break;
          case 'Yamaha': //Yamaha
             models = {
 
                 'YZ125 *FRONT*': 'YZ125',
                 'YZ125R *FRONT*': 'YZ125R',
                 'YZ250 *FRONT*': 'YZ250',
                 'WR250F *FRONT*': 'WR250F',
                 'YZ250F *FRONT*': 'YZ250F',
                 'YZ250R *FRONT*': 'YZ250R',
                 'WR250R *FRONT*': 'WR250R',
                 'WR250X *FRONT*': 'WR250X',
                 'YZ250X *FRONT*': 'YZ250X',
                 'YZ250FX *FRONT*': 'YZ250FX',
                 'WR400 *FRONT*': 'WR400',
 
                 'YZ426F *FRONT*': 'YZ426F',
                 'WR450F *FRONT*': 'WR450F',
                 'WR426 *FRONT*': 'WR426',
                 'YZ450F *FRONT*': 'YZ450F',
                 'YZ450FX *FRONT*': 'YZ450FX',
 
                 'YZ125 *REAR*': 'YZ125',
                 'YZ250 *REAR*': 'YZ250',
                 'WR250F *REAR*': 'WR250F',
                 'YZ250F *REAR*': 'YZ250F',
                 'WR250R *REAR*': 'WR250R',
                 'WR250X *REAR*': 'WR250X',
                 'YZ250X *REAR*': 'YZ250X',
                 'WR400F *REAR*': 'WR400',
 
                 'YZ426F *REAR*': 'YZ426F',
                 'WR450F *REAR*': 'WR450F',
                 'WR426 *REAR*': 'WR426',
                 'YZ450F *REAR*': 'YZ450F',
                 'YZ450FX *REAR*': 'YZ450FX',
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Kawasaki': //Kawasaki
             models = {
                 'KX125 *FRONT*': 'KX125',
                 'KX250 *FRONT*': 'KX250',
                 'KX250F *FRONT*': 'KX250F',
                 'KX250XC *FRONT*': 'KX250XC',
                 'KLX 300R *FRONT*': 'KLX 300R',
                 'KLX400 *FRONT*': 'KLX400',
                 'KX450F *FRONT*': 'KX450F',
                 'KX450XC *FRONT*': 'KX450XC',
                 'KLX450R *FRONT*': 'KLX450R (No Speedo, uses KX Spacers)',
                 'KLR650 *FRONT*': 'KLR650 (Works with OEM speedo)',
 
                 'KX125 *REAR*': 'KX125',
                 'KX250 *REAR*': 'KX250',
                 'KX250F *REAR*': 'KX250F',
                 'KX250XC *REAR*': 'KX250XC',
                 'KLX 300R *REAR*': 'KLX 300R',
                 'KLX400 *REAR*': 'KLX400',
                 'KX450F *REAR*': 'KX450F',
                 'KX450XC *REAR*': 'KX450XC',
                 'KLX450R *REAR*': 'KLX450R',
                 'KLR650 *REAR* ': 'KLR650 (Works with OEM speedo)'
 
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             // rim_colors = {
             // 	'Silver': 'Silver',
             // 	'White': 'White',
             // 	'Black': 'Black',
             // 	'Matte-Black': 'Matte Black',
             // 	'Red': 'Red',
             // 	'Blue': 'Blue',
             // 	'Orange': 'Orange',
             // 	'Green': 'Green',
             // 	'Gold': 'Gold',
             // 	'Purple': 'Purple',
             // 	'Magnesium': 'Magnesium',
             // 	'Flo-Yellow': 'Flo Yellow'
             // };
           rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'KTM': //KTM
             models = {
               
                 "500 EXC *FRONT*": "500 EXC",
                 "500 EXC-F *FRONT*": "500 EXC-F",
                 "500 XCF-W *FRONT*": "500 XCF-W",
                 "500 XC-W *FRONT*": "500 XC-W",
 
                 "500 EXC *REAR*": "500 EXC",
                 "500 EXC-F *REAR*": "500 EXC-F",
                 "500 XCF-W *REAR*": "500 XCF-W",
                 "500 XC-W *REAR*": "500 XC-W",
               
                 'EXC125 *FRONT*': '125 EXC',
                 'EXC200 *FRONT*': '200 EXC',
                 'EXC-F250 *FRONT*': 'EXC-F250',
                 'EXC300 *FRONT*': '300 EXC',
                 'EXC350 *FRONT*': 'EXC350',
                 'EXC-F350 *FRONT*': '350 EXC-F',
                 'EXC380 *FRONT*': 'EXC380',
                 'EXC400 *FRONT*': '400 EXC',
                 'EXC450 *FRONT*': '450 EXC',
                 'EXC-F450 SIX DAYS *FRONT*': 'EXC-F450 SIX DAYS',
                 'EXC-F500 *FRONT*': 'EXC-F500',
                 'EXC520 *FRONT*': 'EXC520',
                 'EXC525 *FRONT*': 'EXC525',
                 'EXC530 *FRONT*': 'EXC530',
                 'EXC-R530 *FRONT*': 'EXC-R530',
                 'XC150 *FRONT*': '150 XC',
                 'XC-W150 *FRONT*': '150 XC-W',
                 'XC200 *FRONT*': '200 XC',
                 'XC-W200 *FRONT*': '200 XC-W',
                 'XC250 *FRONT*': '250 XC',
                 'XC250 TPI *FRONT*': 'XC250 TPI',
                 'XC-W250 *FRONT*': '250 XC-W',
                 'XC-W250 TPI *FRONT*': 'XC-W250 TPI',
                 'XC-F250 *FRONT*': '250 XC-F',
                 'XCF-W250 *FRONT*': '250 XCF-W',
                 'XC300 *FRONT*': '300 XC',
                 'XC300 TPI *FRONT*': 'XC300 TPI',
                 'XC-W300 *FRONT*': '300 XC-W',
                 'XC-W300 TPI *FRONT*': 'XC-W300 TPI',
                 'XC-W300 TPI SIX DAYS *FRONT*': 'XC-W300 TPI SIX DAYS',
                 'XC-F350 *FRONT*': '350 XC-F',
                 'XCF-W350 *FRONT*': '350 XCF-W',
                 'XC400 *FRONT*': 'XC400',
                 'XC-W400 *FRONT*': 'XC-W400',
                 'XC-F450 *FRONT*': '450 XC-F',
                 'XC450 *FRONT*': 'XC450',
                 'XC-W450 *FRONT*': '400 XC-W',
                 'XC-W500 *FRONT*': 'XC-W500',
                 'XC-F505 *FRONT*': 'XC-F505',
                 'XC525 *FRONT*': 'XC525',
                 'XC-W525 *FRONT*': 'XC-W525',
                 'XC530 *FRONT*': 'XC530',
                 'XC-W530 *FRONT*': 'XC-W530',
                 'SX125 *FRONT*': '125 SX',
                 'SX144 *FRONT*': '144 SX',
                 'SX150 *FRONT*': '150 SX',
                 'SX200 *FRONT*': '200 SX',
                 'SX250 *FRONT*': '250 SX',
                 'SXF250 *FRONT*': 'SXF250',
                 'SXF350 *FRONT*': 'SXF350',
                 'SX380 *FRONT*': 'SX380',
                 'SX400 *FRONT*': 'SX400',
                 'SXC400 *FRONT*': 'SXC400',
                 'SX450 *FRONT*': '450 SX',
                 'SX-RFS450 *FRONT*': 'SX-RFS450',
                 'SX-F450 *FRONT*': '450 SX-F',
                 'SX-F450 FACTORY EDITION *FRONT*': '450 SX-F FACTORY EDITION',
                 'SX-F505 *FRONT*': 'SX-F505',
                 'SX520 *FRONT*': 'SX520',
                 'SX525 *FRONT*': 'SX525',
                 'SXC625 *FRONT*': 'SXC625',
                 '690 ENDURO *FRONT*': '690 R',
                 '690 ENDURO ABS *FRONT*': '690 Enduro ABS',
                 '790 Adventure *FRONT*': '790 Adventure',
                 '790 Adventure R *FRONT*': '790 Adventure R',
                 '890 Adventure *FRONT*': '890 Adventure',
                 '890 Adventure R *FRONT*': '890 Adventure R',
                 '1090 Adventure R *FRONT*': '1090 Adventure R',
                 '1190 Adventure *FRONT*': '1190 Adventure',
                 '1290 Adventure *FRONT*': '1290 Adventure',
                 '1290 Super Adventure R *FRONT*': '1290 Super Adventure R',
                 '1290 Super Adventure S *FRONT*': '1290 Super Adventure S',
 
 
                 'EXC125 *REAR*': '125 EXC',
                 'EXC200 *REAR*': '200 EXC',
                 'EXC-F250 *REAR*': 'EXC-F250',
                 'EXC300 *REAR*': '300 EXC',
                 'EXC350 *REAR*': 'EXC350',
                 'EXC-F350 *REAR*': '350 EXC-F',
                 'EXC380 *REAR*': 'EXC380',
                 'EXC400 *REAR*': '400 EXC',
                 'EXC450 *REAR*': '450 EXC',
                 'EXC-F450 SIX DAYS *REAR*': 'EXC-F450 SIX DAYS',
                 'EXC-F500 *REAR*': 'EXC-F500',
                 'EXC520 *REAR*': 'EXC520',
                 'EXC525 *REAR*': 'EXC525',
                 'EXC530 *REAR*': 'EXC530',
                 'EXC-R530 *REAR*': 'EXC-R530',
                 'XC150 *REAR*': '150 XC',
                 'XC-W150 *REAR*': '150 XC-W',
                 'XC200 *REAR*': '200 XC',
                 'XC-W200 *REAR*': '200 XC-W',
                 'XC250 *REAR*': '250 XC',
                 'XC250 TPI *REAR*': 'XC250 TPI',
                 'XC-W250 *REAR*': '250 XC-W',
                 'XC-W250 TPI *REAR*': 'XC-W250 TPI',
                 'XC-F250 *REAR*': '250 XC-F',
                 'XC300 *REAR*': '300 XC',
                 'XC300 TPI *REAR*': 'XC300 TPI',
                 'XC-W300 *REAR*': '300 XC-W',
                 'XCF-W250 *REAR*': '250 XCF-W',
                 'XC-W300 TPI *REAR*': 'XC-W300 TPI',
                 'XC-W300 TPI SIX DAYS *REAR*': 'XC-W300 TPI SIX DAYS',
                 'XC-F350 *REAR*': '350 XC-F',
                 'XCF-W350 *REAR*': '350 XCF-W',
                 'XC400 *REAR*': 'XC400',
                 'XC-W400 *REAR*': 'XC-W400',
                 'XC-F450 *REAR*': '450 XC-F',
                 'XC450 *REAR*': 'XC450',
                 'XC-W450 *REAR*': '400 XC-W',
                 'XC-W500 *REAR*': 'XC-W500',
                 'XC-F505 *REAR*': 'XC-F505',
                 'XC525 *REAR*': 'XC525',
                 'XC-W525 *REAR*': 'XC-W525',
                 'XC530 *REAR*': 'XC530',
                 'XC-W530 *REAR*': 'XC-W530',
                 'SX125 *REAR*': '125 SX',
                 'SX144 *REAR*': '144 SX',
                 'SX150 *REAR*': '150 SX',
                 'SX200 *REAR*': '200 SX',
                 'SX250 *REAR*': '250 SX',
                 'SXF250 *REAR*': 'SXF250',
                 'SXF350 *REAR*': 'SXF350',
                 'SX380 *REAR*': 'SX380',
                 'SX400 *REAR*': 'SX400',
                 'SXC400 *REAR*': 'SXC400',
                 'SX450 *REAR*': '450 SX',
                 'SX-RFS450 *REAR*': 'SX-RFS450',
                 'SX-F450 *REAR*': '450 SX-F',
                 'SX-F450 FACTORY EDITION *REAR*': '450 SX-F FACTORY EDITION',
                 'SX-F505 *REAR*': 'SX-F505',
                 'SX520 *REAR*': 'SX520',
                 'SX525 *REAR*': 'SX525',
                 'SXC625 *REAR*': 'SXC625',
                 '690 ENDURO * REAR *': '690 R',
                 '690 ENDURO ABS * REAR *': '690 Enduro ABS',
                 '790 Adventure *REAR*': '790 Adventure',
                 '790 Adventure R *REAR*': '790 Adventure R',
                 '890 Adventure *REAR*': '890 Adventure',
                 '890 Adventure R *REAR*': '890 Adventure R',
                 '1090 Adventure R *REAR*': '1090 Adventure R',
                 '1190 Adventure *REAR*': '1190 Adventure',
                 '1290 Adventure *REAR*': '1290 Adventure',
                 '1290 Super Adventure R *REAR*': '1290 Super Adventure R',
                 '1290 Super Adventure S *REAR*': '1290 Super Adventure S'
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Stark': //Stark
             models = {
                 'Varg *FRONT*': 'Varg',
 
 
                 'Varg *REAR*': 'Varg',
 
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Suzuki': // SUZUKI
             models = {
                 'DRZ400 S/SE/E *FRONT*': 'DRZ400 S',
                 'DRZ400 SE *FRONT*': 'DRZ400 SE',
                 'DRZ400 SM *FRONT*': 'DRZ400 SM',
                 'DRZ400 E *FRONT*': 'DRZ400 E',
                 'DR650 *FRONT*': 'DR650',
                 'RMX450 *FRONT*': 'RMX450',
                 'RMZ250 *FRONT*': 'RMZ250',
                 'RMZ450 *FRONT*': 'RMZ450',
 
                 'DRZ400 S/SE/E *REAR*': 'DRZ400 S',
                 'DRZ400 SE *REAR*': 'DRZ400 SE',
                 'DRZ400 SM *REAR*': 'DRZ400 SM',
                 'DRZ400 E *REAR*': 'DRZ400 E',
                 'DR650 *REAR*': 'DR650',
                 'RMX450 *REAR*': 'RMX450',
                 'RMZ250 *REAR*': 'RMZ250',
                 'RMZ450 *REAR*': 'RMZ450',
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Husaberg': //Husaberg
             models = {
                 'FC *FRONT*': 'FC',
                 'FE *FRONT*': 'FE',
                 'All FE /FC Models *REAR*': 'FC',
                 'FE *REAR*': 'FE'
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'GasGas': //Gas Gas
             models = {
                 'EC250-EC450 *FRONT*': 'EC125',
                 'EC200 *FRONT*': 'EC200',
                 'EC250 *FRONT*': 'EC250',
                 'EC250 2T *FRONT*': 'EC250 2T',
                 'EC250 4T *FRONT*': 'EC250 4T',
                 'EC300 *FRONT*': 'EC300',
                 'EC450 *FRONT*': 'EC450',
                 'Gas EC200 RANGER *FRONT*': 'EC200 RANGER',
                 'Gas EC250 SIX DAYS *FRONT*': 'EC250 SIX DAYS',
                 'Gas EC300 RANGER *FRONT*': 'EC300 RANGER',
                 'Gas EC300 SIX DAYS *FRONT*': 'EC300 SIX DAYS',
                 'Gas XC200 *FRONT*': 'XC200',
                 'Gas XC250 *FRONT*': 'XC250',
                 'Gas XC300 *FRONT*': 'XC300',					
                 "ES500 *FRONT*": "ES500",
 
                 'EC250-EC450 *REAR*': 'EC125',
                 'EC200 *REAR*': 'EC200',
                 'EC250 *REAR*': 'EC250',
                 'EC250 2T *REAR*': 'EC250 2T',
                 'EC250 4T *REAR*': 'EC250 4T',
                 'EC300 *REAR*': 'EC300',
                 'EC450 *REAR*': 'EC450',
                 'Gas EC200 RANGER *REAR*': 'EC200 RANGER',
                 'Gas EC250 SIX DAYS *REAR*': 'EC250 SIX DAYS',
                 'Gas EC300 RANGER *REAR*': 'EC300 RANGER',
                 'Gas EC300 SIX DAYS *REAR*': 'EC300 SIX DAYS',
                 'Gas XC200 *REAR*': 'XC200',
                 'Gas XC250 *REAR*': 'XC250',
                 'Gas XC300 *REAR*': 'XC300',
                 "ES500 *REAR*": "ES500",
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 //'Front 21x1.60' : 'Front 21x1.60',
                 //'Front 18x2.15' : 'Front 18x2.15',
                 //'Front 19x2.15' : 'Front 19x2.15'
             };
             brake_rotor = {
                 '320MM_FIXED': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
 
         case 'BMW': //BMW
             models = {
                 '450X *FRONT*': '450X',
                 '450X *REAR*': '450X'
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': '17x3.50',
                 'FRONT 16.5x3.50': '16.5x3.50',
             };
             brake_rotor = {
                 'fixed': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
         case 'Beta': //Beta
             models = {
                 'RR *FRONT*': 'RR',
                 'RS *FRONT*': 'RS',
                 'RR *REAR*': 'RR',
                 'RS *REAR*': 'RS'
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': 'FRONT 17x3.50',
             };
             brake_rotor = {
                 '320MM_FIXED': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
 
         case 'Sherco': //Sherco
             models = {
                 '125-300 SE-R *FRONT*': 'SE',
                 '250-450 SEF-R *FRONT*': 'SEF',
                 '250-450 SER *FRONT*': 'SER',
 
                 '125-300 SE-R * REAR *': 'SE',
                 '250-450 SEF-R * REAR *': 'SEF',
                 '250-450 SER * REAR *': 'SER',
 
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 21x1.60': 'FRONT 21x1.60',
             };
             brake_rotor = {
                 '320mm_FIXED': '320mm Fixed',
                 '320mm_FLOATING': '320mm Floating'
             };
             break;
         case 'Surron': //Surron
             models = {
                 'Ultra Bee *FRONT*': 'Ultra Bee',
                 'Ultra Bee * REAR *': 'Ultra Bee'
             };
             hub_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Gold': 'Gold',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
 
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.00': 'FRONT 17x3.30'
             };
             brake_rotor = {
                 '240MM_FIXED': '240mm x 2.3 Fixed',
                 '240MM_FLOATING': '240mm Blue Button Floating Rotor',
                 '260MM_FLOATING': '260mm Blue Button Floating Rotor with bracket',
                 '300MM_FLOATING': '300mm Blue Button Floating Rotor with bracket'
             };
             break;
         case 'Alta Redshift': //Alta Redshift
             models = {
                 'All years and models *FRONT': 'MX',
                 'Enduro *FRONT': 'Enduro',
                 'All years and models * REAR *': 'MX',
                 'Enduro * REAR *': 'Enduro',
 
 
             };
             hub_colors = {
                 'Silver': 'Silver',
 
             };
             rim_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',            
                 'Gold': 'Gold',
                 'Magnesium': 'Magnesium',
                 'Orange': 'Orange',
                 'Purple': 'Purple',
                 'Red': 'Red',            
                 'PBlue': 'PBlue',            
                 'Baby-Blue': 'Baby-Blue',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Grey': 'Nardo Grey',
                 'Yellow': 'Yellow',
                 'White': 'White',
                 'Army-Green': 'army-green',            
                 'Coyote-Tan': 'coyote-tan',            
                 'Teal': 'teal',            
                 'Illusion-Violet': 'illusion-violet'
             
             };
             spoke_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Blue': 'Blue',
                 'Green': 'Green',
                 'Orange': 'Orange',
                 'Red': 'Red',
                 'White': 'White',
                 'Yellow': 'Yellow',
                 'Flo-Yellow': 'Flo Yellow',
                 'Nardo-Gray': 'Nardo Grey'
             };
             nipple_colors = {
                 'Silver': 'Silver',
                 'Black': 'Black',
                 'Red': 'Red',
                 'Blue': 'Blue',
                 'Orange': 'Orange',
                 'Green': 'Green',
                 'Gold': 'Gold',
                 'Purple': 'Purple',
                 'Magnesium': 'Magnesium'
             };
             rim_size = {
                 'FRONT 17x3.50': 'FRONT 17x3.50',
                 'FRONT 16.5x3.50': 'FRONT 16.5x3.50',
             };
             brake_rotor = {
                 '320MM_FIXED': '320mm Fixed',
                 '320MM_FLOATING': '320mm Floating'
             };
             break;
     }
 
     var model_element = $('#bike_model');
     var rim_size_element = $('#rim_size');
     var brake_rotor_element = $('#brake_rotor');
     var sprocket_size_element = $('#sprocket_size')
 
     var model_select = model_element.prop('options');
     var rim_size_select = rim_size_element.prop('options');
     var brake_rotor_select = brake_rotor_element.prop('options');
     var sprocket_size_select = sprocket_size_element.prop('options');
 
     $('option', model_element).remove();
     $('option', rim_size_element).remove();
     $('option', brake_rotor_element).remove();
 
     //// console.log("Model : ", {models});
 
     $.each(models, function(val, text) {
         var new_opt = new Option(text, val);
 
         model_select[model_select.length] = new_opt;
         if (val.indexOf('*FRONT') != -1 || text.indexOf('*FRONT') != -1)
             new_opt.className = 'front';
         else
             new_opt.className = 'rear';
     });
       
     if ($('select#wheel_type').val() == 'REAR') {
         $('select#bike_model option.front').appendTo('select#hidden_bike_model');
         /* rim_size = {
                         'REAR 18x2.15' : 'REAR 18x2.15',
                         'REAR 19x2.15' : 'REAR 19x2.15'
                     };*/
     } else
 
     {
         $('select#bike_model option.rear').appendTo('select#hidden_bike_model');
     }
     // color append function start
     var hubColorsSelect = $("#hub_colors_select"); // Assuming you have a select element with the id 'hub_colors_select'
     var hubColorWrapper = $(".hub_color_wrapper");
     var hiddenInput = $("#hub_color");
     hubColorWrapper.empty();
   
     $.each(hub_colors, function (index, colorValue) {
             const formattedColor = colorValue.replace(" ", "-").toLowerCase();
       // Create a new color swatch element
       var colorSwatch = $("<div>", {
         class: "color-swatch",
         "data-value": colorValue.replace(" ", "-"),
         style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
         title: colorValue
       });
       hubColorWrapper.append(colorSwatch);
   
       colorSwatch.on("click", function () {
         hubColorWrapper.find(".color-swatch").removeClass("active");
         $(this).addClass("active");
         hiddenInput.val(colorValue);
       });
     });
 
     $(".hub_color_wrapper .color-swatch:first").click();
     var initialColorValue = hiddenInput.val();
     hubColorWrapper
       .find('.color-swatch[data-value="' + initialColorValue + '"]')
       .addClass("active");
 
   var anodizedRim = ['silver', 'blue', 'black', 'gold','magnesium', 'orange', 'red', 'green', 'purple' ];
   var powderCoatedRim = [];
 
     // color append function start
   var rimColorsSelect = $("#rim_colors_select"); // Assuming you have a select element with the id 'rim_colors_select'
   var rimColorWrapper = $(".rim_color_wrapper");
   var hiddenInput = $("#rim_color");
   rimColorWrapper.empty();
   $.each(rim_colors, function (index, colorValue) {
         const formattedColor = colorValue.replace(" ", "-").toLowerCase();
     // Create a new color swatch element
     var colorname = colorValue.toLowerCase();
     var dataCategory = anodizedRim.includes(colorname) ? "anodized" : "powder-coat"; 
     // //// console.log({dataCategory});
     var colorSwatch = $("<div>", {
       class: "color-swatch",
       "data-value": colorValue.replace(" ", "-"),
       "data-category": dataCategory,
       style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
       title: colorValue
     });
     rimColorWrapper.append(colorSwatch);
 
     colorSwatch.on("click", function () {
       rimColorWrapper.find(".color-swatch").removeClass("active");
       $(this).addClass("active");
       hiddenInput.val(colorValue);
     });
   });
 
   $(".rim_color_wrapper .color-swatch:first").click();
   var initialColorValue = hiddenInput.val();
   rimColorWrapper
     .find('.color-swatch[data-value="' + initialColorValue + '"]')
     .addClass("active");
   // color append function end
       
     // color append function start
   var spokeColorsSelect = $("#spoke_colors_select"); // Assuming you have a select element with the id 'spoke_colors_select'
   var spokeColorWrapper = $(".spoke_color_wrapper");
   var hiddenInput = $("#spoke_color");
   spokeColorWrapper.empty();
 
   $.each(spoke_colors, function (index, colorValue) {
         const formattedColor = colorValue.replace(" ", "-").toLowerCase();
     // Create a new color swatch element
     var colorSwatch = $("<div>", {
       class: "color-swatch",
       "data-value": colorValue.replace(" ", "-"),
       style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
       title: colorValue
     });
     spokeColorWrapper.append(colorSwatch);
 
     colorSwatch.on("click", function () {
       spokeColorWrapper.find(".color-swatch").removeClass("active");
       $(this).addClass("active");
       hiddenInput.val(colorValue);
     });
   });
   $(".spoke_color_wrapper .color-swatch:first").click();
   var initialColorValue = hiddenInput.val();
   spokeColorWrapper
     .find('.color-swatch[data-value="' + initialColorValue + '"]')
     .addClass("active");
   // color append function end
       
     // color append function start
   var nippleColorsSelect = $("#nipple_colors_select"); // Assuming you have a select element with the id 'nipple_colors_select'
   var nippleColorWrapper = $(".nipple_color_wrapper");
   var hiddenInput = $("#nipple_color");
   nippleColorWrapper.empty();
 
   $.each(nipple_colors, function (index, colorValue) {
         const formattedColor = colorValue.replace(" ", "-").toLowerCase();
     // Create a new color swatch element
     var colorSwatch = $("<div>", {
       class: "color-swatch",
       "data-value": colorValue.replace(" ", "-"),
       style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
       title: colorValue
     });
     nippleColorWrapper.append(colorSwatch);
 
     colorSwatch.on("click", function () {
       nippleColorWrapper.find(".color-swatch").removeClass("active");
       $(this).addClass("active");
       hiddenInput.val(colorValue);
     });
   });
   $(".nipple_color_wrapper .color-swatch:first").click();
   var initialColorValue = hiddenInput.val();
   nippleColorWrapper
     .find('.color-swatch[data-value="' + initialColorValue + '"]')
     .addClass("active");
   // color append function end
       
     var rimSizeSelect = $("select#rim_size");
   //// console.log({rim_size});
   $.each(rim_size, function (value, text) {
     // Create a new option element and append it to the select element
     rimSizeSelect.append(
       $("<option>", {
         value: value,
         text: text,
       })
     );
   });
       
     var brakeRotorSelect = $("select#brake_rotor");
     // console.log(brake_rotor)
     $.each(brake_rotor, function (value, text) {
       // Create a new option element and append it to the select element
       brakeRotorSelect.append(
         $("<option>", {
           value: value,
           text: text,
         })
       );
   });
     
 
     // var select = $('#wheel_type');
     // select.empty().append('<option class="category" value="FRONT">Front</option><option class="category" value="REAR">Rear</option>');
 
     $('#wheel_type').trigger('change')
     var image_name = images+"hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
     var imageArr1 = [image_name];
     var divArr1 = ["resultAreaID_1_0"];
     $('#resultAreaID_1_0 img').attr('src', image_name);
 
     var image_name = images+"rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
     var imageArr2 = [image_name];
     var divArr2 = ["resultAreaID_1_1"];
     $('#resultAreaID_1_1 img').attr('src', image_name);
 
     var image_name = images+"spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
     var imageArr3 = [image_name];
     var divArr3 = ["resultAreaID_1_2"];
     $('#resultAreaID_1_2 img').attr('src', image_name);
 
     var image_name = images+"nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
     var imageArr4 = [image_name];
     var divArr4 = ["resultAreaID_1_3"];
     $('#resultAreaID_1_3 img').attr('src', image_name);
 
     if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
         var image_name = images+"dual-rotor-" + $('select#wheel_type').val() + ".png";
         var imageArr5 = [image_name];
         var divArr5 = ["resultAreaID_1_6"];
         //// console.log({image_name});
         $('#resultAreaID_1_6 img').attr('src', image_name);
     } else if($('select#bike_make').val() == 'Surron'){
       updateSurronImage()
     }else{
       
     }
     
     // //// console.log($('select#wheel_type').val());
     if ($('select#wheel_type').val() == 'REAR') {
         // $('#sprocket').show();
         sprockethide();
         if ($('#speedometer').css('display') != 'none') {
             $("#sm_magnets").val(1);
             if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
                 $("#resultAreaID_1_7").show();
                 var image_name = images+"magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
                 var imageArr6 = [image_name];
                 $('#resultAreaID_1_7 img').attr('src', image_name);
                 // var divArr6 = ["resultAreaID_1_7"];
                 // $('#resultAreaID_1_7 img').attr('src',image_name);
             } else if ($("select#sm_magnets").val() == "NO") {
                 $("#resultAreaID_1_7").hide();
             } else {
                 var image_name = images+"sprocket.png";
                 var imageArr6 = [image_name];
                 var divArr6 = ["resultAreaID_1_7"];
                 $('#resultAreaID_1_7 img').attr('src', image_name);
                 $('#resultAreaID_1_7 img').attr('src',image_name);
             }
         } else {
             if ($('select#wheel_type').val() == 'FRONT') {
                 $('#resultAreaID_1_7').hide();
             } else {
                 var image_name = images+"sprocket.png";
                 var imageArr7 = [image_name];
                 var divArr7 = ["resultAreaID_1_7"];
                 $('#resultAreaID_1_7 img').attr('src', image_name);
                 // imageObj7 = new BL_ImageLoader(divArr7, imageArr7);
             }
         }
 
 
     } else {
         // $('#sprocket').hide();
         // $('#resultAreaID_1_7').hide();
     }
 
 
     if ($('select#rim_size').val() == 'FRONT 16.5x3.50') {
         var select = $('#rim_color');
         select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option>');
         var image_name = images+"rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr2 = [image_name];
         var divArr2 = ["resultAreaID_1_1"];
         $('#resultAreaID_1_1 img').attr('src', image_name);
         // $('#resultAreaID_1_1 img').attr('src', image_name );
     } else {
         var select = $('#rim_color');
         select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="POrange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
     }
 
     if ($('select#bike_make').val() == 'Kawasaki') {
         if ($('select#bike_model').val() == 'KX125 *FRONT*') {
             var select = $('#brake_rotor');
             select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
         } else {
             if ($('select#bike_make').val() === "GasGas") {
                 gasgasbrakeremove();
             } else {
                 var select = $('#brake_rotor');
                 select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
             }
         }
     }
     if ($('select#bike_make').val() == 'Yamaha') {
         if ($('select#bike_model').val() == 'YZ125 *FRONT*') {
             var select = $('#brake_rotor');
             select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
         } else {
             if ($('select#bike_make').val() === "GasGas") {
                 gasgasbrakeremove();
             } else {
                 var select = $('#brake_rotor');
                 select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
             }
         }
     }
 
     
     if ($('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Husqvarna") {
         if ($('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "701 Enduro *REAR*") {
             // $('#sprocket').css("display", "block");
         }
         var select = $('#sprocket_size');
         // select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option>');
 
     }
     /*else {
     var select = $('#sprocket_size');
     select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option>');
     }*/
     if ($('select#wheel_type').val() == 'FRONT') {
         $('#brake_rotor').prop("disabled", false);
     } else {
         //$('#brake_rotor').prop("disabled", true);
     }
     if ($('select#wheel_type').val() === "REAR") {
         $('#brake-rotor-tr').hide();
     } else {
         $('#brake-rotor-tr').show();
     }
     var bike_make = $('select#bike_make').val();
     if ($('select#bike_model').val() == "SM/TC/TE/TXC 250/449/450/510/610 *FRONT*" || $('select#bike_model').val() == "TXC250 *FRONT*" || $('select#bike_model').val() == "WR250 *FRONT*" || $('select#bike_model').val() == "TX300 *FRONT*" || $('select#bike_model').val() == "WR300 *FRONT*" || $('select#bike_model').val() == "TC310 *FRONT*" || $('select#bike_model').val() == "TE310 *FRONT*" || $('select#bike_model').val() == "TXC310 *FRONT*" || $('select#bike_model').val() == "FE350 *FRONT*" || $('select#bike_model').val() == "FX350 *FRONT*" || $('select#bike_model').val() == "WR360 *FRONT*" || $('select#bike_model').val() == "TE410 *FRONT*" || $('select#bike_model').val() == "TC449 *FRONT*" || $('select#bike_model').val() == "TE449 *FRONT*" || $('select#bike_model').val() == "FE450 *FRONT*" || $('select#bike_model').val() == "FX450 *FRONT*" || $('select#bike_model').val() == "TC450 *FRONT*" || $('select#bike_model').val() == "TE450 *FRONT*" || $('select#bike_model').val() == "TXC450 *FRONT*" || $('select#bike_model').val() == "TC510 *FRONT*" || $('select#bike_model').val() == "TE510 *FRONT*" || $('select#bike_model').val() == "TXC510 *FRONT*" || $('select#bike_model').val() == "TE511 *FRONT*" || $('select#bike_model').val() == "TXC511 *FRONT*" || $('select#bike_model').val() == "TC570 *FRONT*" || $('select#bike_model').val() == "TE570 *FRONT*" || $('select#bike_model').val() == "TC610 *FRONT*" || $('select#bike_model').val() == "TE610 *FRONT*" || $('select#bike_model').val() == "TE630 *FRONT*" || $('select#bike_model').val() == "SM/TC/TE/TXC 250/450/510/610 *REAR*" || $('select#bike_model').val() == "TX300 *REAR*" || $('select#bike_model').val() == "WR300 *REAR*" || $('select#bike_model').val() == "TC310 *REAR*" || $('select#bike_model').val() == "TE310 *REAR*" || $('select#bike_model').val() == "FC350 *REAR*" || $('select#bike_model').val() == "FE350 *REAR*" || $('select#bike_model').val() == "FX350 *REAR*" || $('select#bike_model').val() == "WR360 *REAR*" || $('select#bike_model').val() == "TE410 *REAR*" || $('select#bike_model').val() == "FE450 *REAR*" || $('select#bike_model').val() == "FX450 *REAR*" || $('select#bike_model').val() == "TC450 *REAR*" || $('select#bike_model').val() == "TE450 *REAR*" || $('select#bike_model').val() == "TXC450 *REAR*" || $('select#bike_model').val() == "TC510 *REAR*" || $('select#bike_model').val() == "TE510 *REAR*" || $('select#bike_model').val() == "TXC510 *REAR*" || $('select#bike_model').val() == "TC570 *REAR*" || $('select#bike_model').val() == "TE570 *REAR*" || $('select#bike_model').val() == "TC610 *REAR*" || $('select#bike_model').val() == "TE610 *REAR*" || $('select#bike_model').val() == "TC/TE 449/511 *REAR*" || $('select#bike_model').val() == "TE449 *REAR*" || $('select#bike_model').val() == "TXC449 *REAR*" || $('select#bike_model').val() == "TE511 *REAR*" || $('select#bike_model').val() == "TXC511 *REAR*" || $('select#bike_model').val() == "CR/WR 125-250 *REAR*") {
         // $('#rotor_bolt').css("display", "none"); 
     } else if (bike_make == "KTM" || bike_make == "Husqvarna" || bike_make == "Honda" || bike_make == "Yamaha" || bike_make == "BMW" || bike_make == "GasGas" || bike_make == "Husaberg" || bike_make == "Sherco" || bike_make == "TM") {
         $('#rotor_bolt').css("display", "block");
     } else {
         if (bike_make == "Kawasaki" || bike_make == "Suzuki") {
             if ($('select#bike_model').val() == "KX250F *FRONT*" || $('select#bike_model').val() == "KX250XC *FRONT*" || $('select#bike_model').val() == "KX450F *FRONT*" || $('select#bike_model').val() == "KX450XC *FRONT*" || $('select#bike_model').val() == "KLX 300R *FRONT*" || $('select#bike_model').val() == "KX250F *REAR*" || $('select#bike_model').val() == "KX250XC *REAR*" || $('select#bike_model').val() == "KX450F *REAR*" || $('select#bike_model').val() == "KX450XC *REAR*" || $('select#bike_model').val() == "KLX 300R *REAR*" || $('select#bike_model').val() == "KX125 *FRONT*" || $('select#bike_model').val() == "KX250 *FRONT*" || $('select#bike_model').val() == "KLX450R *FRONT*" || $('select#bike_model').val() == "KX125 *REAR*" || $('select#bike_model').val() == "KX250 *REAR*" || $('select#bike_model').val() == "KLX450R *REAR*" || $('select#bike_model').val() == "DR650 *FRONT*" || $('select#bike_model').val() == "DR650 *REAR*") {
                 $('#rotor_bolt').css("display", "block");
             } else {
                 $('#rotor_bolt').css("display", "none");
             }
         }
     }
     if ($('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* ") {
         $('#sprocketbolts').css("display", "none");
 
     } else {
 
         if ($('select#wheel_type').val() == "FRONT") {
             $('#sprocketbolts').css("display", "none");
         } else if ($('select#wheel_type').val() == "REAR") {
 
             $('#sprocketbolts').css("display", "block");
 
         } else {
             $('#sprocketbolts').css("display", "block");
         }
     }
     if ($('select#wheel_type').val() == 'FRONT')
 
     {
         $('#cush_drive1').hide();
     } else {
         $('#cush_drive1').show();
     }
     if ($('select#bike_model').val() == "CRF250L *FRONT*" || $('select#bike_model').val() == "CRF300L *FRONT*" || $('select#bike_model').val() == "CRF300L ABS *FRONT*" || $('select#bike_model').val() == "CRF300L Rally *FRONT*" || $('select#bike_model').val() == "CRF300L Rally ABS *FRONT*" || $('select#bike_model').val() == "CRF250L ABS *FRONT*" || $('select#bike_model').val() == "CRF250L *REAR*" || $('select#bike_model').val() == "CRF300L *REAR*" || $('select#bike_model').val() == "CRF300L ABS *REAR*" || $('select#bike_model').val() == "CRF300L Rally *REAR*" || $('select#bike_model').val() == "CRF300L Rally ABS *REAR*" || $('select#bike_model').val() == "CRF250L ABS *REAR*") {
         //$('#rotor_bolt').css("display", "none");
     }
 
     if ($('#speedometer').css('display') != 'none') {
         $("#sm_magnets").val(1);
         if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
             $("#resultAreaID_1_7").show();
             var image_name = images+"magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
             var imageArr6 = [image_name];
             var divArr6 = ["resultAreaID_1_7"];
             $('#resultAreaID_1_7 img').attr('src', image_name);
             // $('#resultAreaID_1_7 img').attr('src',image_name);
         } else if ($("select#sm_magnets").val() == "NO") {
             $("#resultAreaID_1_7").hide();
         } else {
             var image_name = images+"sprocket.png";
             var imageArr6 = [image_name];
             var divArr6 = ["resultAreaID_1_7"];
             $('#resultAreaID_1_7 img').attr('src', image_name);
         }
     } else {
         if ($('select#wheel_type').val() == 'FRONT') {
             $('#resultAreaID_1_7').hide();
         } else {
             var image_name = images+"sprocket.png";
             var imageArr7 = [image_name];
             var divArr7 = ["resultAreaID_1_7"];
             $('#resultAreaID_1_7 img').attr('src', image_name);
         }
     }
     $('#rotor_bolts').prop('selectedIndex', 0);
     if ($('select#wheel_type').val() === "REAR") {
         $('#brake-rotor-tr').hide();
     } else {
         $('#brake-rotor-tr').show();
     }
 
     //Mounted/Balanced Tire Field Code	
     //$('select#mbtire').val("mbno");
     if ($('select#mbtire').val() == "mbno") {
         $('#resultAreaID_1_10').hide();
         $('#resultAreaID_1_8').hide();
     }
 
       
 
    
 
     if ($('select#rim_size').val() === "FRONT 17x3.50" || $('select#rim_size').val() === "FRONT 17x3.00" || $('select#rim_size').val() === "REAR 17x4.25" || $('select#rim_size').val() === "REAR 17x5.00") {
       if( $('select#bike_model').val()  == "Ultra Bee *FRONT*"){
         $('#mbtire').empty();
         $('#mbtire').append($('<option>').val('mbno').text('No'));
         $('#mbtire').append($('<option>').val('mbyes').text('Michelin Pilot Power 2CT 110/70ZR17'));
         $('#mbtiretr').show();
       }else{
         $('#mbtire').empty();
         $('#mbtire').append($('<option>').val('mbno').text('No'));
         $('#mbtire').append($('<option>').val('DG300').text('Dunlop Dunlop Sportmax GPR-300'));
         $('#mbtire').append($('<option>').val('mbyes').text('Michelin Pilot Power 2CT 110/70ZR17'));
         $('#mbtiretr').show();
       }
       
       
         var image_name = images+"SM-" + $("select#wheel_type").val() + "-tire650.png";
         var imageArr9 = [image_name];
         var divArr9 = ["resultAreaID_1_10"];
         // imageObj9 = new BL_ImageLoader(divArr9, imageArr9);
         $('#resultAreaID_1_9 img').attr('src', image_name);
         if ($('select#mtl').val() != "No") {
             $('#mbtire').prop('selectedIndex', 0);
             // $('#mbtire option').eq(2).remove();
             $('#mbtiretr').show();
         } else {
             if (!$('#mbtire option').filter('[value="mbno"]').length) {
                 $('#mbtire').append($('<option>').val('mbno').text('No'));
             }
             $('select#mbtire').val("mbno");
         }
         if ($('select#mbtire').val() === "mbyes") {
 
         }
     } else {
         $('#mbtiretr').hide();
         $('select#mbtire').val("mbno");
 
     }
 
 
 
     //Titanium Spoke Color Code
     //Bike Make 
     if ($('select#bike_make').val() == "Beta" || $('select#bike_make').val() == "GasGas" || $('select#bike_make').val() == "Husaberg" || $('select#bike_make').val() == "TM" || $('select#bike_make').val() == "Husqvarna" || $('select#bike_make').val() == "Honda" || $('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Yamaha") {
         var select = $('#spoke_color');
         select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Orange">Orange</option><option class="category" value="Red">Red</option><option class="category" value="White">White</option><option class="category" value="Yellow">Yellow</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Titanium">Titanium</option>');
         //SPOKE COLOR
         var image_name = images+"spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr3 = [image_name];
         var divArr3 = ["resultAreaID_1_2"];
         $('#resultAreaID_1_2 img').attr('src', image_name);
         // $('#resultAreaID_1_2 img').attr('src', image_name );
         // // $("#resultAreaID_1_2").find("img").unwrap();
     } else {
         var select = $('#spoke_color');
         select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Orange">Orange</option><option class="category" value="Red">Red</option><option class="category" value="White">White</option><option class="category" value="Yellow">Yellow</option><option class="category" value="Flo-Yellow">Flo Yellow</option>');
         //SPOKE COLOR
         var image_name = images+"spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr3 = [image_name];
         var divArr3 = ["resultAreaID_1_2"];
         $('#resultAreaID_1_2 img').attr('src', image_name);
         // $('#resultAreaID_1_2 img').attr('src', image_name );
         // // $("#resultAreaID_1_2").find("img").unwrap();
     }
     // //Bike Model .change hub color code
     // if ($('select#bike_make').val() === "Alta Redshift") {
     // 	//Display only Silver Hub Color
     // 	$.fn.onlysilverhubcolor;
     // } else {
     // 	//Display All Hub Colors
     // 	$.fn.allhubcolors;
     // }
 
     //Call to tubeless wheel function
     tubelesswheel();
     //Fron suspension Logic//
     if ($('select#bike_make').val() == 'Sherco' & $('select#wheel_type').val() == "FRONT") {
         $('#frontsuspension').show();
 
     } else {
         $('#frontsuspension').hide();
     }
     hide320mm();
     gasgasbrakeremove();
     $(".rim-color-type .rim-type-wrap.anodized").click();
 });
 
     $('select#bike_make').change(function() {
         if ($('select#bike_model').val() === `CRF250R *REAR*` || $('select#bike_model').val() === `Ultra Bee * REAR *` || $('select#bike_model').val() === `CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `CRF450L *REAR*` || $('select#bike_model').val() === `CRF450RL *REAR*` || $('select#bike_model').val() === `CRF250X *REAR*` || $('select#bike_model').val() === `CRF450X *REAR*` || $('select#bike_model').val() === `YZ250F *REAR*` || $('select#bike_model').val() === `YZ250FX *REAR*` || $('select#bike_model').val() === `YZ250X *REAR*` || $('select#bike_model').val() === `YZ450FX *REAR*` || $('select#bike_model').val() === `WR250F *REAR*` || $('select#bike_model').val() === `YZ400F *REAR*` || $('select#bike_model').val() === `YZ400F *REAR*` || $('select#bike_model').val() === `YZ426F *REAR*` || $('select#bike_model').val() === `DRZ400 S * REAR *` || $('select#bike_model').val() === `DRZ400 SE * REAR *` || $('select#bike_model').val() === `DRZ400 E * REAR *` || $('select#bike_model').val() == `EXC125 *REAR*` || $('select#bike_model').val() == `EXC-F350 *REAR*` || $('select#bike_model').val() == `EXC520 *REAR*` || $('select#bike_model').val() == `XC-W250 TPI *REAR*` || $('select#bike_model').val() == `XCF-W250 *REAR*` || $('select#bike_model').val() == `XC-W300 TPI *REAR*` || $('select#bike_model').val() == `XC-F450 *REAR*` || $('select#bike_model').val() == `XC-W500 *REAR*` || $('select#bike_model').val() == `XC-F505 *REAR*` || $('select#bike_model').val() == `SX450 *REAR*` || $('select#bike_model').val() == `EXC200 *REAR*` || $('select#bike_model').val() == `EXC-F250 *REAR*` || $('select#bike_model').val() == `EXC300 *REAR*` || $('select#bike_model').val() == `EXC380 *REAR*` || $('select#bike_model').val() == `EXC400 *REAR*` || $('select#bike_model').val() == `EXC450 *REAR*` || $('select#bike_model').val() == `EXC350 *REAR*` || $('select#bike_model').val() == `EXC-F500 *REAR*` || $('select#bike_model').val() == `EXC-F450 *REAR*` || $('select#bike_model').val() == `XC250 TPI *REAR*` || $('select#bike_model').val() == `XC300 TPI *REAR*` || $('select#bike_model').val() == `XC-W300 TPI Six Days *REAR*` || $('select#bike_model').val() == `SX-F450 Factory Edition *REAR*` || $('select#bike_model').val() == `TX125 *REAR*` || $('select#bike_model').val() == `TE250I *REAR*` || $('select#bike_model').val() == `TE300I *REAR*` || $('select#bike_model').val() == `TX300 *REAR*` || $('select#bike_model').val() == `FC350 *REAR*` || $('select#bike_model').val() == `FE350 *REAR*` || $('select#bike_model').val() == `FX350 *REAR*` || $('select#bike_model').val() == `FE450 *REAR*` || $('select#bike_model').val() == `FX450 *REAR*` || $('select#bike_model').val() == `EXC525 *REAR*` || $('select#bike_model').val() == `EXC530 *REAR*` || $('select#bike_model').val() == `EXC-R530 *REAR*` || $('select#bike_model').val() == `XC150 *REAR*` || $('select#bike_model').val() == `XC-W150 *REAR*` || $('select#bike_model').val() == `XC200 *REAR*` || $('select#bike_model').val() == `XC-W200 *REAR*` || $('select#bike_model').val() == `XC250 *REAR*` || $('select#bike_model').val() == `XC-W250 *REAR*` || $('select#bike_model').val() == `XC-F250 *REAR*` || $('select#bike_model').val() == `XC-F350 *REAR*` || $('select#bike_model').val() == `XCF-W350 *REAR*` || $('select#bike_model').val() == `XC300 *REAR*` || $('select#bike_model').val() == `XC-W300 *REAR*` || $('select#bike_model').val() == `XC400 *REAR*` || $('select#bike_model').val() == `XC-W400 *REAR*` || $('select#bike_model').val() == `XC450 *REAR*` || $('select#bike_model').val() == `XC-W450 *REAR*` || $('select#bike_model').val() == `XC525 *REAR*` || $('select#bike_model').val() == `XC-W525 *REAR*` || $('select#bike_model').val() == `XC530 *REAR*` || $('select#bike_model').val() == `XC-W530 *REAR*` || $('select#bike_model').val() == `SX125 *REAR*` || $('select#bike_model').val() == `SX144 *REAR*` || $('select#bike_model').val() == `SX150 *REAR*` || $('select#bike_model').val() == `SX200 *REAR*` || $('select#bike_model').val() == `SX250 *REAR*` || $('select#bike_model').val() == `SXF250 *REAR*` || $('select#bike_model').val() == `SXF350 *REAR*` || $('select#bike_model').val() == `SX380 *REAR*` || $('select#bike_model').val() == `SX400 *REAR*` || $('select#bike_model').val() == `SXC400 *REAR*` || $('select#bike_model').val() == `SX-RFS450 *REAR*` || $('select#bike_model').val() == `SX-F450 *REAR*` || $('select#bike_model').val() == `Varg *REAR*` || $('select#bike_model').val() == `SX-F505 *REAR*` || $('select#bike_model').val() == `SX520 *REAR*` || $('select#bike_model').val() == `SX525 *REAR*` || $('select#bike_model').val() == `SXC625 *REAR*` || $('select#bike_model').val() === `TE300 *REAR*` || $('select#bike_model').val() === `FC450 *REAR*` || $('select#bike_model').val() === `FE501 *REAR*` || $('select#bike_model').val() === `TE150 *REAR*` || $('select#bike_model').val() === `TX300i *REAR*` || $('select#bike_model').val() === `FC450 Rockstar Edition *REAR*` || $('select#bike_model').val() === `WR450F*REAR*` || $('select#bike_model').val() === `YZ250F *REAR*` || $('select#bike_model').val() === `CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `CRF450R *REAR*` || $('select#bike_model').val() === `CRF450RX *REAR*` || $('select#bike_model').val() === `CRF250RX *REAR*` || $('select#bike_model').val() === `All FE/FC *REAR*` || $('select#bike_model').val() === `FE *REAR*` || $('select#bike_model').val() === `450X *REAR*` || $('select#bike_model').val() === `YZ450F *REAR*` || $('select#bike_model').val() === `WR426 *REAR*` || $('select#bike_model').val() === `KLX400 *REAR*` || $('select#bike_model').val() === `XR250 *REAR*` || $('select#bike_model').val() === `XR400 *REAR*` || $('select#bike_model').val() === `XR650L *REAR*` || $('select#bike_model').val() == `690 ENDURO * REAR *` || $('select#bike_model').val() == `790 Adventure *REAR*` || $('select#bike_model').val() == `790 Adventure R *REAR*` || $('select#bike_model').val() == `890 Adventure *REAR*` || $('select#bike_model').val() == `890 Adventure R *REAR*` || $('select#bike_model').val() == `950 Adventure *REAR*` || $('select#bike_model').val() == `990 Adventure *REAR*` || $('select#bike_model').val() == `1090 Adventure *REAR*` || $('select#bike_model').val() == `1190 Adventure *REAR*` || $('select#bike_model').val() == `1290 Adventure ABS *REAR*` || $('select#bike_model').val() == `1290 Adventure R *REAR*` || $('select#bike_model').val() == `1290 Super Adventure S *REAR*` || $('select#bike_model').val() == `690 ENDURO ABS * REAR *` || $('select#bike_model').val() == `RR *REAR*` || $('select#bike_model').val() == `RS *REAR*`) {
             document.getElementById("cush_drive").disabled = false;
             select = $('#cush_drive');
             select.empty().append('<option class="category" value="unavailable">Standard</option>', '<option class="category" value="Cush Drive">Cush Drive</option>');
             
         } else {
             document.getElementById("cush_drive").disabled = true;
             select = $('#cush_drive');
             select.empty().append(' <option class="category" value="unavailable" selected="selected">Standard</option>');
 
 
 
         }
 
         //Fron suspension Logic//
         if ($('select#wheel_type').val() == "FRONT" & $('select#bike_make').val() == 'Sherco') {
             $('#frontsuspension').show();
 
         } else {
             $('#frontsuspension').hide();
         }
 
 
         //Model Year Show		
         if ($('select#bike_make').val() == 'Husqvarna'|| $('select#bike_make').val() == 'Surron' || $('select#bike_make').val() == 'Honda' || $('select#bike_make').val() == 'KTM' || $('select#bike_make').val() == 'Yamaha' || $('select#bike_make').val() == 'Kawasaki' || $('select#bike_make').val() == 'Suzuki' || $('select#bike_make').val() == 'Husaberg' || $('select#bike_make').val() == 'GasGas' || $('select#bike_make').val() == 'BMW' || $('select#bike_make').val() == 'Beta' || $('select#bike_make').val() == 'TM' || $('select#bike_make').val() == 'Sherco' || $('select#bike_make').val() == 'Stark' || $('select#bike_make').val() == 'Alta Redshift')
 
         {
             $('#bikeyear').show();
             // $('#frontsuspension').show();
 
 
         } else {
             $('#bikeyear').hide();
             //  $('#frontsuspension').hide();
 
         }
         // Hide Blue rim color
         // rimcolorhideblue();
 
     });
 
     var bikeyear = function() {
         //Bike Year Start
         //Declare Selected Bike Model Variable
         var sel_bike_model = $('select#bike_model').val();
         // var sel_bike_model = $('#bike_model option:first').val();
         var sel_year = $('#bike_year');
 
         
         var previous_year = sel_year.val();
         // console.info('YEAR CHANGE EVENT');
         // // console.log($('#wheel_type').val());
         // // console.log($('#bike_make').val());
         // console.info(sel_bike_model);
         //// console.log({sel_bike_model});    
       
         //Option Year Variable
         var y81 = '<option value="1981">1981</option>';
         var y82 = '<option value="1982">1982</option>';
         var y83 = '<option value="1983">1983</option>';
         var y84 = '<option value="1984">1984</option>';
         var y85 = '<option value="1985">1985</option>';
         var y86 = '<option value="1986">1986</option>';
         var y87 = '<option value="1987">1987</option>';
         var y88 = '<option value="1988">1988</option>';
         var y89 = '<option value="1989">1989</option>';
         var y90 = '<option value="1990">1990</option>';
         var y91 = '<option value="1991">1991</option>';
         var y92 = '<option value="1992">1992</option>';
         var y93 = '<option value="1993">1993</option>';
         var y94 = '<option value="1994">1994</option>';
         var y95 = '<option value="1995">1995</option>';
         var y96 = '<option value="1996">1996</option>';
         var y97 = '<option value="1997">1997</option>';
         var y98 = '<option value="1998">1998</option>';
         var y99 = '<option value="1999">1999</option>';
         var y00 = '<option value="2000">2000</option>';
         var y01 = '<option value="2001">2001</option>';
         var y02 = '<option value="2002">2002</option>';
         var y03 = '<option value="2003">2003</option>';
         var y04 = '<option value="2004">2004</option>';
         var y05 = '<option value="2005">2005</option>';
         var y06 = '<option value="2006">2006</option>';
         var y07 = '<option value="2007">2007</option>';
         var y08 = '<option value="2008">2008</option>';
         var y09 = '<option value="2009">2009</option>';
         var y10 = '<option value="2010">2010</option>';
         var y11 = '<option value="2011">2011</option>';
         var y12 = '<option value="2012">2012</option>';
         var y13 = '<option value="2013">2013</option>';
         var y14 = '<option value="2014">2014</option>';
         var y15 = '<option value="2015">2015</option>';
         var y16 = '<option value="2016">2016</option>';
         var y17 = '<option value="2017">2017</option>';
         var y18 = '<option value="2018">2018</option>';
         var y19 = '<option value="2019">2019</option>';
         var y20 = '<option value="2020">2020</option>';
         var y21 = '<option value="2021">2021</option>';
         var y22 = '<option value="2022">2022</option>';
         var y23 = '<option value="2023">2023</option>';
         var y24 = '<option value="2024">2024</option>';
         var y25 = '<option value="2025">2025</option>';
         var y26 = '<option value="2026">2026</option>';
         //Global Usage
         //else if(sel_bike_model === "") {sel_year.empty().append();}
         //y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19
 
             //Model Husqvarna Front
         
             if(sel_bike_model === "TC125 *REAR*" || sel_bike_model === "TC125 *FRONT*" ) {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}	
                 else if(sel_bike_model === "FX350 *REAR*" || sel_bike_model === "FX450 *REAR*" || sel_bike_model === "FX450 *FRONT*" || sel_bike_model === "FX350 *FRONT*") {sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "CR250 *FRONT*" || sel_bike_model === "CR250 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05);}
                 else if(sel_bike_model === "TE300 *FRONT*" || sel_bike_model === "TE125 *FRONT*") {sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "FE250 *FRONT*" || sel_bike_model === "FE250 *REAR*" || sel_bike_model === "FE350 *FRONT*" || sel_bike_model === "FE350 *REAR*" || sel_bike_model === "FE450 *FRONT*" || sel_bike_model === "FE450 *REAR*" || sel_bike_model === "FE501 *FRONT*" || sel_bike_model === "FE501 *REAR*"  || sel_bike_model === "FC/TC/FE/TE 250 *REAR*" || sel_bike_model === "FC/TC/FE/TE 250 *FRONT*" || sel_bike_model === "FC350 *FRONT*" || sel_bike_model === "FC350 *REAR*" || sel_bike_model === "FC450 *FRONT*" || sel_bike_model === "FC450 *REAR*") {sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "TC250 *FRONT*" || sel_bike_model === "TC250 *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "TE250 *FRONT*"  || sel_bike_model === "TE250 *REAR") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "TXC250 *FRONT*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "WR250 *FRONT*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);}
                 else if(sel_bike_model === "TX300 *REAR*" || sel_bike_model === "TX300 *FRONT*") {sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                 else if(sel_bike_model === "TXC449 *FRONT*") {sel_year.empty().append(y11);}
                 else if(sel_bike_model === "WR300 *FRONT*") {sel_year.empty().append(y09 + y10 + y11 + y12 + y13);}
                 else if(sel_bike_model === "TC310 *FRONT*" || sel_bike_model === "TE310 *FRONT*" ) {sel_year.empty().append( y09 + y10 + y11 + y12);}
                 else if(sel_bike_model === "TXC310 *FRONT*" || sel_bike_model === "TXC310 *REAR*") {sel_year.empty().append(y12 + y13);}
                 else if(sel_bike_model === "WR360 *FRONT*" || sel_bike_model === "TC610 *FRONT*") {sel_year.empty().append(y00 + y01 + y02 + y03);}
                 else if(sel_bike_model === "TE410 *FRONT*") {sel_year.empty().append(y00 + y01);}
                 else if(sel_bike_model === "TC449 *FRONT*" || sel_bike_model === "TE449 *FRONT*" || sel_bike_model === "TE511 *FRONT*") {sel_year.empty().append(y11 + y12 + y13);}
                 else if(sel_bike_model === "TC450 *FRONT*" || sel_bike_model === "TE450 *FRONT*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);}
                 else if(sel_bike_model === "TXC450 *FRONT*") {sel_year.empty().append(y07 + y08 + y09 + y10 + y11);}
                 else if(sel_bike_model === "TC510 *FRONT*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09);}
                 else if(sel_bike_model === "TE510 *FRONT*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10);}
                 else if(sel_bike_model === "TXC510 *FRONT*") {sel_year.empty().append(y08 + y09 + y10 + y11);}
                 else if(sel_bike_model === "TXC511 *FRONT*") {sel_year.empty().append(y11 + y12);}
                 else if(sel_bike_model === "TC570 *FRONT*" || sel_bike_model === "TE570 *FRONT*") {sel_year.empty().append(y01 + y02);}
                 else if(sel_bike_model === "TE610 *FRONT*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09);}
                 else if(sel_bike_model === "TE630 *FRONT*") {sel_year.empty().append(y10 + y11);}
                 else if(sel_bike_model === "701 Enduro *FRONT*"  || sel_bike_model === "701 Enduro *REAR*") {sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             //Model Husqvarna Rear
                 
             else if(sel_bike_model === "TE125 *REAR*" || sel_bike_model === "TE300 *REAR*") {sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "TX125 *REAR*" || sel_bike_model === "TX125 *FRONT*") {sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "SM/TC/TE/TXC 250/450/510/610 *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CR/WR 125-250 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);}
             else if(sel_bike_model === "TE250I *FRONT*" || sel_bike_model === "TE250I *REAR*") {sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "TXC449 *REAR*") {sel_year.empty().append(y11);}
             else if(sel_bike_model === "WR300 *REAR*") {sel_year.empty().append(y09 + y10 + y11 + y12 + y13);}
             else if(sel_bike_model === "TC310 *REAR*" || sel_bike_model === "TE310 *REAR*") {sel_year.empty().append(y09 + y10 + y11 + y12);}
             else if(sel_bike_model === "WR360 *REAR*" || sel_bike_model === "TC610 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03);}
             else if(sel_bike_model === "TE410 *REAR*") {sel_year.empty().append(y00 + y01);}
             else if(sel_bike_model === "TC/TE 449/511 *REAR*" || sel_bike_model === "TE449 *REAR*" || sel_bike_model === "TE511 *REAR*") {sel_year.empty().append(y11 + y12 + y13);}
             else if(sel_bike_model === "TC450 *REAR*" || sel_bike_model === "TE450 *REAR*" ) {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);}
             else if(sel_bike_model === "TXC450 *REAR*") {sel_year.empty().append(y07 + y08 + y09 + y10 + y11);}
             else if(sel_bike_model === "TC510 *REAR*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 );}
             else if(sel_bike_model === "TE510 *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10);}
             else if(sel_bike_model === "TXC510 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11);}
             else if(sel_bike_model === "TXC511 *REAR*") {sel_year.empty().append(y11 + y12);}
             else if(sel_bike_model === "TC570 *REAR*" || sel_bike_model === "TE570 *REAR*") {sel_year.empty().append(y01 + y02);}
             else if(sel_bike_model === "TE610 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09);}
             else if(sel_bike_model === "TE630 *REAR*") {sel_year.empty().append(y10 + y11);}
             else if(sel_bike_model === "TE300I *REAR*" || sel_bike_model === "TE300I *FRONT*") {sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "TE150 *REAR*" || sel_bike_model === "TE150 *FRONT*") {sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "TX300i *REAR*" || sel_bike_model === "TX300i *FRONT*") {sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "FC450 ROCKSTAR EDITION *REAR*" || sel_bike_model === "FC450 ROCKSTAR EDITION *FRONT*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
             
             //Model Honda Front and Rear
             else if(sel_bike_model  === 'CR125-CR250 *REAR*' || sel_bike_model ===  'CR125-CR250 *REAR*'){
                 sel_year.empty().append(y87 + y88 + y89 + y90 + y91 +y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);
 
             }
             else if(sel_bike_model  === 'CR500 *REAR*'){
                 sel_year.empty().append(y87 + y88 + y89 + y90 + y91 +y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01);
             }
             else if(sel_bike_model  === 'CRF450R *FRONT*' || sel_bike_model  === 'CRF450R *REAR*'){
                 sel_year.empty().append(
                     y02 + y03 + y04 + y05 + y06 + 
                     y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + 
                     y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                     );
 
             }
             else if(sel_bike_model  === 'CRF250R *FRONT*' || sel_bike_model  === 'CRF250R *REAR*'){
                 sel_year.empty().append(
                     y04 + y05 + y06 + 
                     y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + 
                     y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF250L *FRONT*' || sel_bike_model  === 'CRF250L *REAR*'){
                 sel_year.empty().append(
                     y13 + y14 + y15 + y16 + 
                     y17 + y18 + y19 + y20 + y21
                 );
             }
             else if(sel_bike_model  === 'CRF300L *FRONT*' || sel_bike_model  === 'CRF300L *REAR*'){
                 sel_year.empty().append( y21 + y22 + y23);
             }
             else if(sel_bike_model  === 'CRF250L RALLY *REAR*' || 
                     sel_bike_model  === 'CRF250L RALLY *FRONT*' || 
                     sel_bike_model  === 'CRF250L ABS *FRONT*' || 
                     sel_bike_model  === 'CRF250L ABS *REAR*'){
                 sel_year.empty().append(
                     y17 + y18 + y19 + y20 + y21
                 );
             }
             else if(sel_bike_model  === 'CRF300L ABS *REAR*' || 
                     sel_bike_model  === 'CRF300L ABS *FRONT*' || 
                     sel_bike_model  === 'CRF300L Rally *FRONT*' || 
                     sel_bike_model  === 'CRF300L Rally *REAR*'|| 
                     sel_bike_model  === 'CRF300L Rally ABS *REAR*' || 
                     sel_bike_model  === 'CRF300L Rally ABS *FRONT*'){
                 sel_year.empty().append(
                     y21 + y22 + y23
                 );
             }
             else if(sel_bike_model  === 'CRF450L *FRONT*' || 
                     sel_bike_model  === 'CRF450L *REAR*'){
                 sel_year.empty().append(
                     y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
                 );
             }
             else if(sel_bike_model  === 'CRF450RL *REAR*' || 
                     sel_bike_model  === 'CRF450RL *FRONT*'){
                 sel_year.empty().append(
                     y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF450R WORKS EDITION *FRONT*' || 
                     sel_bike_model  === 'CRF450R WORKS EDITION *REAR*'){
                 sel_year.empty().append(
                     y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF250RX *FRONT*' || 
                     sel_bike_model  === 'CRF250RX *REAR*'){
                 sel_year.empty().append(
                     y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF450RX *REAR*' || 
                     sel_bike_model  === 'CRF450RX *FRONT*'){
                 sel_year.empty().append(
                     y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF250X *REAR*' || 
                     sel_bike_model  === 'CRF250X *FRONT*'){
                 sel_year.empty().append(
                     y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'CRF450X *FRONT*' || 
                     sel_bike_model  === 'CRF450X *REAR*'){
                 sel_year.empty().append(
                     y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if(sel_bike_model  === 'XR650R *FRONT*' || 
                     sel_bike_model  === 'XR650R *REAR*'){
                 sel_year.empty().append(
                     y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 
                 );
             }
             else if(sel_bike_model  === 'CR125-CR250 *REAR*' || 
                     sel_bike_model  === 'CR125-CR250 *FRONT*' ||
                     sel_bike_model === 'XR400 *FRONT*' ||
                     sel_bike_model === 'XR4000 *REAR*'
             ){
                 sel_year.empty().append(
                     y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 
                 );
             }
             else if(sel_bike_model  === 'XR650L (No Speedo) *FRONT*' ||
                     sel_bike_model === 'XR650L *REAR*'
             ){
                 sel_year.empty().append(
                     y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25
                 );
             }
             else if (sel_bike_model === "CRF250L RALLY ABS *FRONT*" || sel_bike_model === "CRF250L RALLY ABS *REAR*") {
                sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20);
            }

 
 
 
             else if(sel_bike_model === "CR125-CR250 *FRONT*" || sel_bike_model === 'CR125-CR250 *FRONT*') {
                 sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);}
             else if(sel_bike_model === "CR125-CR250 *FRONT*" || sel_bike_model === "CR125-CR250 *FRONT*") {sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);}
             else if(sel_bike_model === "CRF250L *FRONT*" || sel_bike_model === "CRF250L *REAR*") {sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CRF300L *REAR*" || sel_bike_model === "CRF300L ABS *REAR*" || sel_bike_model === "CRF300L Rally *REAR*" || sel_bike_model === "CRF300L Rally ABS *REAR*" || sel_bike_model === "CRF300L *FRONT*" || sel_bike_model === "CRF300L ABS *FRONT*" || sel_bike_model === "CRF300L Rally *FRONT*" || sel_bike_model === "CRF300L Rally ABS *FRONT*" ) {sel_year.empty().append(y21);}
             else if(sel_bike_model === "CRF250L RALLY *FRONT*" || sel_bike_model === "CRF450RX *FRONT*" || sel_bike_model === "CRF250L RALLY *REAR*" || sel_bike_model === "CRF450RX *REAR*") {sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CRF450L *FRONT*" || sel_bike_model === "CRF450L *REAR*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CRF450RL *FRONT*" || sel_bike_model === "CRF450RL *REAR*") {sel_year.empty().append(y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CRF250R *FRONT*" || sel_bike_model === "CRF250X *FRONT*" || sel_bike_model === "CRF250R *REAR*" || sel_bike_model === "CRF250X *REAR*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "XR400 *FRONT*") {sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);}
             else if(sel_bike_model === "CRF450R *FRONT*" || sel_bike_model === "CRF450R *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CRF450X *FRONT*" || sel_bike_model === "CRF450X *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
 
             }
             else if(sel_bike_model === "CR500 *FRONT*"){
                 sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21);
             }
             else if(sel_bike_model === "CR500 *FRONT*") {sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00 + y01);}
             else if(sel_bike_model === "XR650L (No Speedo) *FRONT*" || sel_bike_model === "XR650L *REAR*") {
                 sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
             }
             else if(sel_bike_model === "XR650R *FRONT*" || sel_bike_model === "XR650R *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);}
             else if(sel_bike_model === "CR125-CR250 *REAR*" || sel_bike_model === "CR125-CR250 *REAR*") {sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);}                 
             else if(sel_bike_model === "XR4000 *REAR*") {sel_year.empty().append(y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);}                  
             else if(sel_bike_model === "CR500 *REAR*") {sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01);}           else if(sel_bike_model === "CRF250L ABS *REAR*" || sel_bike_model === "CRF250L ABS *FRONT*" || sel_bike_model === "CRF250L RALLY ABS *FRONT*" || sel_bike_model === "CRF250L Rally ABS *REAR*") {sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "CR500 *REAR*") {sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01);}           else if(sel_bike_model === "CRF250RX *REAR*" || sel_bike_model === "CRF250RX *FRONT*" || sel_bike_model === "CRF450R WORKS EDITION *REAR*" || sel_bike_model === "CRF450R WORKS EDITION *FRONT*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
                             
                              
             //Model Yamaha Front and Rear
              else if(sel_bike_model === "YZ125 *FRONT*" || sel_bike_model === "YZ250 *FRONT*" || sel_bike_model === "YZ125 *REAR*" || sel_bike_model === "YZ250 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "YZ125R *FRONT*" || sel_bike_model === "YZ250R *FRONT*") {sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "YZ250F *FRONT*" || sel_bike_model === "YZ250F *REAR*") {sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR250F *FRONT*" || sel_bike_model === "WR250F *REAR*") {sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "YZ250FX *FRONT*") {sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR400 *FRONT*" || sel_bike_model === "WR400F *REAR*") {sel_year.empty().append(y00 + y01);}
              else if(sel_bike_model === "YZ400F *FRONT*") {sel_year.empty().append(y98);}
              else if(sel_bike_model === "YZ426F *FRONT*") {sel_year.empty().append(y00 + y01);}
              else if(sel_bike_model === "YZ450F *FRONT*" || sel_bike_model === "YZ450F *REAR*") {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR450F *FRONT*" || sel_bike_model === "WR450F *REAR*" ) {sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR250R *FRONT*" || sel_bike_model === "WR250R *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR250X *FRONT*" || sel_bike_model === "WR250X *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12);}
              else if(sel_bike_model === "YZ400F *REAR*") {sel_year.empty().append(y99);}
              else if(sel_bike_model === "YZ426F *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);}
              else if(sel_bike_model === "YZ450FX *REAR*" || sel_bike_model === "YZ250X *REAR*"  || sel_bike_model === "YZ250X *FRONT*" || sel_bike_model === "YZ450F *FRONT*") {sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
              else if(sel_bike_model === "WR426 *REAR*" || sel_bike_model === "WR426 *FRONT*") {sel_year.empty().append(y01 + y02);}
             
              //Model Kawasaki FRONT and Rear
              
               else if(sel_bike_model === "KX125 *FRONT*" || sel_bike_model === "KX125 *REAR*" || sel_bike_model === "KX250 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);}
               else if(sel_bike_model === "KX250 *FRONT*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);}
               
               else if(sel_bike_model === "KX250F *REAR*" || sel_bike_model === "KX250F *FRONT*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
               else if(sel_bike_model === "KX250XC *REAR*" || sel_bike_model === "KX250XC *FRONT*") {sel_year.empty().append(y21);}
               else if(sel_bike_model === "KLX400 *FRONT*" || sel_bike_model === "KLX400 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);}
               else if(sel_bike_model === "KX450F *FRONT*" || sel_bike_model === "KX450F *REAR*") {sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
               else if(sel_bike_model === "KX450XC *FRONT*" || sel_bike_model === "KX450XC *REAR*") {sel_year.empty().append(y21);}
               
               else if(sel_bike_model === "KLX450R *FRONT*" || sel_bike_model === "KLX450R *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14);}
               else if(sel_bike_model === "KLX 300R *FRONT*" || sel_bike_model === "KLX 300R *REAR*") {sel_year.empty().append(y20 + y21);}
               
               else if(sel_bike_model === "KLR650 *REAR* " || sel_bike_model === "KLR650 *FRONT*") {sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20);}
             
              //Model KTM FRONT and REAR
 else if(sel_bike_model === "EXC125 *FRONT*"||sel_bike_model === "EXC125 *REAR*") {sel_year.empty().append( y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06);}
 else if(sel_bike_model === "EXC200 *FRONT*" ||sel_bike_model === "EXC200 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05);}
 else if(sel_bike_model === "EXC-F250 *FRONT*" || sel_bike_model === "EXC-F250 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC300 *FRONT*" ||sel_bike_model === "SX125 *FRONT*" ||sel_bike_model === "SX250 *FRONT*"||sel_bike_model === "EXC300 *REAR*" ||sel_bike_model === "SX125 *REAR*" ||sel_bike_model === "SX250 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 
 else if(sel_bike_model === "EXC380 *FRONT*"||sel_bike_model === "EXC380 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03);}
 else if(sel_bike_model === "EXC400 *FRONT*"||sel_bike_model === "EXC400 *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06);}
 else if(sel_bike_model === "XC450 *FRONT*"||sel_bike_model === "XC450 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09);}
 else if(sel_bike_model === "XC-W450 *FRONT*"||sel_bike_model === "XC-W450 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC450 *FRONT*" || sel_bike_model === "EXC450 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);}
 else if(sel_bike_model === "EXC350 *FRONT*" || sel_bike_model === "EXC350 *REAR*") {sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC-F500 *FRONT*"||sel_bike_model === "EXC-F500 *REAR*") {sel_year.empty().append(y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC525 *FRONT*"||sel_bike_model === "EXC525 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07);}								
 else if(sel_bike_model === "EXC-R530 *FRONT*" || sel_bike_model === "SX-F505 *FRONT*" || sel_bike_model === "EXC-R530 *REAR*" || sel_bike_model === "SX-F505 *REAR*") {sel_year.empty().append(y08 + y09);}
 else if(sel_bike_model === "XC150 *FRONT*" ||sel_bike_model === "XC150 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC530 *FRONT*"  || sel_bike_model === "EXC530 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11);}
 else if(sel_bike_model === "XC200 *FRONT*"||sel_bike_model === "XC200 *REAR*") {sel_year.empty().append(y06 + y07 + y08 + y09);}
 else if(sel_bike_model === "XC-W200 *FRONT*" ||sel_bike_model === "XC-W200 *REAR*") {sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);}							
 else if(sel_bike_model === "XC250 *FRONT*"||sel_bike_model === "XC-W250 *FRONT*" ||sel_bike_model === "XC300 *FRONT*"||sel_bike_model === "XC-W300 *FRONT*"||sel_bike_model === "XC250 *REAR*"||sel_bike_model === "XC-W250 *REAR*" ||sel_bike_model === "XC300 *REAR*"||sel_bike_model === "XC-W300 *REAR*") {sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XC-F250 *FRONT*"|| sel_bike_model === "XC-F250 *REAR*") {sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 
 else if(sel_bike_model === "XC400 *FRONT*"||sel_bike_model === "XC400 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12);}
 else if(sel_bike_model === "XC-W400 *FRONT*"||sel_bike_model === "XC-W400 *REAR*") {sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12);}
 else if(sel_bike_model === "XC525 *FRONT*"||sel_bike_model === "XC-W525 *FRONT*"||sel_bike_model === "XC525 *REAR*"||sel_bike_model === "XC-W525 *REAR*") {sel_year.empty().append(y06 + y07);}
 else if(sel_bike_model === "XC530 *FRONT*"||sel_bike_model === "XC-W530 *FRONT*"||sel_bike_model === "XC530 *REAR*"||sel_bike_model === "XC-W530 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11);}
 else if(sel_bike_model === "SX144 *FRONT*"||sel_bike_model === "SX144 *REAR*") {sel_year.empty().append(y07 + y08);}
 else if(sel_bike_model === "SX150 *FRONT*"||sel_bike_model === "SX150 *REAR*") {sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "SX200 *FRONT*"||sel_bike_model === "SX200 *REAR*") {sel_year.empty().append(y03 + y04);}
 else if(sel_bike_model === "SXF250 *FRONT*"||sel_bike_model === "SXF350 *FRONT*"||sel_bike_model === "SXF250 *REAR*"||sel_bike_model === "SXF350 *REAR*") {sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "SX380 *FRONT*"||sel_bike_model === "SX380 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01 + y02);}
 else if(sel_bike_model === "SX400 *FRONT*" ||sel_bike_model === "SX520 *FRONT*"||sel_bike_model === "SX400 *REAR*" ||sel_bike_model === "SX520 *REAR*") {sel_year.empty().append(y00 + y01 + y02);}
 else if(sel_bike_model === "SXC400 *FRONT*"||sel_bike_model === "SXC400 *REAR*") {sel_year.empty().append(y98 + y99 + y00 + y01);}
 else if(sel_bike_model === "SX-RFS450 *FRONT*"||sel_bike_model === "SX-RFS450 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06);}
 else if(sel_bike_model === "SX-F450 *FRONT*"||sel_bike_model === "SX-F450 *REAR*") {sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "Varg *FRONT*"||sel_bike_model === "Varg *REAR*") {sel_year.empty().append(y23 + y24);}
 
 else if(sel_bike_model === "SX525 *FRONT*"||sel_bike_model === "SX525 *REAR*") {sel_year.empty().append(y03 + y04 + y05 + y06 + y07);}
 else if(sel_bike_model === "SXC625 *FRONT*"||sel_bike_model === "SXC625 *REAR*") {sel_year.empty().append(y03 + y04 + y05);}
 else if(sel_bike_model === "690 ENDURO *FRONT*"||sel_bike_model === "690 ENDURO * REAR *") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13);}
 else if(sel_bike_model === "690 ENDURO ABS *FRONT*"||sel_bike_model === "690 ENDURO ABS * REAR *") {sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XCF-W350 *FRONT*" ||sel_bike_model === "XCF-W350 *REAR*") {sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XC-F350 *FRONT*" || sel_bike_model === "XC-F350 *REAR*" || sel_bike_model === "EXC-F350 *FRONT*"|| sel_bike_model === "EXC-F350 *REAR*") {sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 
 else if(sel_bike_model === "XC-W500 *FRONT*"|| sel_bike_model === "XC-W500 *REAR*") {sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC520 *FRONT*"|| sel_bike_model === "EXC520 *REAR*") {sel_year.empty().append(y00 + y01 + y02);}
 else if(sel_bike_model === "XC-W250 TPI *FRONT*"|| sel_bike_model === "XC-W250 TPI *REAR*") {sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XCF-W250 *FRONT*"|| sel_bike_model === "XCF-W250 *REAR*") {sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XC-W300 TPI *FRONT*"|| sel_bike_model === "XC-W300 TPI *REAR*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XC-F450 *FRONT*"|| sel_bike_model === "XC-F450 *REAR*" || sel_bike_model === "XC-W150 *FRONT*" || sel_bike_model === "XC-W150 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "XC-F505 *FRONT*"|| sel_bike_model === "XC-F505 *REAR*") {sel_year.empty().append(y08 + y09);}
 else if(sel_bike_model === "SX450 *FRONT*"|| sel_bike_model === "SX450 *REAR*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "790 Adventure *FRONT*"|| sel_bike_model === "790 Adventure *REAR*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "890 Adventure *FRONT*"|| sel_bike_model === "890 Adventure *REAR*" || sel_bike_model === "890 Adventure R *REAR*"|| sel_bike_model === "890 Adventure R *FRONT*") {sel_year.empty().append(y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "790 Adventure R *FRONT*"|| sel_bike_model === "790 Adventure R *REAR*"|| sel_bike_model === "XC250 TPI *REAR*"|| sel_bike_model === "XC250 TPI *FRONT*"|| sel_bike_model === "XC300 TPI *REAR*"|| sel_bike_model === "XC300 TPI *FRONT*") {sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "EXC-F450 SIX DAYS *FRONT*" || sel_bike_model === "EXC-F450 SIX DAYS *REAR*"|| sel_bike_model === "XC-W300 TPI SIX DAYS *FRONT*" || sel_bike_model === "XC-W300 TPI SIX DAYS *REAR*") {sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 else if(sel_bike_model === "SX-F450 FACTORY EDITION *FRONT*"|| sel_bike_model === "SX-F450 FACTORY EDITION *REAR*") {sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
 
                      
             //Model Suzuki Front and rear
             
             else if(sel_bike_model === "DRZ400 SE *FRONT*"|| sel_bike_model === "DRZ400 E *FRONT*" || sel_bike_model === "DRZ400 SE *REAR*"|| sel_bike_model === "DRZ400 E *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "DR650 *FRONT*" || sel_bike_model === "DR650 *REAR*") {sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "RMX450 *FRONT*" || sel_bike_model === "RMX450 *REAR*") {sel_year.empty().append( y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "RMZ250 *FRONT*" ||sel_bike_model === "RMZ250 *REAR*")  {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             
             else if(sel_bike_model === "RMZ450 *FRONT*" || sel_bike_model === "RMZ450 *REAR*") {sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "DRZ400 SM *FRONT*" || sel_bike_model === "DRZ400 SM *REAR*" || sel_bike_model === "DRZ400 S/SE/E *FRONT*" || sel_bike_model === "DRZ400 S/SE/E *REAR*") {sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                     
             
             //Model Husaberg Front and Rear
             else if(sel_bike_model === "FC *REAR*" || sel_bike_model === "FE *REAR*" || sel_bike_model === "FC *FRONT*" || sel_bike_model === "FE *FRONT*") {sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);}
                             
             //Model Gas Gas Front and Rear
             //y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18
             else if(sel_bike_model === "EC250-EC450 *FRONT*" || sel_bike_model === "EC250-EC450 *REAR*") {sel_year.empty().append(y08 + y09 + y10);}
             else if(sel_bike_model === "EC200 *FRONT*" || sel_bike_model === "EC200 *REAR*") {sel_year.empty().append(y16 + y17);}
             else if(sel_bike_model === "EC250 *FRONT*" || sel_bike_model === "EC250 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "EC250 2T *FRONT*" || sel_bike_model === "EC250 2T *REAR*" || sel_bike_model === "EC250 4T *FRONT*" || sel_bike_model === "EC250 4T *REAR*") {sel_year.empty().append(y09 + y10 + y11);}
             else if(sel_bike_model === "EC300 *FRONT*" || sel_bike_model === "EC300 *REAR*") {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             else if(sel_bike_model === "EC450 *FRONT*" || sel_bike_model === "EC450 *REAR*") {sel_year.empty().append(y09 + y10 + y11 + y12);}
             
             else if(sel_bike_model === "Gas EC200 RANGER *FRONT*" || sel_bike_model === "Gas EC200 RANGER *REAR*" || sel_bike_model === "Gas EC300 RANGER *FRONT*" || sel_bike_model === "Gas EC300 RANGER *REAR*") {sel_year.empty().append(y20);}
             else if(sel_bike_model === "Gas EC250 SIX DAYS *FRONT*" || sel_bike_model === "Gas EC250 SIX DAYS *REAR*" || sel_bike_model === "Gas EC300 SIX DAYS *FRONT*" || sel_bike_model === "Gas EC300 SIX DAYS *REAR*" || sel_bike_model === "Gas XC200 *FRONT*" || sel_bike_model === "Gas XC200 *REAR*" || sel_bike_model === "Gas XC250 *FRONT*" || sel_bike_model === "Gas XC250 *REAR*" || sel_bike_model === "Gas XC300 *FRONT*" || sel_bike_model === "Gas XC300 *REAR*") {sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);}
                       
             //Model BMW Front and rear
             
             else if(sel_bike_model === "450X *FRONT*" || sel_bike_model === "450X *REAR*") {sel_year.empty().append(y09 + y10 + y11);}
             
             //Model Beta Front and REAR
             else if(sel_bike_model === "RR *FRONT*" || sel_bike_model === "RS *FRONT*" || sel_bike_model === "RR *REAR*" || sel_bike_model === "RS *REAR*") {sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             
             
             
             //Model TM Front And Rear
             else if(sel_bike_model === "MX 125-530 *FRONT*" || sel_bike_model === "EN 125-530 *FRONT*" || sel_bike_model === "MX 125-530 * REAR *" || sel_bike_model === "EN 125-530 * REAR *") {sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             //Model Sherco Front and Rear
             else if(sel_bike_model === "125-300 SE-R *FRONT*" || sel_bike_model === "250-450 SEF-R *FRONT*" || sel_bike_model === "250-450 SER *FRONT*" || sel_bike_model === "125-300 SE-R * REAR *" || sel_bike_model === "250-450 SEF-R * REAR *" || sel_bike_model === "250-450 SER * REAR *" ) {sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);}
             
             //Model Alta Redshift Front and REAR
             else if(sel_bike_model === "All years and models *FRONT" || sel_bike_model === "Enduro *FRONT" || sel_bike_model === "All years and models * REAR *" || sel_bike_model === "Enduro * REAR *" ) {sel_year.empty().append(y16 + y17 + y18 + y19);}
             
             else {}
 
 
             // NEW year as per AJ
             if(sel_bike_model.includes('EXC125')){
                 sel_year.empty().append(y03 + y04 + y05);
             }else if(sel_bike_model.includes('SX125')){
                 sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('SX144')){
                 sel_year.empty().append(y07 + y08);
             }else if(sel_bike_model.includes('SX150')){
                 sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XC150')){
                 sel_year.empty().append(y10 + y11 + y12 + y13 + y14);
             }else if(sel_bike_model.includes('XC-W150')){
                 sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('EXC200')){
                 sel_year.empty().append(y03 + y04 + y05);
             }else if(sel_bike_model.includes('SX200')){
                 sel_year.empty().append(y03 + y04);
             }else if(sel_bike_model.includes('XC200')){
                 sel_year.empty().append(y06 + y07 + y08 + y09);
             }else if(sel_bike_model.includes('XC-W200')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
             }else if(sel_bike_model.includes('XC-W200')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
             }else if(sel_bike_model.includes('250SX')){
                 sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('250XC')){
                 sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);
             }else if(sel_bike_model.includes('XC-F250')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XC-W250')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XCF-W250')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('EXC300')){
                 sel_year.empty().append(y03 + y04 + y05);
             }else if(sel_bike_model.includes('XC300')){
                 sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XC-W300')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('EXC-F350')){
                 sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XC-F350')){
                 sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
             }else if(sel_bike_model.includes('XCF-W350')){
                 sel_year.empty().append(y12 + y13 + y14 + y15 + y16);
             }else if(sel_bike_model.includes('EXC400')){
                 sel_year.empty().append(y03 + y04 + y05);			
             }else if(sel_bike_model.includes('XC-W450')){
                 sel_year.empty().append(y07 + y08 + y09 + y10);			
             }else if(sel_bike_model.includes('EXC450')){
                 sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);			
             }else if(sel_bike_model.includes('SX450')){
                 sel_year.empty().append(y03 + y04 + y05 + y06);			
             }else if(sel_bike_model.includes('SX-F450')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('SX-F450 Factory Edition')){
                 sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('XC-F450')){
                 sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('XC-W450')){
                 sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);			
             }else if(sel_bike_model.includes('690 Enduro')){
                 sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('790 Adventure')){
                 sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);			
             }else if(sel_bike_model.includes('890 Adventure')){
                 sel_year.empty().append(y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('950 Adventure')){
                 sel_year.empty().append(y06);			
             }else if(sel_bike_model.includes('990 Adventure')){
                 sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);			
             }else if(sel_bike_model.includes('1190 Adventure')){
                 sel_year.empty().append(y13 + y14 + y15 + y16);			
             }else if(sel_bike_model.includes('1290 Adventure')){
                 sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else if(sel_bike_model.includes('500 EXC')){
                 sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
             }else{
                 
             }
 
             if(sel_bike_model == "ES500 *FRONT*" || sel_bike_model == "ES500 *REAR*"){
                 sel_year.empty().append(y23 + y24 + y25);						
             }
 
             // NEW year as per AJ
 
             if (sel_year.find(`option[value="${previous_year}"]`).length > 0) {
                 sel_year.val(previous_year); // Set the previous year as selected
             } else {
                 sel_year.find('option:first').prop('selected', true); // Default to the first year
             }
             speedometer();
     }
 
     var speedometer = function() {
         var wheel = $('select#wheel_type').val();
         var make = $('select#bike_make').val();
         var model = $('select#bike_model').val();
         
         
 
         const bikeMake = document.querySelector('#bike_make').value;
         const bikeYear = parseInt(document.querySelector('#bike_year').value, 10);

         //added
         const bikeModel = document.querySelector('#bike_model').value;
         
         //console.log(bikeModel);
         //var selectElement = document.querySelector('#bike_model');
         //var selectedOptionText = $('select#bike_model').val();
         const engineSize = bikeModel.match(/\d+/);
         if(engineSize){
            //console.log(engineSize);
            var engineNumIsLessThan = engineSize;
            //console.log(engineNumIsLessThan + "-The Engine size");
         }
         //const engineNumAlone = engineSize[0];
         //console.log(engineNumAlone);
        //console.log(engineSize[0]);
        //console.log(selectedOptionText);/*/

         // // console.log({
         // 	bikeMake,bikeYear
         // });

         if (wheel == "FRONT") {
 
             if (1==2 && (make == "Husaberg" || model == "TC125 *FRONT*" || model == "FC 250 *FRONT*" || model == "TC 250 *FRONT*" || model == "FE 250 *FRONT*" || model == "TE 250 *FRONT*" || model == "TE300 *FRONT*" || model == "FC450 *FRONT*" || model == "FE501 *FRONT*" || model == "TE150 *FRONT*" || model == "TX300i *FRONT*" || model == "FC450 Rockstar Edition *FRONT*" || model == "SM 125 *FRONT*" || model == "TC125 *FRONT*" || model == "TE 125 *FRONT*" || model == "TXC 125 *FRONT*" || model == "WR 125 *FRONT*" || model == "CR 125 *FRONT*" || model == "SM 250 *FRONT*" || model == "TC 250 *FRONT*" || model == "TE 250 *FRONT*" || model == "TXC 250 *FRONT*" || model == "WR 250 *FRONT*" || model == "CR 250 *FRONT*" || model == "SM 449 *FRONT*" || model == "TC 449 *FRONT*" || model == "TE 449 *FRONT*" || model == "TXC 449 *FRONT*" || model == "WR 449 *FRONT*" || model == "CR 449 *FRONT*" || model == "SM 450 *FRONT*" || model == "TC 450 *FRONT*" || model == "TE 450 *FRONT*" || model == "TXC 450 *FRONT*" || model == "WR 450 *FRONT*" || model == "CR 450 *FRONT*" || model == "SM 510 *FRONT*" || model == "TC 510 *FRONT*" || model == "TE 510 *FRONT*" || model == "TXC 510 *FRONT*" || model == "WR 510 *FRONT*" || model == "CR 510 *FRONT*" || model == "EXC125 *FRONT*" || model == "EXC-F350 *FRONT*" || model == "EXC520 *FRONT*" || model == "XC-W250 TPI *FRONT*" || model == "XCF-W250 *FRONT*" || model == "XC-W300 TPI *FRONT*" || model == "XC-F450 *FRONT*" || model == "XC-W500 *FRONT*" || model == "XC-F505 *FRONT*" || model == "SX450 *FRONT*" || model == "EXC200 *FRONT*" || model == "EXC-F250 *FRONT*" || model == "EXC300 *FRONT*" || model == "EXC380 *FRONT*" || model == "EXC400 *FRONT*" || model == "EXC450 *FRONT*" || model == "EXC350 *FRONT*" || model == "EXC-F500 *FRONT*" || model == "EXC-F450 *FRONT*" || model == "XC250 TPI *FRONT*" || model == "XC300 TPI *FRONT*" || model == "XC-W300 TPI Six Days *FRONT*" || model == "SX-F450 Factory Edition *FRONT*" || $('select#bike_model').val() == "TX125 *FRONT*" || $('select#bike_model').val() == "TE250I *FRONT*" || $('select#bike_model').val() == "TE300I *FRONT*" || $('select#bike_model').val() == "TX300 *FRONT*" || $('select#bike_model').val() == "FC350 *FRONT*" || $('select#bike_model').val() == "FE350 *FRONT*" || $('select#bike_model').val() == "FX350 *FRONT*" || $('select#bike_model').val() == "FE450 *FRONT*" || $('select#bike_model').val() == "FX450 *FRONT*" || model == "EXC525 *FRONT*" || model == "EXC530 *FRONT*" || model == "EXC-R530 *FRONT*" || model == "XC150 *FRONT*" || model == "XC-W150 *FRONT*" || model == "XC200 *FRONT*" || model == "XC-W200 *FRONT*" || model == "XC250 *FRONT*" || model == "XC-W250 *FRONT*" || model == "XC-F250 *FRONT*" || model == "XC300 *FRONT*" || model == "XC-W300 *FRONT*" || model == "XC-F350 *FRONT*" || model == "XCF-W350 *FRONT*" || model == "XC400 *FRONT*" || model == "XC-W400 *FRONT*" || model == "XC450 *FRONT*" || model == "XC-W450 *FRONT*" || model == "XC525 *FRONT*" || model == "XC-W525 *FRONT*" || model == "XC530 *FRONT*" || model == "XC-W530 *FRONT*" || model == "SX125 *FRONT*" || model == "SX144 *FRONT*" || model == "SX150 *FRONT*" || model == "SX200 *FRONT*" || model == "SX250 *FRONT*" || model == "SXF250 *FRONT*" || model == "SXF350 *FRONT*" || model == "SX380 *FRONT*" || model == "SX400 *FRONT*" || model == "SXC400 *FRONT*" || model == "SX-RFS450 *FRONT*" || model == "SX-F450 *FRONT*" || model == "Varg *FRONT*" || model == "SX-F505 *FRONT*" || model == "SX520 *FRONT*" || model == "SX525 *FRONT*")) {
                 //Show Speedometer Magnets
                 $("#speedometer").show();
                 //Change Speedometer Options
                 $('#sm_magnets').val($('#sm_magnets option:first').val());
                 $('#sm_magnets').change(magnet_change);
                 //Magnet Price Increase
                
             } 
             
             else if(((['KTM', 'Beta'].includes(bikeMake) && engineNumIsLessThan <= 530) || 
                 (bikeMake === 'Husqvarna' && bikeYear >= 2014 && bikeYear <= 2025 && engineNumIsLessThan <= 530) || 
                 (bikeMake === 'GasGas' && bikeYear >= 2020 && bikeYear <= 2025 && engineNumIsLessThan <= 530))){
                     $("#speedometer").show();
                     $('#sm_magnets').val($('#sm_magnets option:first').val());
                     $('#sm_magnets').change(magnet_change);
             }else {
                 //Hide Speedometer Magnets
                 $("#sm_magnets").val(1);
                 $("#speedometer").hide();
             }
 
         } else { //Hide Speedometer Magnets
             $("#sm_magnets").val(1);
             $("#speedometer").hide();
         }
     
        }
     let debounceTimer;
     let tire_image = {
         "Dunlop Sportmax GPR-300 150/60ZR17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png",
         "Michelin Pilot Power 2CT 150/60R17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png"
     }
 
     let debounceTimerPrice;
     document.addEventListener('wb_price_updated', function (e) {
         var data = e.detail;
         clearTimeout(debounceTimerPrice);
         debounceTimerPrice = setTimeout(function () {
             console.log('Price Updated');
             console.log(data);
         }, 500);
     });
 
     var tprice = function() {
         var activeNippleColor = $('.nipple_color_wrapper .active').data('value');
        $('#nipple_color').val(activeNippleColor);
         //Change Tire image
         // clearTimeout(debounceTimer);
         // debounceTimer = setTimeout(function() {
         // 	//// console.log("This code runs only once after a delay!");
         // 	var selected_tire = $('#mbtire').val();
         // 	// if( selected_tire == "Dunlop Sportmax GPR-300 150/60ZR17"){
         // 	// 	$('div#resultAreaID_1_10 img').attr('src', "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png");
         // 	// 	$('div#resultAreaID_1_10').show();
         // 	// }else{
         // 	// 	$('div#resultAreaID_1_10 img').attr('src', "");
         // 	// 	$('div#resultAreaID_1_10').hide();
         // 	// }
 
         // 	if( selected_tire != "mbno"){
         // 		$('div#resultAreaID_1_10 img').attr('src', "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-REAR-tire650_6d4c409a-011a-4913-a00a-2d296f7dca68.png?v=1729666392");
         // 		$('div#resultAreaID_1_10').show();
         // 	}else{
         // 		$('div#resultAreaID_1_10 img').attr('src', "");
         // 		$('div#resultAreaID_1_10').hide();
         // 	}
             
         // }, 500);
 
         if (role == "true") {
             var base_price = 379;
             var spoke_price = 40;
             var nipple_price = 25;
             var brake_price = 0;
             var wheel_size_price = 0;
             var rim_color = 0;
             var sprocket_bolts = 39;
             var rotor_bolts = 12;
             var magnet_price = 0;
             var mbtire_price = 0;
             var tubeless_wheel = 0;
             var sprocket_price = 0;
             var cush_drive = 0;

            const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 50,
                    "REAR": 47
                },
                "320MM_FIXED": {
                    "FRONT": 0,
                    "REAR": 0
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

 
             if ($('select#wheel_type').val() === "REAR") {
                 if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "17X5.00") {
                     wheel_size_price = 20;
     
                     //base_price = 477;
                 }
             }
             if ($('select#wheel_type').val() === "FRONT")
                 base_price = 379;
     
              if ($('select#wheel_type').val() === "REAR") {
                  if ($('select#rim_size').val() === "REAR 17x4.25") {
                      base_price = 379;
                      brake_price = 0;
                  }
              }
              if ($('select#bike_make').val() === "Surron") {
             if ($('select#wheel_type').val() === "FRONT"){
                 var brake_rotor = $('select#brake_rotor').val(); 
                 switch(brake_rotor) {
                     case '240MM_FIXED':
                     brake_price = 0;
                     break;
                     case '240MM_FLOATING':
                     brake_price = 45;
                     break;
                     case '260MM_FLOATING':
                     brake_price = 69;
                     break;
                     case '300MM_FLOATING':
                     brake_price = 44;
                     break;
                 }     			
             }else{
                 var brake_rotor = $('select#brake_rotor').val(); 
                 switch(brake_rotor) {
                     case '240MM_FIXED':
                     brake_price = 20;
                     break;
                     case '240MM_FLOATING':
                     brake_price = 47;
                     break;
                 }   
             }
             }
 
           //// console.log({brake_price});
     
             if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
                 if ($('#rim_color').val() === "Coyote-Tan" || $('#rim_color').val() === "Army-Green" || $('#rim_color').val() === "White" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "POrange" || $('#rim_color').val() === "School-Bus-Yellow" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Baby-Blue") {
                     rim_color = 35;
                 } else if ($('#rim_color').val() === "Teal" || $('#rim_color').val() === "Illusion-Violet") {
                     rim_color = 60;
                 } else {
                     rim_color = 0;
                 }
 
                 var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
                 var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'Blue','Army-Green', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet','Illusion-Violet','Teal'];
                 var specialColors = ['Illusion-Violet','Teal'];
                 var rim_color_value = $('#rim_color').val();
                 var rim_type = $('.rim-type-wrap.active').data('category');
                 // Pricing details
                 var standardPrice = 35;
                 var powderCoatPrice = 35;
                 var specialColorPrice = 60;                
 
                 if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
                     rim_color = standardPrice;
                 } else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
                     specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
                 } else {
                     rim_color =  35; // Default price if color/type is not recognized
                 }
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             var rim_type = $('.rim-type-wrap.active').data('category');			
             var rim_color_value = $('#rim_color').val();
             if (rim_type === 'anodized') {
                 if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
                     rim_color = 0;
                 }
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             //Mounted/Balanced Tire Price
             if ($('select#mbtire').val() === "mbyes") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 207;
                 }
                 if ($('select#rim_size').val() === "REAR 17x4.25") {
                   if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                     mbtire_price = 207;
                   }else{
                     mbtire_price = 207;
                   }
                     
                 }
                 if ($('select#rim_size').val() === "FRONT 17x3.00") {
                   if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                     mbtire_price = 207;
                   }
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 207;
                 }
             } else if ($('select#mbtire').val() === "DG300") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 130;
                 }
                 if ($('select#rim_size').val() === "REAR 17x4.25") {
                     mbtire_price = 130;
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 130;
                 }
             }
     
             if ($('select#rim_type').val() === "Elite")
                 base_price = base_price + 30;
     
     
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 } else {
                     base_price = base_price;
                 }
             }
             if ($('#spoke_color').val() === "Silver")
                 spoke_price = 0;
             if ($('#spoke_color').val() === "Titanium")
                 spoke_price = 179;
 
             if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
                 spoke_price = 65;
             }
 
             if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
                 nipple_price = 0;
     
             if ($('select#bike_make').val() === "GasGas") {
                 brake_price = 0;
             }

            //  check if rear or front for rotor price 
            if ($('#wheel_type').val() === "REAR") {
                if ($('select#brake_rotor').val() === "320MM_FLOATING") {
                    brake_price = 47;
                }
            }else if ($('#wheel_type').val() === "FRONT") {
                if ($('select#brake_rotor').val() === "320MM_FLOATING") {
                    brake_price = 50;
                }
            }
            
            
             if ($('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "701 Enduro *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "701 Enduro *REAR*") {
                 var base_price = 412;
                 brake_price = 0;
     
             } // here-here
             if (
                    $('select#bike_model').val() == '790 Adventure *REAR*' || 
                    $('select#bike_model').val() == '790 Adventure R *REAR*' || 
                    $('select#bike_model').val() == '890 Adventure *REAR*' || 
                    $('select#bike_model').val() == '890 Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1090 Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1190 Adventure *REAR*' ||
                    $('select#bike_model').val() == '1290 Adventure *REAR*' ||
                    $('select#bike_model').val() == '1290 Super Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1290 Super Adventure S *REAR*'
                ) {
                 var base_price = 615;
                 brake_price = 0;
     
             }
             if (
                    $('select#bike_model').val() == '790 Adventure *FRONT*' || 
                    $('select#bike_model').val() == '790 Adventure R *FRONT*' || 
                    $('select#bike_model').val() == '890 Adventure *FRONT*' || 
                    $('select#bike_model').val() == '890 Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1090 Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1190 Adventure *FRONT*' ||
                    $('select#bike_model').val() == '1290 Adventure *FRONT*' ||
                    $('select#bike_model').val() == '1290 Super Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1290 Super Adventure S *FRONT*'
                ) {
                 var base_price = 488;
                 brake_price = 0;
     
             } else if ($('select#bike_model').val() == "KLR650 *REAR* ") {
                 var base_price = 412;
                 brake_price = 0;
             } else if ($('select#bike_model').val() == "690 ENDURO ABS * REAR *") {
                 var base_price = 412;
                 brake_price = 0;
             } else if ($('select#bike_model').val() === "DR650 *REAR*") {
                 var base_price = 412;
                 brake_price = 0;
             }                
             else {
                 base_price = base_price;
             }
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 }
             }
              var cushsel = $('#cush_drive');
              if (cushsel.val() == "Cush Drive") {
                  cush_drive = 125;
                  base_price = base_price + cush_drive;
              } else {
                  base_price = base_price;
              }
              if ($('select#sprocket_bolts').val() === "Standard") {
                 sprocket_bolts = 0;
             }
             if ($('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "KLR650 *FRONT*") {
                 sprocket_bolts = 0;
             }
 
             if ($('select#bike_make').val() === "Surron") {
               if ($('select#sprocket_bolts').val() === "Standard") {
                   sprocket_bolts = 0;
               }else{
                   sprocket_bolts = 32;
               }
               if ($('select#rotor_bolts').val() === "Standard") {
                   rotor_bolts = 0;
               }
             }
           
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }
     
             if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
                 magnet_price = 0;
             } else {
                 magnet_price = 7;
             }
              //Tubeless wheel condition
              if ($('select#mtl').val() != "No") {
                  tubeless_wheel = 72;
              } else {
                  tubeless_wheel = 0;
              }
             //No SPROCKET
             if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
                sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
            else {
				sprocket_price = 0;
			}
 
             var mbtire = $('#mbtire').val();
             var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
             };
             var selectedPrice = tirePrices[mbtire];
             if (selectedPrice !== undefined) {
                 mbtire_price = selectedPrice;
             } else {
                 mbtire_price = mbtire_price
             }
 
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }else{
                 rotor_bolts = 21;				
             }
             // price-retail-price
             var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + magnet_price + mbtire_price + tubeless_wheel + sprocket_price ;
             price = roundUpIfEndsWith95(price);
             new_base_price = price;
             $('#price').text('$' + price);
             var retail_price = retailPrice();
             $('#retail-price').text('$' + retail_price);
 
             const wb_price_updated = new CustomEvent('wb_price_updated', {
                 detail: {
                     base_price,
                     spoke_price,
                     nipple_price,
                     brake_price,
                     wheel_size_price,
                     rim_color,
                     sprocket_bolts,
                     rotor_bolts,
                     magnet_price,
                     mbtire_price,
                     tubeless_wheel,
                     cush_drive,
                     price,
                     sprocket_price,
                 }
             });
             document.dispatchEvent(wb_price_updated);
             $('#amount').val(price);
             $('#dlr_price').val(price);
             $('#description1').val($('select#bike_make').val());
             $('#description2').val($('select#bike_model').val());
             $('#description3').val(" rim_size:" + $('select#rim_size').val());
             $('#description4').val(" hub_color:" + $('#hub_color').val());
             $('#description5').val(" rim_color:" + $('#rim_color').val());
             $('#description6').val(" spoke_color:" + $('#spoke_color').val());
             $('#description7').val(" nipple_color:" + $('#nipple_color').val());
             $('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
             $('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
 
 
            
         } else {
     
             var base_price = 500;
             var spoke_price = 65;
             var nipple_price = 35;
             var brake_price = 0;
             var wheel_size_price = 0;
             var rim_color = 0;
             var sprocket_bolts = 59;
             var rotor_bolts = 19;
             var magnet_price = 0;
             var mbtire_price = 0;
             var tubeless_wheel = 0;
             var cush_drive = 0;

             // Adjust brake price for 320MM_FLOATING rotor based on wheel type
            const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

             const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 85,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 81,
                    "REAR": 27
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

             if ($('select#wheel_type').val() === "REAR") {
                 if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "17X5.00") {
                     wheel_size_price = 29;
                     brake_price = 0;
                 }
             }
             if ($('select#wheel_type').val() === "FRONT")
                 base_price = 500;
     
              if ($('select#wheel_type').val() === "REAR") {
                  if ($('select#rim_size').val() === "REAR 17x4.25") {
                      base_price = 500;
                      brake_price = 0;
                  }
              }
                          if ($('select#bike_make').val() === "Surron") {
                 if ($('select#wheel_type').val() === "FRONT"){
                 var brake_rotor = $('select#brake_rotor').val(); 
                     switch(brake_rotor) {
                       case '240MM_FIXED':
                         brake_price = 0;
                         break;
                       case '240MM_FLOATING':
                         brake_price = 69;
                         break;
                       case '260MM_FLOATING':
                         brake_price = 89;
                         break;
                       case '300MM_FLOATING':
                        brake_price = 58;
                         break;
                     }     			
                 }else{
                  var brake_rotor = $('select#brake_rotor').val(); 
                     switch(brake_rotor) {
                       case '240MM_FIXED':
                         brake_price = 27;
                         break;
                       case '240MM_FLOATING':
                         brake_price = 62;
                         break;
                     }   
                 }
              }
 
           //// console.log({brake_price});
     
             if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
                 // if ($('#rim_color').val() === "Coyote-Tan" || $('#rim_color').val() === "Army-Green" || $('#rim_color').val() === "White" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "POrange" || $('#rim_color').val() === "School-Bus-Yellow") {
                 // 	rim_color = 50;
     
                 // } else if ($('#rim_color').val() === "Blue") {
                 // 	rim_color = 60;
                 // } else if ($('#rim_color').val() === "Baby-Blue") {
                 // 	rim_color = 60;
                 // } else if ($('#rim_color').val() === "Teal" || $('#rim_color').val() === "Illusion-Violet") {
                 // 	rim_color = 89;
                 // } else {
                 // 	rim_color = 0;
                 // }
                 var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
                 var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'Blue','Army-Green', 'Baby-Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet','Illusion-Violet','Teal'];
                 var specialColors = ['Illusion-Violet','Teal'];
                 var rim_color_value = $('#rim_color').val();
                 var rim_type = $('.rim-type-wrap.active').data('category');
                 // Pricing details
                 var standardPrice = 50;
                 var powderCoatPrice = 50;
                 var specialColorPrice = 80;
                 
                 if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
                     rim_color = standardPrice;
                 } else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
                     specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
                 } else {
                     rim_color =  50;
                 }
 
                 
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             var rim_type = $('.rim-type-wrap.active').data('category');			
             var rim_color_value = $('#rim_color').val();
             if (rim_type === 'anodized') {
                 if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
                     rim_color = 0;
                 }
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             //Mounted/Balanced Tire Price
             if ($('select#mbtire').val() === "mbyes") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 247;
                 }
 
                 
                 if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                   mbtire_price = 247;
                 }else{
                   mbtire_price = 247;
                 }
 
               
                 if ($('select#bike_make').val() === "Surron") {
                   if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                     mbtire_price = 247;
                   }else{
                     mbtire_price = 247;
                   }
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 247;
                 }
             } else if ($('select#mbtire').val() === "DG300") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 211;
                 }
                 if ($('select#rim_size').val() === "REAR 17x4.25") {
                     mbtire_price = 211;
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 211;
                 }
             }
     
             if ($('select#rim_type').val() === "Elite")
                 base_price = base_price + 30;
     
     
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 } else {
                     base_price = base_price;
                 }
             }
             if ($('#spoke_color').val() === "Silver")
                 spoke_price = 0;
             if ($('#spoke_color').val() === "Titanium")
                 spoke_price = 249;
                 if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
                     spoke_price = 89;
                 }
             if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
                 nipple_price = 0;
     
             if ($('select#bike_make').val() === "GasGas") {
                 brake_price = 0;
             }
             
            

             if ($('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "701 Enduro *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "701 Enduro *REAR*") {
                 var base_price = 515;
                 brake_price = 0;
     
             }
             if ($('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*") {
                 var base_price = 737;
                 brake_price = 0;
     
             }
             if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
                 var base_price = 649;
                 brake_price = 0;
     
             } else if ($('select#bike_model').val() == "KLR650 *REAR* ") {
                 var base_price = 515;
                 brake_price = 0;
             } else if ($('select#bike_model').val() == "690 ENDURO ABS * REAR *") {
                 var base_price = 515;
                 brake_price = 0;
             } else if ($('select#bike_model').val() === "DR650 *REAR*") {
                 var base_price = 515;
                 brake_price = 0;
             } else {
                 base_price = base_price;
             }
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 }
             }
             var cushsel = $('#cush_drive');
             if (cushsel.val() == "Cush Drive") {
                 cush_drive = 175;
                 base_price = base_price + cush_drive;
     
             } else {
                 base_price = base_price;
             }
             if ($('select#sprocket_bolts').val() === "Standard") {
                 sprocket_bolts = 0;
             }
             if ($('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "KLR650 *FRONT*") {
                 sprocket_bolts = 0;
             }
 
 
             if ($('select#bike_make').val() === "Surron") {
               if ($('select#sprocket_bolts').val() === "Standard") {
                   sprocket_bolts = 0;
               }else{
                   sprocket_bolts = 49;
               }
               if ($('select#rotor_bolts').val() === "Standard") {
                   rotor_bolts = 0;
               }
             }
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }
     
             if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
                 magnet_price = 0;
             } else {
                 magnet_price = 11;
             }
              //Tubeless wheel condition
              if ($('select#mtl').val() != "No") {
                  tubeless_wheel = 107;
              } else {
                  tubeless_wheel = 0;
              }
             //No SPROCKET
             if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
				sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
              sprocket_price = 0;

              var mbtire = $('#mbtire').val();
             var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
             };
             
             var selectedPrice = tirePrices[mbtire];
             if (selectedPrice !== undefined) {
                 mbtire_price = selectedPrice;
             } else {
                 mbtire_price = mbtire_price
             }
 
             
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }else{
                 rotor_bolts = 31;				
             }
           
             var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + magnet_price + mbtire_price + tubeless_wheel + sprocket_price;
             price = roundUpIfEndsWith95(price);
             new_base_price = price;
             const wb_price_updated = new CustomEvent('wb_price_updated', {
                 detail: {
                     base_price,
                     spoke_price,
                     nipple_price,
                     brake_price,
                     wheel_size_price,
                     rim_color,
                     sprocket_bolts,
                     rotor_bolts,
                     magnet_price,
                     mbtire_price,
                     tubeless_wheel,
                     cush_drive,
                     price,
                     sprocket_price,
                 }
             });
             document.dispatchEvent(wb_price_updated);
             $('#price').text('$' + price);
             $('#amount').val(price);
             $('#rgr_price').val(price);
             $('#description1').val($('select#bike_make').val());
             $('#description2').val($('select#bike_model').val());
             $('#description3').val(" rim_size:" + $('select#rim_size').val());
             $('#description4').val(" hub_color:" + $('#hub_color').val());
             $('#description5').val(" rim_color:" + $('#rim_color').val());
             $('#description6').val(" spoke_color:" + $('#spoke_color').val());
             $('#description7').val(" nipple_color:" + $('#nipple_color').val());
             $('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
             $('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
 
               return true;
     
         }
 
 
 
     }
     // retail price
     var retailPrice = function() {
 
             var base_price = 500;
             var spoke_price = 65;
             var nipple_price = 35;
             var brake_price = 0;
             var wheel_size_price = 0;
             var rim_color = 0;
             var sprocket_bolts = 59;
             var rotor_bolts = 19;
             var sprocket_price = 0;
             var magnet_price = 0;
             var mbtire_price = 0;
             var tubeless_wheel = 0;
 
             if ($('select#wheel_type').val() === "REAR") {
                 if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "17X5.00") {
                     var wheel_size_price = 29;
                     var brake_price = 0;
                 }
             }
             if ($('select#wheel_type').val() === "FRONT")
                 var base_price = 500;
 
             if ($('select#wheel_type').val() === "REAR") {
                 if ($('select#rim_size').val() === "REAR 17x4.25") {
                     var base_price = 500; // was 515
                     var brake_price = 0;
                 }
             }
            if ($('select#bike_make').val() === "Surron") {
                 if ($('select#wheel_type').val() === "FRONT"){
                 var brake_rotor = $('select#brake_rotor').val(); 
                     switch(brake_rotor) {
                         case '240MM_FIXED':
                         brake_price = 0;
                         break;
                         case '240MM_FLOATING':
                         brake_price = 69;
                         break;
                         case '260MM_FLOATING':
                         brake_price = 89;
                         break;
                         case '300MM_FLOATING':
                         brake_price = 119;
                         break;
                     }     			
                 }else{
                     var brake_rotor = $('select#brake_rotor').val(); 
                     switch(brake_rotor) {
                         case '240MM_FIXED':
                         brake_price = 0;
                         break;
                         case '240MM_FLOATING':
                         brake_price = 69;
                         break;
                     }   
                 }
                 }
 
             //// console.log({brake_price});
 
             if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
                 // if ($('#rim_color').val() === "Coyote-Tan" || $('#rim_color').val() === "Army-Green" || $('#rim_color').val() === "White" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "POrange" || $('#rim_color').val() === "School-Bus-Yellow") {
                 // 	rim_color = 50;
 
                 // } else if ($('#rim_color').val() === "Blue") {
                 // 	rim_color = 60;
                 // } else if ($('#rim_color').val() === "Baby-Blue") {
                 // 	rim_color = 60;
                 // } else if ($('#rim_color').val() === "Teal" || $('#rim_color').val() === "Illusion-Violet") {
                 // 	rim_color = 89;
                 // } else {
                 // 	rim_color = 0;
                 // }
                 var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
                 var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'Blue','Army-Green', 'Baby-Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet','Illusion-Violet','Teal'];
                 var specialColors = ['Illusion-Violet','Teal'];
                 var rim_color_value = $('#rim_color').val();
                 var rim_type = $('.rim-type-wrap.active').data('category');
                 // Pricing details
                 var standardPrice = 50;
                 var powderCoatPrice = 50;
                 var specialColorPrice = 80;
                 
                 if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
                     var rim_color = standardPrice;
                 } else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
                     specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
                 } else {
                     var rim_color =  50;
                 }
 
                 
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             var rim_type = $('.rim-type-wrap.active').data('category');			
             var rim_color_value = $('#rim_color').val();
             if (rim_type === 'anodized') {
                 if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
                     var rim_color = 0;
                 }
             }
             // RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
             //Mounted/Balanced Tire Price
             if ($('select#mbtire').val() === "mbyes") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 247;
                 }
 
                 
                 if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                     mbtire_price = 247;
                 }else{
                     mbtire_price = 247;
                 }
 
                 
                 if ($('select#bike_make').val() === "Surron") {
                     if ($('select#bike_model').val() === "Ultra Bee *FRONT*") {
                     mbtire_price = 247;
                     }else{
                     mbtire_price = 247;
                     }
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 247;
                 }
             } else if ($('select#mbtire').val() === "DG300") {
                 if ($('select#rim_size').val() === "FRONT 17x3.50") {
                     mbtire_price = 211;
                 }
                 if ($('select#rim_size').val() === "REAR 17x4.25") {
                     mbtire_price = 211;
                 }
                 if ($('select#rim_size').val() === "REAR 17x5.00") {
                     mbtire_price = 211;
                 }
             }
 
             if ($('select#rim_type').val() === "Elite")
                 base_price = base_price + 30;
 
 
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 } else {
                     base_price = base_price;
                 }
             }
             if ($('#spoke_color').val() === "Silver")
                 spoke_price = 0;
             if ($('#spoke_color').val() === "Titanium")
                 spoke_price = 249;
                 if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
                     spoke_price = 89;
                 }
             if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
                 nipple_price = 0;
 
             if ($('select#bike_make').val() === "GasGas") {
                 brake_price = 0;
             }
             const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 85,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 0, // 81
                    "REAR": 0 //27 
            }
        };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;
            // here-here
             if ($('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "701 Enduro *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "701 Enduro *REAR*") {
                 base_price = 515;
                 brake_price = 0;
 
             }
             if (
                    $('select#bike_model').val() == '790 Adventure *REAR*' || 
                    $('select#bike_model').val() == '790 Adventure R *REAR*' || 
                    $('select#bike_model').val() == '890 Adventure *REAR*' || 
                    $('select#bike_model').val() == '890 Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1090 Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1190 Adventure *REAR*' ||
                    $('select#bike_model').val() == '1290 Adventure *REAR*' ||
                    $('select#bike_model').val() == '1290 Super Adventure R *REAR*' ||
                    $('select#bike_model').val() == '1290 Super Adventure S *REAR*'
             ) {    
                console.log('applying rear reatil and dealer prices for KTMS ADV')
                 base_price = 790;
                 brake_price = 0;
 
             }
             if (
                    $('select#bike_model').val() == '790 Adventure *FRONT*' || 
                    $('select#bike_model').val() == '790 Adventure R *FRONT*' || 
                    $('select#bike_model').val() == '890 Adventure *FRONT*' || 
                    $('select#bike_model').val() == '890 Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1090 Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1190 Adventure *FRONT*' ||
                    $('select#bike_model').val() == '1290 Adventure *FRONT*' ||
                    $('select#bike_model').val() == '1290 Super Adventure R *FRONT*' ||
                    $('select#bike_model').val() == '1290 Super Adventure S *FRONT*'
             ) {
                 base_price = 635;
                 brake_price = 0;
 
             } else if ($('select#bike_model').val() == "KLR650 *REAR* ") {
                 base_price = 515;
                 brake_price = 0;
             } else if ($('select#bike_model').val() == "690 ENDURO ABS * REAR *") {
                 base_price = 515;
                 brake_price = 0;
             } else if ($('select#bike_model').val() === "DR650 *REAR*") {
                 base_price = 515;
                 brake_price = 0;
             } else {
                 base_price = base_price;
             }
             var carrier_css = $("#sprocket").css('display');
             if (carrier_css == "block") {
                 var carrier = $('#carrier_id');
                 if (carrier.val() == "Yes") {
                     base_price = base_price + 175;
                 }
             }
             var cushsel = $('#cush_drive');
             if (cushsel.val() == "Cush Drive") {
                 base_price = base_price + 175;
 
             } else {
                 base_price = base_price;
             }
             if ($('select#sprocket_bolts').val() === "Standard") {
                 sprocket_bolts = 0;
             }
             if ($('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "KLR650 *FRONT*") {
                 sprocket_bolts = 0;
             }
 
 
             if ($('select#bike_make').val() === "Surron") {
                 if ($('select#sprocket_bolts').val() === "Standard") {
                 sprocket_bolts = 0;
                 }else{
                     sprocket_bolts = 49;
                 }
                 if ($('select#rotor_bolts').val() === "Standard") {
                     rotor_bolts = 0;
                 }
             }
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }
 
             if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
                 magnet_price = 0;
             } else {
                 magnet_price = 11;
             }
              //Tubeless wheel condition
              if ($('select#mtl').val() != "No") {
                  tubeless_wheel = 107;
              } else {
                  tubeless_wheel = 0;
              }
             //No SPROCKET
             if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
		
				sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
            else {
				sprocket_price = 0;
			}
 
             var mbtire = $('#mbtire').val();
             var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
             };
             
             var selectedPrice = tirePrices[mbtire];
             if (selectedPrice !== undefined) {
                 mbtire_price = selectedPrice;
             } else {
                 mbtire_price = mbtire_price
             }
 
             
             if ($('select#rotor_bolts').val() === "Standard") {
                 rotor_bolts = 0;
             }else{
                 rotor_bolts = 31;				
             }
             
             var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + magnet_price + mbtire_price + tubeless_wheel + sprocket_price;
             price = roundUpIfEndsWith95(price);             
             return price;
 
 
     }
     // retail price
     //Wheel RimType
     $('select#wheel_type').change(function() {
 
         var bikeModelSelect = document.getElementById("bike_model");
         const selectedText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;
 
         var select_model = $('select#bike_model');
         $("option:selected", select_model).removeAttr("selected");
         $('select#hidden_bike_model option').appendTo('select#bike_model');
         switch (this.value) {
             default:
             case 'FRONT':
                 $('select#bike_model option.rear').appendTo('select#hidden_bike_model');
                 $('#brake-rotor-tr').show();
                 var rim_size = {
                     'FRONT 17x3.50': 'FRONT 17x3.50',
                     'FRONT 16.5x3.50': 'FRONT 16.5x3.50'
                 };
 
                if($('select#bike_model').val() == "Ultra Bee *FRONT*"){
                 var rim_size = {
                 'FRONT 17x3.00': 'FRONT 17x3.00'
                 };
                 
                 var brake_rotor = {
                                     '240MM_FIXED': '240mm x 2.3 Fixed',
                                     '240MM_FLOATING': '240mm Blue Button Floating Rotor',
                                     '260MM_FLOATING': '260mm Blue Button Floating Rotor with bracket',
                                     '300MM_FLOATING': '300mm Blue Button Floating Rotor with bracket'
                 };
                 var brakeRotorSelect = $("select#brake_rotor");
                 // console.log(brake_rotor);
                 $.each(brake_rotor, function (value, text) {
                 // Create a new option element and append it to the select element
                 brakeRotorSelect.append(
                   $("<option>", {
                     value: value,
                     text: text,
                   })
                 );
                 });
                 $('select#brake-rotor-tr').show();
                }
     
                 var rim_size_element = $('#rim_size');
                 var rim_size_select = rim_size_element.prop('options');
                 $('option', rim_size_element).remove();
                 var rimSizeSelect = $("select#rim_size");
                 $.each(rim_size, function(value, text) {
                     // Create a new option element and append it to the select element
                     rimSizeSelect.append(
                         $("<option>", {
                             value: value,
                             text: text,
                         })
                     );
                 });
                 break;
             case 'REAR':
                 $('select#bike_model option.front').appendTo('select#hidden_bike_model');
                 $('#brake-rotor-tr').hide();
                 var rim_size = {
                     'REAR 17x4.25': 'REAR 17x4.25',
                     'REAR 17x5.00': 'REAR 17x5.00'
                 };
                 // console.log('new val:', $('select#bike_model').val());
                 if($('select#bike_model').val() == "Ultra Bee * REAR *"){
                   var rim_size = {
                         'REAR 17x4.25': 'REAR 17x4.25'
                     };
                     var brake_rotor = {
                         '240MM_FIXED': '240mm Fixed',
                         '240MM_FLOATING': ' 240mm Floating'
                     };
                     var brakeRotorSelect = $("select#brake_rotor");
                     $.each(brake_rotor, function (value, text) {
                     // Create a new option element and append it to the select element
                     brakeRotorSelect.append(
                       $("<option>", {
                         value: value,
                         text: text,
                       })
                     );
                  });
                 $('select#brake-rotor-tr').show();
                   
               }    
               var rim_size_element = $('#rim_size');
               var rim_size_select = rim_size_element.prop('options');
               $('option', rim_size_element).remove();
               var rimSizeSelect = $("select#rim_size");
               $.each(rim_size, function(value, text) {
                   // Create a new option element and append it to the select element
                   rimSizeSelect.append(
                       $("<option>", {
                           value: value,
                           text: text,
                       })
                   );
               });                
               break;
         }
         select_model.val(select_model.find('option').first().val()).change();
 
         var bikeModelSelect = document.getElementById("bike_model");
         var options = bikeModelSelect.options;
 
         for (let i = 0; i < options.length; i++) {
             if (options[i].text === selectedText) {
                 bikeModelSelect.selectedIndex = i;
                 break;
             }
         }
 
         select_model.change();
 
         $('#rotor_bolts').prop('selectedIndex', 0);

     });
 
 
   $('select#brake_rotor').change(function() {
     updateSurronImage();
   });
 
    $('select#wheel_type').change(function() {
     //// console.log("On wheel type change : ", $('select#bike_model').val());
        if ($('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Husqvarna" || $('select#bike_model').val() == "CR125-CR250 *REAR*" || $('select#bike_model').val() == "CR125-CR250 *REAR*" || $('select#bike_model').val() == "CRF250L *REAR*" || $('select#bike_model').val() == "CRF300L *REAR*" || $('select#bike_model').val() == "CRF300L ABS *REAR*" || $('select#bike_model').val() == "CRF300L Rally *REAR*" || $('select#bike_model').val() == "CRF300L Rally ABS *REAR*" || $('select#bike_model').val() == "CRF250L ABS *REAR*" || $('select#bike_model').val() == "CRF250L RALLY *REAR*" || $('select#bike_model').val() == "CRF250R *REAR*" || $('select#bike_model').val() == "CRF250X *REAR*" || $('select#bike_model').val() == "XR4000 *REAR*" || $('select#bike_model').val() == "CRF450R *REAR*" || $('select#bike_model').val() == "CRF450R WORKS EDITION *REAR*" || $('select#bike_model').val() == "CRF450L *REAR*" || $('select#bike_model').val() == "CRF450RL *REAR*" || $('select#bike_model').val() == "CRF450X *REAR*" || $('select#bike_model').val() == "CRF450RX *REAR*" || $('select#bike_model').val() == "CRF250RX *REAR*") {
            if ($('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "701 Enduro *REAR*") {
                // $('#sprocket').css("display", "block");
            }
            var select = $('#sprocket_size');
            // select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option>');
        }
        //BRAKE TYPE
        if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
            var image_name = images + "dual-rotor-" + $('select#wheel_type').val() + ".png";
            var imageArr5 = [image_name];
            var divArr5 = ["resultAreaID_1_6"];
         //// console.log({image_name});
            $('#resultAreaID_1_6 img').attr('src', image_name);
        } 
     else if($('select#bike_make').val() == 'Surron'){
       updateSurronImage();
     }
     else {
         // https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-fixed-REAR.png?v=1708578145
            var image_name = rotorImage + $('select#brake_rotor').val() + "-" + $('select#wheel_type').val() + ".png";
         // //// console.log(image_name);
            var imageArr5 = [image_name];
            var divArr5 = ["resultAreaID_1_6"];
         //// console.log({image_name});
            $('#resultAreaID_1_6 img').attr('src', image_name);
         if($('select#bike_make').val() == 'Surron'){
          updateSurronImage();
         }
        }
        //HUB COLOR
        var image_name = images + "hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
        var imageArr1 = [image_name];
        var divArr1 = ["resultAreaID_1_0"];
        $('#resultAreaID_1_0 img').attr('src', image_name);
        //RIM COLOR
        var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
        var imageArr2 = [image_name];
        var divArr2 = ["resultAreaID_1_1"];
        $('#resultAreaID_1_1 img').attr('src', image_name);
        //SPOKE COLOR
        var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
        var imageArr3 = [image_name];
        var divArr3 = ["resultAreaID_1_2"];
        $('#resultAreaID_1_2 img').attr('src', image_name);
        // $("#resultAreaID_1_2").find("img").unwrap();
        //NIPPLE COLOR
        var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
        var imageArr4 = [image_name];
        var divArr4 = ["resultAreaID_1_3"];
        $('#resultAreaID_1_3 img').attr('src', image_name);
        // $("#resultAreaID_1_3").find("img").unwrap();
        //SPROCKET SIZE
        var image_name = images + "sprocket.png";
        var imageArr6 = [image_name];
        var divArr6 = ["resultAreaID_1_7"];
        $('#resultAreaID_1_7 img').attr('src', image_name);
   
        if ($('select#bike_make').val() == 'KTM' && $('select#wheel_type').val() == 'REAR') {
            var select = $('#sprocket_size');
            // select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option>');
        }
   
        /*else {
        var select = $('#sprocket_size');
        select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option>');
        
        }*/
   
        if ($('select#wheel_type').val() == 'FRONT') {
            // $('#sprocket').hide();
            $('#resultAreaID_1_7').hide();
            $('#brake_rotor').prop("disabled", false);
        } else {
            // $('#sprocket').show();
            sprockethide();
            //$('#brake_rotor').prop("disabled", true);
        }
        var bike_make = $('select#bike_make').val();
      // //// console.log({bike_make})
        if ($('select#bike_model').val() == "SM/TC/TE/TXC 250/449/450/510/610 *FRONT*" || $('select#bike_model').val() == "TXC250 *FRONT*" || $('select#bike_model').val() == "WR250 *FRONT*" || $('select#bike_model').val() == "TX300 *FRONT*" || $('select#bike_model').val() == "WR300 *FRONT*" || $('select#bike_model').val() == "TC310 *FRONT*" || $('select#bike_model').val() == "TE310 *FRONT*" || $('select#bike_model').val() == "TXC310 *FRONT*" || $('select#bike_model').val() == "FE350 *FRONT*" || $('select#bike_model').val() == "FX350 *FRONT*" || $('select#bike_model').val() == "WR360 *FRONT*" || $('select#bike_model').val() == "TE410 *FRONT*" || $('select#bike_model').val() == "TC449 *FRONT*" || $('select#bike_model').val() == "TE449 *FRONT*" || $('select#bike_model').val() == "FE450 *FRONT*" || $('select#bike_model').val() == "FX450 *FRONT*" || $('select#bike_model').val() == "TC450 *FRONT*" || $('select#bike_model').val() == "TE450 *FRONT*" || $('select#bike_model').val() == "TXC450 *FRONT*" || $('select#bike_model').val() == "TC510 *FRONT*" || $('select#bike_model').val() == "TE510 *FRONT*" || $('select#bike_model').val() == "TXC510 *FRONT*" || $('select#bike_model').val() == "TE511 *FRONT*" || $('select#bike_model').val() == "TXC511 *FRONT*" || $('select#bike_model').val() == "TC570 *FRONT*" || $('select#bike_model').val() == "TE570 *FRONT*" || $('select#bike_model').val() == "TC610 *FRONT*" || $('select#bike_model').val() == "TE610 *FRONT*" || $('select#bike_model').val() == "TE630 *FRONT*" || $('select#bike_model').val() == "SM/TC/TE/TXC 250/450/510/610 *REAR*" || $('select#bike_model').val() == "TX300 *REAR*" || $('select#bike_model').val() == "WR300 *REAR*" || $('select#bike_model').val() == "TC310 *REAR*" || $('select#bike_model').val() == "TE310 *REAR*" || $('select#bike_model').val() == "FC350 *REAR*" || $('select#bike_model').val() == "FE350 *REAR*" || $('select#bike_model').val() == "FX350 *REAR*" || $('select#bike_model').val() == "WR360 *REAR*" || $('select#bike_model').val() == "TE410 *REAR*" || $('select#bike_model').val() == "FE450 *REAR*" || $('select#bike_model').val() == "FX450 *REAR*" || $('select#bike_model').val() == "TC450 *REAR*" || $('select#bike_model').val() == "TE450 *REAR*" || $('select#bike_model').val() == "TXC450 *REAR*" || $('select#bike_model').val() == "TC510 *REAR*" || $('select#bike_model').val() == "TE510 *REAR*" || $('select#bike_model').val() == "TXC510 *REAR*" || $('select#bike_model').val() == "TC570 *REAR*" || $('select#bike_model').val() == "TE570 *REAR*" || $('select#bike_model').val() == "TC610 *REAR*" || $('select#bike_model').val() == "TE610 *REAR*" || $('select#bike_model').val() == "TC/TE 449/511 *REAR*" || $('select#bike_model').val() == "TE449 *REAR*" || $('select#bike_model').val() == "TXC449 *REAR*" || $('select#bike_model').val() == "TE511 *REAR*" || $('select#bike_model').val() == "TXC511 *REAR*" || $('select#bike_model').val() == "CR/WR 125-250 *REAR*") {
            //   $('#rotor_bolt').css("display", "none"); 
        } else if (bike_make == "KTM" || bike_make == "Husqvarna"|| bike_make == "Surron" || bike_make == "Honda" || bike_make == "Yamaha" || bike_make == "BMW" || bike_make == "GasGas" || bike_make == "Husaberg" || bike_make == "Sherco" || bike_make == "TM") {
            $('#rotor_bolt').css("display", "block");
        } else {
   
            if (bike_make == "Kawasaki" || bike_make == "Suzuki") {
                if ($('select#bike_model').val() == "KX250F *FRONT*" || $('select#bike_model').val() == "KX250XC *FRONT*" || $('select#bike_model').val() == "KX450F *FRONT*" || $('select#bike_model').val() == "KX450XC *FRONT*" || $('select#bike_model').val() == "KLX 300R *FRONT*" || $('select#bike_model').val() == "KX250F *REAR*" || $('select#bike_model').val() == "KX250XC *REAR*" || $('select#bike_model').val() == "KX450F *REAR*" || $('select#bike_model').val() == "KX450XC *REAR*" || $('select#bike_model').val() == "KLX 300R *REAR*" || $('select#bike_model').val() == "KX125 *FRONT*" || $('select#bike_model').val() == "KX250 *FRONT*" || $('select#bike_model').val() == "KLX450R *FRONT*" || $('select#bike_model').val() == "KX125 *REAR*" || $('select#bike_model').val() == "KX250 *REAR*" || $('select#bike_model').val() == "KLX450R *REAR*" || $('select#bike_model').val() == "DR650 *FRONT*" || $('select#bike_model').val() == "DR650 *REAR*") {
                    $('#rotor_bolt').css("display", "block");
                } else {
                    $('#rotor_bolt').css("display", "none");
                }
            }
   
        }
        if ($('select#bike_model').val() == "CRF250L *FRONT*" || $('select#bike_model').val() == "CRF300L *FRONT*" || $('select#bike_model').val() == "CRF300L ABS *FRONT*" || $('select#bike_model').val() == "CRF300L Rally *FRONT*" || $('select#bike_model').val() == "CRF300L Rally ABS *FRONT*" || $('select#bike_model').val() == "CRF250L ABS *FRONT*" || $('select#bike_model').val() == "CRF250L *REAR*" || $('select#bike_model').val() == "CRF300L *REAR*" || $('select#bike_model').val() == "CRF300L ABS *REAR*" || $('select#bike_model').val() == "CRF300L Rally *REAR*" || $('select#bike_model').val() == "CRF300L Rally ABS *REAR*" || $('select#bike_model').val() == "CRF250L ABS *REAR*") {
            //	$('#rotor_bolt').css("display", "none");
        }
   
   
   
        if ($('select#wheel_type').val() === "FRONT") {
            var select = $('#rim_type');
            select.empty().append('<option class="category" value="Standard">Standard</option>');      
         $('select#rotor_bolt').show();
   
        } else {
            var select = $('#rim_type');
            select.empty().append('<option class="category" value="Standard">Standard</option>');
         $('#mbtire').show();      
         $('select#rotor_bolt').hide();
        }
        if ($('select#bike_model').val() === "DR650 *REAR*" || $('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "701 Enduro *REAR*") {
            $("#resultAreaID_1_6").attr('style', 'width:150px;height:95px;');
        } else {
            if ($('select#wheel_type').val() == 'REAR') {
                //$("#resultAreaID_1_6").attr('style','width:188px;height:185px;');
                //$(".text").attr('style','margin-top: 209px;');
   
            } else {
                $("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
                $(".text").attr('style', 'margin-top: 209px;');
            }
        }
        $('#rotor_bolts').prop('selectedIndex', 0);
        //Call to tubeless wheel function
        tubelesswheel();
        if ($('select#rim_size').val() == 'FRONT 17x3.50' || $('select#rim_size').val() == 'FRONT 16.5x3.50' || $('select#rim_size').val() == 'REAR 17x4.25' || $('select#rim_size').val() == 'REAR 17x5.00') {
            $('#mtl').prop('selectedIndex', 0);
            if ($('select#mtl').val() == "No") {
                $('#resultAreaID_1_11').hide();
            } else {
                $('#resultAreaID_1_11').show();
                var image_name = images + "tubeless-" + $('select#mtl').val() + "-" + $('select#wheel_type').val() + ".png";
                var imageArr10 = [image_name];
                var divArr10 = ["resultAreaID_1_11"];
                $('#resultAreaID_1_11 img').attr('src', image_name);
            }
        }
   
        if (!$('#mbtire option').filter('[value="mbno"]').length) {
            $('#mbtire').append($('<option>').val('mbno').text('No'));
        }
        //$('#mbtire').prop('selectedIndex', 2);
        //Fron suspension Logic//
        if ($('select#wheel_type').val() == "FRONT" & $('select#bike_make').val() == 'Sherco') {
            $('#frontsuspension').show();
        } else {
            $('#frontsuspension').hide();
   
        }
     // //// console.log($('select#bike_model').val());
     if ($('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* ") {
         $('#sprocketbolts').css("display", "none");
 
     } else {
         // //// console.log('on the else');
         if ($('select#wheel_type').val() == "FRONT") {
             $('#sprocketbolts').css("display", "none");
         } else if ($('select#wheel_type').val() == "REAR") {
 
             $('#sprocketbolts').css("display", "block");
 
         } else {
             $('#sprocketbolts').css("display", "block");
         }
     }
        hide320mm();
        nosprocket();
        //gasgasbrakeremove();
        
    });
   
     $(document).on("change", "#rim_color", function() {
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr2 = [image_name];
         var divArr2 = ["resultAreaID_1_1"];
         // $('#resultAreaID_1_1 img').attr('src', image_name );
         $('#resultAreaID_1_1 img').attr('src', image_name);
     });
 
     var rimcolorSwatches = $('.rim_color_wrapper .color-swatch');
     var rimHiddenInput = $('#rim_color');
 
     $(document).on("click", '.rim_color_wrapper .color-swatch', function() {
         var colorValue = $(this).data('value');
         rimcolorSwatches.removeClass('active');
         $(this).addClass('active');
         rimHiddenInput.val(colorValue);
         //// console.log({colorValue});
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
         $('#resultAreaID_1_1 img').attr('src', image_name);
         tprice();
         var colorTitle = $(this).attr('title') || $(this).data('value');
         $('#selected_rim_color').html(colorTitle.replaceAll('-', " "));
     });
 
     // Hub Color
     var hubcolorSwatches = $('.hub_color_wrapper .color-swatch');
     var hubHiddenInput = $('#hub_color');
 
 
     $(document).on("click", '.hub_color_wrapper .color-swatch', function() {
         var colorValue = $(this).data('value');
         hubcolorSwatches.removeClass('active');
         $(this).addClass('active');
         hubHiddenInput.val(colorValue);
         // //// console.log(colorValue);
         if ($('select#cush_drive').val() == "Cush Drive") {
             //Display Cush Hub
             var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-cush-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
             var imageArr1 = [image_name];
             var divArr1 = ["resultAreaID_1_0"];
             // $('#resultAreaID_1_0 img').attr('src', image_name );
 
             if ($('select#carrier_id').val() == "Yes") {
 
                 //sprocket, carrier, and rubbers for Cush 
                 var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-" + $('#hub_color').val() + "-sprocket-and-carrier500.png";
                 var imageArr5 = [image_name];
                 var divArr5 = ["resultAreaID_1_6"];
                 //// console.log({image_name});
                 $('#resultAreaID_1_6 img').attr('src',image_name);
                 document.getElementById("resultAreaID_1_7").innerHTML = "";
             } else {
                 if ($('select#bike_model').val() === "DR650 * REAR *" || $('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* ") {
                     document.getElementById("resultAreaID_1_7").innerHTML = "";
                 } else {
                     //sprocket, carrier, and rubbers for Cush 
                     var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-rubbers.png";
                     var imageArr7 = [image_name];
                     var divArr7 = ["resultAreaID_1_7"];
                     $('#resultAreaID_1_7 img').attr('src',image_name);
 
                     var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-" + $('#hub_color').val() + "-sprocket-and-carrier500.png";
                     var imageArr5 = [image_name];
                     var divArr5 = ["resultAreaID_1_6"];
                     //// console.log({image_name});
                     $('#resultAreaID_1_6 img').attr('src',image_name);
                 }
             };
             $('#resultAreaID_1_4').show();
         } else {
             var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
             var imageArr1 = [image_name];
             var divArr1 = ["resultAreaID_1_0"];
             $('#resultAreaID_1_0 img').attr('src', image_name);
 
             var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-sprocket.png";
             var imageArr6 = [image_name];
             var divArr6 = ["resultAreaID_1_7"];
             $('#resultAreaID_1_7 img').attr('src',image_name );
         }
        tprice();
        var colorTitle = $(this).attr('title') || $(this).data('value');
         $('#selected_hub_color').html(colorTitle);
 
       var activeNippleColor = $('.nipple_color_wrapper .active').data('value');
        $('#nipple_color').val(activeNippleColor);
     });
 
       var nipplecolorSwatches = $('.nipple_color_wrapper .color-swatch');
       var nippleHiddenInput = $('#nipple_color');
       $(document).on("click", '.nipple_color_wrapper .color-swatch', function() {
           var colorValue = $(this).data('value');
           nipplecolorSwatches.removeClass('active');
           $(this).addClass('active');
           nippleHiddenInput.val(colorValue);
           var image_name = images+"nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
           $('#resultAreaID_1_3 img').attr('src', image_name);
         tprice();
         var colorTitle = $(this).attr('title') || $(this).data('value');
         $('#selected_nipple_color').html(colorTitle);
       });
 
       // Spoke Color
       var spokecolorSwatches = $('.spoke_color_wrapper .color-swatch');
       var spokeHiddenInput = $('#spoke_color');
   
       $(document).on("click", '.spoke_color_wrapper .color-swatch', function() {
         var colorValue = $(this).data('value'); 
         spokecolorSwatches.removeClass('active'); 
         $(this).addClass('active'); 
         // //// console.log(colorValue)
         spokeHiddenInput.val(colorValue);
         if ($('select#cush_drive').val() != "unavailable") {
             //Display Cush Spokes
             var image_name = images+"cush-spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
             $('#resultAreaID_1_2 img').attr('src', image_name);
         } else {
             //SPOKE COLOR
             var image_name = images+"spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
             $('#resultAreaID_1_2 img').attr('src', image_name);
         }
         tprice();
         var colorTitle = $(this).attr('title') || $(this).data('value');
         $('#selected_spoke_color').html(colorTitle);
       });
 
   $('select#mtl').change( function () {
     tubelesswheel();
     if($('select#mtl').val() != "No") {
         $('#mbtire').prop('selectedIndex', 0);
         // $('#mbtire option').eq(2).remove();
         // $('#resultAreaID_1_10').show();
         //$('#resultAreaID_1_8').show();
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-"+$("select#wheel_type").val()+"-tire650.png";
         var imageArr9 = [image_name];
         var divArr9 = [	"resultAreaID_1_10"];
         // $('#resultAreaID_1_10 img').attr("src", image_name);
         //$('#resultAreaID_1_8 img').attr("src", image_name);
     }
     else {
         // $('#resultAreaID_1_10').hide();
         if (!$('#mbtire option').filter('[value="mbno"]').length) {
         $('#mbtire').append($('<option>').val('mbno').text('No'));
         }
     }
    });	
 
   $('select#mbtire').change(function() {
     if ($('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {
         $("#resultAreaID_1_10").show();
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-" + $("select#wheel_type").val() + "-tire650.png";
         var imageArr9 = [image_name];
         var divArr9 = ["resultAreaID_1_10"];
         $('#resultAreaID_1_10 img').attr("src", image_name);
         //$('#resultAreaID_1_8 img').attr("src", image_name);
     } else {
         $("#resultAreaID_1_10").hide();
     }
 });
 
   $('select#brake_rotor').change(function() {
 
     cushsel = $('#cush_drive');
     if (cushsel.val() == "available") {
 
     }
     if ($('select#bike_model').val() === "DR650 *REAR*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "690 ENDURO * REAR *" || $('select#bike_model').val() == "690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "701 Enduro *REAR*") {
         $("#resultAreaID_1_6").attr('style', 'width:150px;height:95px;');
     } else {
         if ($('select#brake_rotor').val() === "320MM_FLOATING") {
             $("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
             $(".text").attr('style', 'margin-top: 209px;');
         } else {
             $("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
             $(".text").attr('style', 'margin-top: 209px;');
         }
     }
     if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
         var image_name = images+"dual-rotor-" + $('select#wheel_type').val() + ".png";
         var imageArr5 = [image_name];
         $('#resultAreaID_1_6 img').attr("src", image_name);
     }else if($('select#bike_make').val() == 'Surron'){
       updateSurronImage();
     } else {
         var image_name = images+"brake-" + $('select#brake_rotor').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr5 = [image_name];
         $('#resultAreaID_1_6 img').attr("src", image_name);
     }
 });
 
   $('select#rim_size').change(function() {
    document.querySelector('.rim-type-wrap.anodized[data-category="anodized"]').click();
     if ($('select#rim_size').val() == 'FRONT 16.5x3.50') {
         var select = $('#rim_color');
         var rim_color_wrapper = $('.rim_color_wrapper');
         rim_color_wrapper.find('.color-swatch[data-category="anodized"]').remove();
         rim_color_wrapper.append(`<div class="color-swatch category active" data-category="anodized" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch category active" data-category="anodized" data-value="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>`);
         showColors('anodized');
         const activeColor = document.querySelector('.rim_color_wrapper .color-swatch.category.active.show');
         activeColor.click();
         // select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option>');
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr2 = [image_name];
         var divArr2 = ["resultAreaID_1_1"];
         $('#resultAreaID_1_1 img').attr("src", image_name);
     } else {
         var select = $('#rim_color');
         var rim_color_wrapper = $('.rim_color_wrapper');
         rim_color_wrapper.find('.color-swatch[data-category="anodized"]').remove();
         rim_color_wrapper.append(`<div class="color-swatch category" data-category="anodized" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div><div class="color-swatch category" data-category="anodized" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>`);
         
         showColors('anodized');
 
         const anodizedColorSwatches = document.querySelectorAll('.rim_color_wrapper .color-swatch[data-category="anodized"]');
         anodizedColorSwatches.forEach((swatch) => {
             swatch.addEventListener('click', (e) => {
                 anodizedColorSwatches.forEach(s => s.classList.remove('active'));
                 e.currentTarget.classList.add('active');
             });
         });
         var active_category = document.querySelector('.rim-type-wrap.active').getAttribute('data-category');
         const activeColor = document.querySelector('.rim_color_wrapper .color-swatch.category.active.show') ? document.querySelector('.rim_color_wrapper .color-swatch.category.active.show') : document.querySelector(`.rim_color_wrapper .color-swatch.category[data-category="${active_category}"]`);
         activeColor.click();
         // TO DO
         // select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="POrange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
         var imageArr2 = [image_name];
         var divArr2 = ["resultAreaID_1_1"];
         $('#resultAreaID_1_1 img').attr("src", image_name);
     }
     
     //Mounted/Balanced Tire Field Code
     //// console.log("rim size"+ $('select#rim_size').val());
     $('select#mbtire').val("mbno");
     if ($('select#rim_size').val() === "FRONT 17x3.50" || $('select#rim_size').val() ===  "FRONT 17x3.50") {
         if ($('select#mtl').val() != "No") {
             $('#mbtiretr').show();
             $('#mbtire').prop('selectedIndex', 0);
             // $('#mbtire option').eq(2).remove();
         } else {
             $('#mbtiretr').show();
             if (!$('#mbtire option').filter('[value="mbno"]').length) {
                 $('#mbtire').append($('<option>').val('mbno').text('No'));
             }
             if ($('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {
                 $('#resultAreaID_1_10').show();
                 //$('#resultAreaID_1_8').show();
                 var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sm-" + $("select#wheel_type").val() + "-tire650.png";
                 var imageArr5 = [image_name];
                 $('#resultAreaID_1_10 img').attr("src", image_name);
                 //$('#resultAreaID_1_8 img').attr("src", image_name);
             }
         }
       } else if ($('select#rim_size').val() === "REAR 17x4.25" || $('select#rim_size').val() === "REAR 17x5.00") {
           $('#mbtiretr').show();
           if ($('select#mtl').val() != "No") {
               $('#mbtire').prop('selectedIndex', 0);
           } else {
               $('select#mbtire').val("mbno");
               $('#resultAreaID_1_10').hide();
           }
       } else {
       // //// console.log("Here ");
           $('#mbtiretr').hide();
           $('select#mbtire').val("mbno");
           $('#resultAreaID_1_10').hide();
       }
       //Call to tubeless wheel function
       tubelesswheel();
   });
 
     function hideShowRimColor(rim_type, rim_size){
      if(rim_type == 'Elite'){
        //only powder coated rim
        $(".rim-type-wrap.powder-coat").trigger("click");       
        $(".rim-type-wrap.anodized").hide();
      }else{
        //show all rims
        $(".rim-type-wrap.anodized").show();
        $(".rim-type-wrap.anodized").trigger("click");       
      }
     }
 
     $('select#rim_type').change(function() {
       var rim_type= $('select#rim_type').val();
       var rim_size = $('select#rim_size').val();
       var rimcolor = hideShowRimColor(rim_type,rim_size );
     });
 
   $('select#bike_model').change(speedometer);
     $('select#bike_make').change(bikeyear);
     $('document').on('change', 'select#bike_model', function(){
         bikeyear();
     })
     $('select#bike_model').change(spoketitanium);
     $('select#bike_make').change(speedometer);
     $('select#wheel_type').change(speedometer);
     $('select#bike_year').change(speedometer);
 
     $('select#bike_year').change(spoketitanium);
     $('select#rim_size').change(spoketitanium);
     $('select#wheel_type').change(spoketitanium);
 
     // change year on wheel type
     $('select#wheel_type').change(bikeyear);
     $('select#bike_model').change(bikeyear);
 
       $('select#bike_make').change(tprice);
     $('select#bike_model').change(tprice);
     $('select#carrier_id').change(tprice);
   
   
     $('select#rim_size').change(tprice);
     $('select#brake_rotor').change(tprice);
     $('select#sprocket_size').change(tprice);
     $('select#wheel_type').change(tprice);
     $('select#rim_type').change(tprice);
     $('select#cush_drive').change(tprice);
     $('select#sprocket_bolts').change(tprice);
     $('select#rotor_bolts').change(tprice);
     $('select#sm_magnets').change(tprice);
     $(document).on('change', 'select, input', function(){
       tprice();
     });
   //   $('select#mtl').change(tprice);
   // alert('as')
     $(document).on('change', 'select#mtl',  tprice)
     $(document).on('change', 'select#mbtire',  tprice)
     $('select#make_tubeless').change(tprice);
   // Function to transform the fieldName
 function transformFieldName(name) {
     return name.replace(/_/g, ' ')
                .replace(/\w\S*/g, function(txt){
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
 }
 
 // Function to transform the fieldValue
 function transformFieldValue(value) {
     return value ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : value;
 }
 
  function collectFormData() {
         var formDataArray = [];
         $('#custom-wheel-form select, #custom-wheel-form input[type="text"], #custom-wheel-form input[type="hidden"]').each(function() {
             var fieldName = $(this).attr('name');
             var fieldValue = $(this).val();
             if (fieldName) {
                 var fieldData = {
                     name: transformFieldName(fieldName),
                     value: transformFieldValue(fieldValue)
                 };
                 formDataArray.push(fieldData);
             }
         });
         return formDataArray;
     }

        $('select#wheel_type').change(function() {
               setTimeout(function () {
            $('#sprocket_size').val('no').change();
        }, 500);
         });

 
   $('.act-btn-custom').on('click', function() {
       var selectedvariant = $('#custom-wheel-form').attr("data-variantid");
       var totalpersonalizeitem = parseInt(new_base_price - base_price ) / 0.01;
       var title = $('.product-info-heading ').text();
       // //// console.log(base_price, new_base_price, totalpersonalizeitem);
       var withtire = "45197118308600";
       var withouttire = "45197118341368";
       var tirevalue = $('select#mbtire').val();
       selectedvariant = withouttire;
       
         var rim_size = document.querySelector('#rim_size').value;
         var wheel_type = document.querySelector('#wheel_type').value;
         var has_tire = document.querySelector('#mbtire').value
 
         if(wheel_type == "FRONT"){
             if(has_tire!="mbno"){ // HAS TIRE
                 if(rim_size.includes('17')){
                     selectedvariant = 45907904069880;
                 }
             }else{ // NO TIRE
                 if(rim_size.includes('17')){
                     selectedvariant = 45907903480056;
                 }
             }
         }else{
             if(has_tire!="mbno"){ // HAS TIRE
                 if(rim_size.includes('17')){
                     selectedvariant = 45907904659704;
                 }
             }else{ // NO TIRE
                 if(rim_size.includes('17')){
                     selectedvariant = 45907903807736;
                 }
             }
         }     
 
       var formData = collectFormData();
       if($('#wheel_type').val() == "FRONT"){
         formData = formData.filter(function(item) {
             return item.name !== "Sprocket Bolts" && item.name !== "Sprocket Size";
         }); 
     }else{
         formData = formData.filter(function(item) {
             return item.name !== "Brake Rotor";
         }); 
     }
         var properties = {};
         formData.forEach(function(field) {
             properties[field.name] = field.value;
         });
     
         properties['__extraPricing'] = totalpersonalizeitem;
 
         let newObject = {
             product: title,
             __parentVariant: selectedvariant
         };
 
        let wbproperties = { ...newObject, ...properties };
 
      //    var requestData = {
                     // items: [
                     // 	{
                     // 		quantity: totalpersonalizeitem, // Adjust the quantity as needed
                     // 		id: 44252901507320, // Use your actual product ID\
                     // 		properties: wbproperties
                     // 	},
                     // 	{
                     // 		quantity: 1, // Adjust the quantity as needed
                     // 		id: selectedvariant, // Use your actual product ID
                     // 		properties: properties
                     // 	}                
                     // ]
      //    };
     properties['__price'] = new_base_price;
     
     var requestData = {
                     items: [
                         {
                             quantity: 1, // Adjust the quantity as needed
                             id: selectedvariant, // Use your actual product ID
                             properties: properties
                         }                
                     ]
         };
 
     // Updating Model
     const bikeModelSelect = document.getElementById("bike_model");
     const selectedModelText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;
 
     requestData.items[0].properties["Bike Model"] = selectedModelText;
 
     $.ajax({
         url: "/cart/add.js",
         type: "POST",
         data: JSON.stringify(requestData),
         contentType: "application/json",
         dataType: 'json',
         success: function(response) {
             // //// console.log("Item added to the cart successfully.", response);
             window.location.href = "/cart";
         },
         error: function(xhr, status, error) {
             //// console.log("Error adding item to the cart.", status, error);
         }
     });
   });
 
 
   $('.product.product-page').addClass('init');
 
 });
 //base prices updated


 function roundUpIfEndsWith95(price) {
  return Math.ceil(price);
}
